(function () {

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";
var parcelRequire = $parcel$global["parcelRequire04f6"];
var parcelRegister = parcelRequire.register;
parcelRegister("cyXq8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $9256c0b3940e96e7$var$_IntlTelInput = $9256c0b3940e96e7$var$_interopRequireDefault((parcelRequire("eBHwa")));
function $9256c0b3940e96e7$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $9256c0b3940e96e7$var$_default = $9256c0b3940e96e7$var$_IntlTelInput.default;
module.exports.default = $9256c0b3940e96e7$var$_default;

});
parcelRegister("eBHwa", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $aa2647233349421c$var$_react = $aa2647233349421c$var$_interopRequireWildcard((parcelRequire("1Mpn7")));

var $aa2647233349421c$var$_classnames = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("eQDD4")));

var $aa2647233349421c$var$_underscore = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("hVsvH")));

var $aa2647233349421c$var$_AllCountries = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("liJs6")));

var $aa2647233349421c$var$_FlagDropDown = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("cwexE")));

var $aa2647233349421c$var$_TelInput = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("gGWR9")));

var $aa2647233349421c$var$_utils = $aa2647233349421c$var$_interopRequireDefault((parcelRequire("kH4y4")));

var $6Wpqq = parcelRequire("6Wpqq");
function $aa2647233349421c$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $aa2647233349421c$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $aa2647233349421c$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $aa2647233349421c$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $aa2647233349421c$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $aa2647233349421c$var$_typeof(obj);
}
function $aa2647233349421c$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $aa2647233349421c$var$_possibleConstructorReturn(self, call) {
    if (call && ($aa2647233349421c$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $aa2647233349421c$var$_assertThisInitialized(self);
}
function $aa2647233349421c$var$_getPrototypeOf(o) {
    $aa2647233349421c$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $aa2647233349421c$var$_getPrototypeOf(o);
}
function $aa2647233349421c$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $aa2647233349421c$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $aa2647233349421c$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $aa2647233349421c$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $aa2647233349421c$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $aa2647233349421c$var$_setPrototypeOf(subClass, superClass);
}
function $aa2647233349421c$var$_setPrototypeOf(o, p) {
    $aa2647233349421c$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $aa2647233349421c$var$_setPrototypeOf(o, p);
}
function $aa2647233349421c$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $aa2647233349421c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $aa2647233349421c$var$mobileUserAgentRegexp = /Android.+Mobile|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;

var $aa2647233349421c$var$IntlTelInput = function(_Component) {
    $aa2647233349421c$var$_inherits(IntlTelInput, _Component);
    $aa2647233349421c$var$_createClass(IntlTelInput, null, [
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(nextProps, prevState) {
                var newState = null;
                if (typeof nextProps.value !== 'undefined' && prevState.value !== nextProps.value) newState = {
                    value: nextProps.value
                };
                if (prevState.disabled !== nextProps.disabled) newState = {
                    disabled: nextProps.disabled
                };
                return newState;
            }
        }
    ]);
    function IntlTelInput(_props) {
        var _this;
        $aa2647233349421c$var$_classCallCheck(this, IntlTelInput);
        _this = $aa2647233349421c$var$_possibleConstructorReturn(this, $aa2647233349421c$var$_getPrototypeOf(IntlTelInput).call(this, _props));
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "updateFlagOnDefaultCountryChange", function(countryCode) {
            _this.setFlag(countryCode, false);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "getTempCountry", function(countryCode) {
            if (countryCode === 'auto') return 'auto';
            var countryData = $aa2647233349421c$var$_utils.default.getCountryData(_this.countries, countryCode);
            if (!countryData.iso2) {
                if (_this.props.preferredCountries.length > 0) countryData = $aa2647233349421c$var$_utils.default.getCountryData(_this.countries, _this.props.preferredCountries[0]);
                else countryData = $aa2647233349421c$var$_AllCountries.default.getCountries()[0];
            }
            return countryData.iso2;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "setNumber", function(number, preventFormat) {
            _this.updateFlagFromNumber(number);
            _this.updateValFromNumber(number, !preventFormat);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "setFlagDropdownRef", function(ref) {
            _this.flagDropDown = ref;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "setTelRef", function(ref) {
            _this.tel = ref;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "setFlag", function(countryCode, isInit) {
            var prevCountry = _this.selectedCountryData && _this.selectedCountryData.iso2 ? _this.selectedCountryData : {};
            _this.selectedCountryData = countryCode ? $aa2647233349421c$var$_utils.default.getCountryData(_this.countries, countryCode, false, false, _this.props.noCountryDataHandler) : {};
            if (_this.selectedCountryData.iso2) _this.defaultCountry = _this.selectedCountryData.iso2;
            var title = countryCode ? "".concat(_this.selectedCountryData.name, ": +").concat(_this.selectedCountryData.dialCode) : 'Unknown';
            var dialCode = _this.state.dialCode;
            if (_this.props.separateDialCode) {
                dialCode = _this.selectedCountryData.dialCode ? "+".concat(_this.selectedCountryData.dialCode) : '';
                if (prevCountry.dialCode) delete _this.wrapperClass["iti-sdc-".concat(prevCountry.dialCode.length + 1)];
                if (dialCode) _this.wrapperClass["iti-sdc-".concat(dialCode.length)] = true;
            }
            var selectedIndex = 0;
            if (countryCode && countryCode !== 'auto') {
                selectedIndex = $aa2647233349421c$var$_utils.default.findIndex(_this.preferredCountries, function(country) {
                    return country.iso2 === countryCode;
                });
                if (selectedIndex === -1) {
                    selectedIndex = $aa2647233349421c$var$_utils.default.findIndex(_this.countries, function(country) {
                        return country.iso2 === countryCode;
                    });
                    if (selectedIndex === -1) selectedIndex = 0;
                    selectedIndex += _this.preferredCountries.length;
                }
            }
            if (_this.tel && _this.state.showDropdown) _this.tel.focus();
            var newNumber = _this.updateDialCode(_this.selectedCountryData.dialCode, !isInit);
            _this.setState({
                value: newNumber,
                showDropdown: false,
                highlightedCountry: selectedIndex,
                countryCode: countryCode,
                title: title,
                dialCode: dialCode
            }, function() {
                _this.updatePlaceholder(_this.props);
                _this.wrapperClass.active = false;
                if (!isInit && prevCountry.iso2 !== countryCode && typeof _this.props.onSelectFlag === 'function') {
                    var currentNumber = _this.state.value;
                    var fullNumber = _this.formatFullNumber(currentNumber);
                    var isValid = _this.isValidNumber(fullNumber);
                    _this.props.onSelectFlag(currentNumber, _this.selectedCountryData, fullNumber, isValid);
                }
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "getExtension", function(number) {
            if (window.intlTelInputUtils) return window.intlTelInputUtils.getExtension(_this.getFullNumber(number), _this.selectedCountryData.iso2);
            return '';
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "getNumber", function(number, format) {
            if (window.intlTelInputUtils) return window.intlTelInputUtils.formatNumber(_this.getFullNumber(number), _this.selectedCountryData.iso2, format);
            return '';
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "getFullNumber", function(number) {
            var prefix = _this.props.separateDialCode ? "+".concat(_this.selectedCountryData.dialCode) : '';
            return prefix + number;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "getDialCode", function(number) {
            var dialCode = '';
            if (number.charAt(0) === '+') {
                var numericChars = '';
                for(var i = 0, max = number.length; i < max; i++){
                    var c = number.charAt(i);
                    if ($aa2647233349421c$var$_utils.default.isNumeric(c)) {
                        numericChars += c;
                        if (_this.countryCodes[numericChars]) dialCode = number.substr(0, i + 1);
                        if (numericChars.length === 4) break;
                    }
                }
            }
            return dialCode;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "isUnknownNanp", function(number, dialCode) {
            return dialCode === '+1' && $aa2647233349421c$var$_utils.default.getNumeric(number).length >= 4;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "addCountryCode", function(countryCodes, iso2, dialCode, priority) {
            if (!(dialCode in countryCodes)) countryCodes[dialCode] = [];
            var index = priority || 0;
            countryCodes[dialCode][index] = iso2;
            return countryCodes;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "processAllCountries", function() {
            if (_this.props.onlyCountries.length) _this.filterCountries(_this.props.onlyCountries, function(inArray) {
                return inArray !== -1;
            });
            else if (_this.props.excludeCountries.length) _this.filterCountries(_this.props.excludeCountries, function(inArray) {
                return inArray === -1;
            });
            else _this.countries = $aa2647233349421c$var$_AllCountries.default.getCountries();
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "processCountryCodes", function() {
            _this.countryCodes = {};
            for(var i = 0; i < _this.countries.length; i++){
                var c = _this.countries[i];
                _this.addCountryCode(_this.countryCodes, c.iso2, c.dialCode, c.priority);
                if (c.areaCodes) for(var j = 0; j < c.areaCodes.length; j++)_this.addCountryCode(_this.countryCodes, c.iso2, c.dialCode + c.areaCodes[j]);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "processPreferredCountries", function() {
            _this.preferredCountries = [];
            for(var i = 0, max = _this.props.preferredCountries.length; i < max; i++){
                var countryCode = _this.props.preferredCountries[i].toLowerCase();
                var countryData = $aa2647233349421c$var$_utils.default.getCountryData(_this.countries, countryCode, true);
                if (countryData) _this.preferredCountries.push(countryData);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "setInitialState", function() {
            var val = _this.props.value || _this.props.defaultValue || '';
            if (_this.getDialCode(val)) _this.updateFlagFromNumber(val, true);
            else if (_this.tempCountry !== 'auto') {
                if (_this.tempCountry) _this.setFlag(_this.tempCountry, true);
                else {
                    _this.defaultCountry = _this.preferredCountries.length ? _this.preferredCountries[0].iso2 : _this.countries[0].iso2;
                    if (!val) _this.setFlag(_this.defaultCountry, true);
                }
                if (!val && !_this.nationalMode && !_this.autoHideDialCode && !_this.props.separateDialCode) _this.setState({
                    value: "+".concat(_this.selectedCountryData.dialCode)
                });
            }
            var doNotify = true;
            if (val) _this.updateValFromNumber(val, _this.props.formatOnInit, doNotify);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "initRequests", function() {
            (parcelRequire("h3Gbx")).then(function() {
                _this.loadUtils();
                _this.utilsScriptDeferred.resolve();
            }).catch(function() {
                return 'An error occurred while loading the component';
            });
            if (_this.tempCountry === 'auto') _this.loadAutoCountry();
            else _this.autoCountryDeferred.resolve();
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "loadCountryFromLocalStorage", function() {
            try {
                return window.localStorage !== undefined ? window.localStorage.getItem('itiAutoCountry') : '';
            } catch (e) {
                return '';
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "loadAutoCountry", function() {
            var lsAutoCountry = _this.loadCountryFromLocalStorage();
            if (lsAutoCountry) _this.autoCountry = lsAutoCountry;
            if (_this.autoCountry) _this.autoCountryLoaded();
            else if (!_this.startedLoadingAutoCountry) {
                _this.startedLoadingAutoCountry = true;
                if (typeof _this.props.geoIpLookup === 'function') _this.props.geoIpLookup(function(countryCode) {
                    _this.autoCountry = countryCode.toLowerCase();
                    if (window.localStorage !== undefined) window.localStorage.setItem('itiAutoCountry', _this.autoCountry);
                    _this.autoCountryLoaded();
                });
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "cap", function(number) {
            var max = _this.tel ? _this.tel.getAttribute('maxlength') : number;
            return max && number.length > max ? number.substr(0, max) : number;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "removeEmptyDialCode", function() {
            var value = _this.state.value;
            var startsPlus = value.charAt(0) === '+';
            if (startsPlus) {
                var numeric = $aa2647233349421c$var$_utils.default.getNumeric(value);
                if (!numeric || _this.selectedCountryData.dialCode === numeric) _this.setState({
                    value: ''
                });
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleUpDownKey", function(key) {
            var current = _this.flagDropDown.querySelectorAll('.highlight')[0];
            var prevElement = current ? current.previousElementSibling : undefined;
            var nextElement = current ? current.nextElementSibling : undefined;
            var next = key === $6Wpqq.KEYS.UP ? prevElement : nextElement;
            if (next) {
                if (next.getAttribute('class').indexOf('divider') > -1) next = key === $6Wpqq.KEYS.UP ? next.previousElementSibling : next.nextElementSibling;
                _this.scrollTo(next);
                var selectedIndex = $aa2647233349421c$var$_utils.default.retrieveLiIndex(next);
                _this.setState({
                    showDropdown: true,
                    highlightedCountry: selectedIndex
                });
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleEnterKey", function() {
            var current = _this.flagDropDown.querySelectorAll('.highlight')[0];
            if (current) {
                var selectedIndex = $aa2647233349421c$var$_utils.default.retrieveLiIndex(current);
                var countryCode = current.getAttribute('data-country-code');
                _this.setState({
                    showDropdown: false,
                    highlightedCountry: selectedIndex,
                    countryCode: countryCode
                }, function() {
                    _this.setFlag(_this.state.countryCode);
                    _this.unbindDocumentClick();
                });
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "searchForCountry", function(query) {
            for(var i = 0, max = _this.countries.length; i < max; i++)if ($aa2647233349421c$var$_utils.default.startsWith(_this.countries[i].name, query)) {
                var listItem = _this.flagDropDown.querySelector(".country-list [data-country-code=\"".concat(_this.countries[i].iso2, "\"]:not(.preferred)"));
                var selectedIndex = $aa2647233349421c$var$_utils.default.retrieveLiIndex(listItem);
                _this.setState({
                    showDropdown: true,
                    highlightedCountry: selectedIndex
                });
                _this.scrollTo(listItem, true);
                break;
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "formatNumber", function(number) {
            if (window.intlTelInputUtils && _this.selectedCountryData) {
                var format = window.intlTelInputUtils.numberFormat.INTERNATIONAL;
                if (!_this.props.separateDialCode && _this.nationalMode || number.charAt(0) !== '+') format = window.intlTelInputUtils.numberFormat.NATIONAL;
                number = window.intlTelInputUtils.formatNumber(number, _this.selectedCountryData.iso2, format);
            }
            return number;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "updateValFromNumber", function(number, doFormat) {
            var doNotify = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
            if (doFormat && window.intlTelInputUtils && _this.selectedCountryData) {
                var format = !_this.props.separateDialCode && (_this.nationalMode || number.charAt(0) !== '+') ? window.intlTelInputUtils.numberFormat.NATIONAL : window.intlTelInputUtils.numberFormat.INTERNATIONAL;
                number = window.intlTelInputUtils.formatNumber(number, _this.selectedCountryData.iso2, format);
            }
            number = _this.beforeSetNumber(number);
            _this.setState({
                showDropdown: false,
                value: number
            }, function() {
                if (doNotify) _this.notifyPhoneNumberChange(number);
                _this.unbindDocumentClick();
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "updateFlagFromNumber", function(number, isInit) {
            if (number && _this.nationalMode && _this.selectedCountryData && _this.selectedCountryData.dialCode === '1' && number.charAt(0) !== '+') {
                if (number.charAt(0) !== '1') number = "1".concat(number);
                number = "+".concat(number);
            }
            var dialCode = _this.getDialCode(number);
            var countryCode = null;
            if (dialCode) {
                var countryCodes = _this.countryCodes[$aa2647233349421c$var$_utils.default.getNumeric(dialCode)];
                var alreadySelected = _this.selectedCountryData && countryCodes.indexOf(_this.selectedCountryData.iso2) !== -1;
                if (!alreadySelected || _this.isUnknownNanp(number, dialCode)) {
                    for(var j = 0; j < countryCodes.length; j++)if (countryCodes[j]) {
                        countryCode = countryCodes[j];
                        break;
                    }
                }
            } else if (number.charAt(0) === '+' && $aa2647233349421c$var$_utils.default.getNumeric(number).length) countryCode = null;
            if (countryCode !== null) _this.setFlag(countryCode, isInit);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "filterCountries", function(countryArray, processFunc) {
            var i;
            for(i = 0; i < countryArray.length; i++)countryArray[i] = countryArray[i].toLowerCase();
            _this.countries = [];
            for(i = 0; i < $aa2647233349421c$var$_AllCountries.default.getCountries().length; i++)if (processFunc(countryArray.indexOf($aa2647233349421c$var$_AllCountries.default.getCountries()[i].iso2))) _this.countries.push($aa2647233349421c$var$_AllCountries.default.getCountries()[i]);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "processCountryData", function() {
            $aa2647233349421c$var$_AllCountries.default.initialize(_this.props.countriesData);
            _this.processAllCountries.call($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)));
            _this.processCountryCodes.call($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)));
            _this.processPreferredCountries.call($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)));
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleOnBlur", function(e) {
            _this.removeEmptyDialCode();
            if (typeof _this.props.onPhoneNumberBlur === 'function') {
                var value = _this.state.value;
                var fullNumber = _this.formatFullNumber(value);
                var isValid = _this.isValidNumber(fullNumber);
                _this.props.onPhoneNumberBlur(isValid, value, _this.selectedCountryData, fullNumber, _this.getExtension(value), e);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleOnFocus", function(e) {
            if (typeof _this.props.onPhoneNumberFocus === 'function') {
                var value = _this.state.value;
                var fullNumber = _this.formatFullNumber(value);
                var isValid = _this.isValidNumber(fullNumber);
                _this.props.onPhoneNumberFocus(isValid, value, _this.selectedCountryData, fullNumber, _this.getExtension(value), e);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "bindDocumentClick", function() {
            _this.isOpening = true;
            document.querySelector('html').addEventListener('click', _this.handleDocumentClick);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "unbindDocumentClick", function() {
            document.querySelector('html').removeEventListener('click', _this.handleDocumentClick);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "clickSelectedFlag", function(e) {
            var _this$props = _this.props, allowDropdown = _this$props.allowDropdown, onFlagClick = _this$props.onFlagClick;
            var _this$state = _this.state, showDropdown = _this$state.showDropdown, disabled = _this$state.disabled, readonly = _this$state.readonly;
            if (!showDropdown && !disabled && !readonly && allowDropdown) _this.setState({
                showDropdown: true,
                offsetTop: $aa2647233349421c$var$_utils.default.offset(_this.tel).top,
                outerHeight: $aa2647233349421c$var$_utils.default.getOuterHeight(_this.tel)
            }, function() {
                var highlightItem = _this.flagDropDown.querySelector('.highlight');
                if (highlightItem) _this.scrollTo(highlightItem, true);
            });
            else if (showDropdown) _this.toggleDropdown(false);
            if (typeof onFlagClick === 'function') onFlagClick(e);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "updatePlaceholder", function() {
            var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.props;
            if (window.intlTelInputUtils && props.autoPlaceholder && _this.selectedCountryData) {
                var numberType = window.intlTelInputUtils.numberType[props.numberType];
                var placeholder = _this.selectedCountryData.iso2 ? window.intlTelInputUtils.getExampleNumber(_this.selectedCountryData.iso2, _this.nationalMode, numberType) : '';
                placeholder = _this.beforeSetNumber(placeholder, props);
                if (typeof props.customPlaceholder === 'function') placeholder = props.customPlaceholder(placeholder, _this.selectedCountryData);
                _this.setState({
                    placeholder: placeholder
                });
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "toggleDropdown", function(status) {
            _this.setState({
                showDropdown: !!status
            }, function() {
                if (!_this.state.showDropdown) _this.unbindDocumentClick();
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "scrollTo", function(element, middle) {
            try {
                var container = _this.flagDropDown.querySelector('.country-list');
                var containerHeight = parseFloat(window.getComputedStyle(container).getPropertyValue('height'));
                var containerTop = $aa2647233349421c$var$_utils.default.offset(container).top;
                var containerBottom = containerTop + containerHeight;
                var elementHeight = $aa2647233349421c$var$_utils.default.getOuterHeight(element);
                var elementTop = $aa2647233349421c$var$_utils.default.offset(element).top;
                var elementBottom = elementTop + elementHeight;
                var middleOffset = containerHeight / 2 - elementHeight / 2;
                var newScrollTop = elementTop - containerTop + container.scrollTop;
                if (elementTop < containerTop) {
                    if (middle) newScrollTop -= middleOffset;
                    container.scrollTop = newScrollTop;
                } else if (elementBottom > containerBottom) {
                    if (middle) newScrollTop += middleOffset;
                    var heightDifference = containerHeight - elementHeight;
                    container.scrollTop = newScrollTop - heightDifference;
                }
            } catch (err) {}
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "updateDialCode", function(newDialCode, hasSelectedListItem) {
            var currentNumber = _this.state.value;
            if (!newDialCode) return currentNumber;
            var newNumber = currentNumber;
            newDialCode = "+".concat(newDialCode);
            if (currentNumber.charAt(0) === '+') {
                var prevDialCode = _this.getDialCode(currentNumber);
                if (prevDialCode) newNumber = currentNumber.replace(prevDialCode, newDialCode);
                else newNumber = newDialCode;
            } else if (_this.nationalMode || _this.props.separateDialCode) ;
            else if (currentNumber) newNumber = newDialCode + currentNumber;
            else if (hasSelectedListItem || !_this.autoHideDialCode) newNumber = newDialCode;
            if (newNumber !== currentNumber) _this.notifyPhoneNumberChange(newNumber);
            return newNumber;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "generateMarkup", function() {
            _this.wrapperClass['separate-dial-code'] = _this.props.separateDialCode;
            if (_this.isMobile && _this.props.useMobileFullscreenDropdown) {
                document.querySelector('body').classList.add('iti-mobile');
                _this.dropdownContainer = 'body';
                window.addEventListener('scroll', _this.handleWindowScroll);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleSelectedFlagKeydown", function(e) {
            if (!_this.state.showDropdown && (e.which === $6Wpqq.KEYS.UP || e.which === $6Wpqq.KEYS.DOWN || e.which === $6Wpqq.KEYS.SPACE || e.which === $6Wpqq.KEYS.ENTER)) {
                e.preventDefault();
                e.stopPropagation();
                _this.toggleDropdown(true);
            }
            if (e.which === $6Wpqq.KEYS.TAB) _this.toggleDropdown(false);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "isValidNumber", function(number) {
            var val = $aa2647233349421c$var$_utils.default.trim(number);
            var countryCode = _this.nationalMode || _this.props.separateDialCode ? _this.selectedCountryData.iso2 : '';
            if (window.intlTelInputUtils) return window.intlTelInputUtils.isValidNumber(val, countryCode);
            return false;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "formatFullNumber", function(number) {
            return window.intlTelInputUtils ? _this.getNumber(number, window.intlTelInputUtils.numberFormat.INTERNATIONAL) : number;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "notifyPhoneNumberChange", function(newNumber) {
            if (typeof _this.props.onPhoneNumberChange === 'function') {
                var fullNumber = _this.formatFullNumber(newNumber);
                var isValid = _this.isValidNumber(fullNumber);
                _this.props.onPhoneNumberChange(isValid, newNumber, _this.selectedCountryData, fullNumber, _this.getExtension(newNumber));
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "beforeSetNumber", function(number) {
            var props = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _this.props;
            if (props.separateDialCode) {
                var dialCode = _this.getDialCode(number);
                if (dialCode) {
                    if (_this.selectedCountryData.areaCodes !== null) dialCode = "+".concat(_this.selectedCountryData.dialCode);
                    var start = number[dialCode.length] === ' ' || number[dialCode.length] === '-' ? dialCode.length + 1 : dialCode.length;
                    number = number.substr(start);
                }
            }
            return _this.cap(number);
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleWindowScroll", function() {
            _this.setState({
                showDropdown: false
            }, function() {
                window.removeEventListener('scroll', _this.handleWindowScroll);
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleDocumentKeyDown", function(e) {
            var queryTimer;
            e.preventDefault();
            if (e.which === $6Wpqq.KEYS.UP || e.which === $6Wpqq.KEYS.DOWN) _this.handleUpDownKey(e.which);
            else if (e.which === $6Wpqq.KEYS.ENTER) _this.handleEnterKey();
            else if (e.which === $6Wpqq.KEYS.ESC) _this.setState({
                showDropdown: false
            });
            else if (e.which >= $6Wpqq.KEYS.A && e.which <= $6Wpqq.KEYS.Z || e.which === $6Wpqq.KEYS.SPACE) {
                if (queryTimer) clearTimeout(queryTimer);
                if (!_this.query) _this.query = '';
                _this.query += String.fromCharCode(e.which);
                _this.searchForCountry(_this.query);
                queryTimer = setTimeout(function() {
                    _this.query = '';
                }, 1000);
            }
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleDocumentClick", function(e) {
            var targetClass = e.target.getAttribute('class');
            if (targetClass === null || targetClass && targetClass.indexOf('country') === -1 && targetClass.indexOf('selected-flag') === -1 && targetClass.indexOf('iti-flag') === -1 && targetClass.indexOf('iti-arrow') === -1) _this.isOpening = false;
            if (!_this.isOpening) _this.toggleDropdown(false);
            _this.isOpening = false;
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "handleInputChange", function(e) {
            var cursorPosition = e.target.selectionStart;
            var previousValue = e.target.value;
            var priorValue = _this.state.value;
            var previousStringBeforeCursor = previousValue === '' ? previousValue : previousValue.substring(0, cursorPosition);
            var formattedValue = previousValue.length < priorValue.length ? previousValue : _this.formatNumber(e.target.value);
            var value = _this.props.format ? formattedValue : e.target.value;
            cursorPosition = $aa2647233349421c$var$_utils.default.getCursorPositionAfterFormating(previousStringBeforeCursor, previousValue, value);
            if (_this.props.value !== undefined) _this.setState({
                cursorPosition: cursorPosition
            }, function() {
                _this.updateFlagFromNumber(value);
                _this.notifyPhoneNumberChange(value);
            });
            else _this.setState({
                value: value,
                cursorPosition: cursorPosition
            }, function() {
                _this.updateFlagFromNumber(value);
                _this.notifyPhoneNumberChange(value);
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "changeHighlightCountry", function(showDropdown, selectedIndex) {
            _this.setState({
                showDropdown: showDropdown,
                highlightedCountry: selectedIndex
            });
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "loadUtils", function() {
            if (window.intlTelInputUtils) _this.utilsScriptDeferred.resolve();
        });
        $aa2647233349421c$var$_defineProperty($aa2647233349421c$var$_assertThisInitialized($aa2647233349421c$var$_assertThisInitialized(_this)), "autoCountryLoaded", function() {
            if (_this.tempCountry === 'auto') {
                _this.tempCountry = _this.autoCountry;
                _this.autoCountryDeferred.resolve();
            }
        });
        _this.wrapperClass = {};
        _this.autoCountry = '';
        _this.tempCountry = '';
        _this.startedLoadingAutoCountry = false;
        _this.deferreds = [];
        _this.autoCountryDeferred = new $aa2647233349421c$var$_underscore.default.Deferred();
        _this.utilsScriptDeferred = new $aa2647233349421c$var$_underscore.default.Deferred();
        _this.isOpening = false;
        _this.isMobile = typeof navigator !== 'undefined' && $aa2647233349421c$var$mobileUserAgentRegexp.test(navigator.userAgent);
        _this.preferredCountries = [];
        _this.countries = [];
        _this.countryCodes = {};
        _this.windowLoaded = false;
        _this.query = '';
        _this.selectedCountryData = {};
        _this.state = {
            showDropdown: false,
            highlightedCountry: 0,
            value: _props.value || _props.defaultValue,
            disabled: _props.disabled,
            readonly: false,
            offsetTop: 0,
            outerHeight: 0,
            placeholder: '',
            title: '',
            countryCode: 'us',
            dialCode: '',
            cursorPosition: (_props.value || _props.defaultValue).length
        };
        return _this;
    }
    $aa2647233349421c$var$_createClass(IntlTelInput, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var _this2 = this;
                this.autoHideDialCode = this.props.autoHideDialCode;
                this.allowDropdown = this.props.allowDropdown;
                this.nationalMode = this.props.nationalMode;
                this.dropdownContainer = '';
                if (this.nationalMode) this.autoHideDialCode = false;
                if (this.props.separateDialCode) {
                    this.autoHideDialCode = false;
                    this.nationalMode = false;
                    this.allowDropdown = true;
                }
                this.processCountryData.call(this);
                this.tempCountry = this.getTempCountry(this.props.defaultCountry);
                if (document.readyState === 'complete') this.windowLoaded = true;
                else window.addEventListener('load', function() {
                    _this2.windowLoaded = true;
                });
                this.generateMarkup();
                this.setInitialState();
                this.initRequests();
                this.deferreds.push(this.autoCountryDeferred.promise());
                this.deferreds.push(this.utilsScriptDeferred.promise());
                $aa2647233349421c$var$_underscore.default.when(this.deferreds).done(function() {
                    _this2.setInitialState();
                });
                document.addEventListener('keydown', this.handleDocumentKeyDown);
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps, nextState) {
                if (nextState.showDropdown) {
                    document.addEventListener('keydown', this.handleDocumentKeyDown);
                    this.bindDocumentClick();
                } else {
                    document.removeEventListener('keydown', this.handleDocumentKeyDown);
                    this.unbindDocumentClick();
                }
                return true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate(prevProps) {
                if (this.props.value !== prevProps.value) this.updateFlagFromNumber(this.props.value);
                if (typeof this.props.customPlaceholder === 'function' && prevProps.customPlaceholder !== this.props.customPlaceholder) this.updatePlaceholder(this.props);
                if (this.props.allowDropdown !== prevProps.allowDropdown) this.allowDropdown = this.props.allowDropdown;
                if (this.props.defaultCountry !== prevProps.defaultCountry) this.updateFlagOnDefaultCountryChange(this.props.defaultCountry);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener('keydown', this.handleDocumentKeyDown);
                window.removeEventListener('scroll', this.handleWindowScroll);
                this.unbindDocumentClick();
            }
        },
        {
            key: "render",
            value: function render() {
                var inputClass = this.props.inputClassName;
                var wrapperStyle = Object.assign({}, this.props.style || {});
                this.wrapperClass['allow-dropdown'] = this.allowDropdown;
                this.wrapperClass.expanded = this.state.showDropdown;
                var wrapperClass = (0, $aa2647233349421c$var$_classnames.default)(this.wrapperClass, this.props.containerClassName);
                var titleTip = this.selectedCountryData ? "".concat(this.selectedCountryData.name, ": +").concat(this.selectedCountryData.dialCode) : 'Unknown';
                var value = this.props.value !== undefined ? this.props.value : this.state.value;
                return $aa2647233349421c$var$_react.default.createElement("div", {
                    className: wrapperClass,
                    style: wrapperStyle
                }, $aa2647233349421c$var$_react.default.createElement($aa2647233349421c$var$_FlagDropDown.default, {
                    refCallback: this.setFlagDropdownRef,
                    allowDropdown: this.allowDropdown,
                    dropdownContainer: this.dropdownContainer,
                    separateDialCode: this.props.separateDialCode,
                    dialCode: this.state.dialCode,
                    clickSelectedFlag: this.clickSelectedFlag,
                    setFlag: this.setFlag,
                    countryCode: this.state.countryCode,
                    isMobile: this.isMobile,
                    handleSelectedFlagKeydown: this.handleSelectedFlagKeydown,
                    changeHighlightCountry: this.changeHighlightCountry,
                    countries: this.countries,
                    showDropdown: this.state.showDropdown,
                    inputTop: this.state.offsetTop,
                    inputOuterHeight: this.state.outerHeight,
                    preferredCountries: this.preferredCountries,
                    highlightedCountry: this.state.highlightedCountry,
                    titleTip: titleTip
                }), $aa2647233349421c$var$_react.default.createElement($aa2647233349421c$var$_TelInput.default, {
                    refCallback: this.setTelRef,
                    handleInputChange: this.handleInputChange,
                    handleOnBlur: this.handleOnBlur,
                    handleOnFocus: this.handleOnFocus,
                    className: inputClass,
                    disabled: this.state.disabled,
                    readonly: this.state.readonly,
                    fieldName: this.props.fieldName,
                    fieldId: this.props.fieldId,
                    value: value,
                    placeholder: this.props.placeholder !== undefined ? this.props.placeholder : this.state.placeholder,
                    autoFocus: this.props.autoFocus,
                    autoComplete: this.props.autoComplete,
                    inputProps: this.props.telInputProps,
                    cursorPosition: this.state.cursorPosition
                }));
            }
        }
    ]);
    return IntlTelInput;
}($aa2647233349421c$var$_react.Component);
$aa2647233349421c$var$IntlTelInput.defaultProps = {
    containerClassName: 'intl-tel-input',
    inputClassName: '',
    fieldName: '',
    fieldId: '',
    defaultValue: '',
    countriesData: null,
    allowDropdown: true,
    autoHideDialCode: true,
    autoPlaceholder: true,
    customPlaceholder: null,
    excludeCountries: [],
    formatOnInit: true,
    separateDialCode: false,
    defaultCountry: '',
    geoIpLookup: null,
    nationalMode: true,
    numberType: 'MOBILE',
    noCountryDataHandler: null,
    onlyCountries: [],
    preferredCountries: [
        'us',
        'gb'
    ],
    onPhoneNumberChange: null,
    onPhoneNumberBlur: null,
    onPhoneNumberFocus: null,
    onSelectFlag: null,
    disabled: false,
    autoFocus: false,
    useMobileFullscreenDropdown: true,
    autoComplete: 'off',
    telInputProps: {},
    format: false,
    onFlagClick: null
};
var $aa2647233349421c$var$_default = $aa2647233349421c$var$IntlTelInput;
module.exports.default = $aa2647233349421c$var$_default;
$aa2647233349421c$var$IntlTelInput.__docgenInfo = {
    "description": "",
    "methods": [
        {
            "name": "getDerivedStateFromProps",
            "docblock": null,
            "modifiers": [
                "static"
            ],
            "params": [
                {
                    "name": "nextProps",
                    "type": null
                },
                {
                    "name": "prevState",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "updateFlagOnDefaultCountryChange",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countryCode",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "getTempCountry",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countryCode",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "setNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "preventFormat",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "setFlagDropdownRef",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "ref",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "setTelRef",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "ref",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "setFlag",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countryCode",
                    "type": null
                },
                {
                    "name": "isInit",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "getExtension",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "getNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "format",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "getFullNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "getDialCode",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "isUnknownNanp",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "dialCode",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "addCountryCode",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countryCodes",
                    "type": null
                },
                {
                    "name": "iso2",
                    "type": null
                },
                {
                    "name": "dialCode",
                    "type": null
                },
                {
                    "name": "priority",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "processAllCountries",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "processCountryCodes",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "processPreferredCountries",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "setInitialState",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "initRequests",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "loadCountryFromLocalStorage",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "loadAutoCountry",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "cap",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "removeEmptyDialCode",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "handleUpDownKey",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "key",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleEnterKey",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "searchForCountry",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "query",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "formatNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "updateValFromNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "doFormat",
                    "type": null
                },
                {
                    "name": "doNotify",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "updateFlagFromNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "isInit",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "filterCountries",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countryArray",
                    "type": null
                },
                {
                    "name": "processFunc",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "processCountryData",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "handleOnBlur",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleOnFocus",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "bindDocumentClick",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "unbindDocumentClick",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "clickSelectedFlag",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "updatePlaceholder",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "props",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "toggleDropdown",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "status",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "scrollTo",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "element",
                    "type": null
                },
                {
                    "name": "middle",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "updateDialCode",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "newDialCode",
                    "type": null
                },
                {
                    "name": "hasSelectedListItem",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "generateMarkup",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "handleSelectedFlagKeydown",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "isValidNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "formatFullNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "notifyPhoneNumberChange",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "newNumber",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "beforeSetNumber",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "number",
                    "type": null
                },
                {
                    "name": "props",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleWindowScroll",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "handleDocumentKeyDown",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleDocumentClick",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleInputChange",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "changeHighlightCountry",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "showDropdown",
                    "type": null
                },
                {
                    "name": "selectedIndex",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "loadUtils",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "autoCountryLoaded",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        }
    ],
    "displayName": "IntlTelInput",
    "props": {
        "containerClassName": {
            "defaultValue": {
                "value": "'intl-tel-input'",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Container CSS class name."
        },
        "inputClassName": {
            "defaultValue": {
                "value": "''",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Text input CSS class name."
        },
        "fieldName": {
            "defaultValue": {
                "value": "''",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "It's used as `input` field `name` attribute."
        },
        "fieldId": {
            "defaultValue": {
                "value": "''",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "It's used as `input` field `id` attribute."
        },
        "defaultValue": {
            "defaultValue": {
                "value": "''",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "The value used to initialize input. This will only work on uncontrolled component."
        },
        "countriesData": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "array"
                }
            },
            "required": false,
            "description": "Countries data can be configured, it defaults to data defined in `AllCountries`."
        },
        "allowDropdown": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Whether or not to allow the dropdown. If disabled, there is no dropdown arrow, and the selected flag is not clickable.\nAlso we display the selected flag on the right instead because it is just a marker of state."
        },
        "autoHideDialCode": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "If there is just a dial code in the input: remove it on blur, and re-add it on focus."
        },
        "autoPlaceholder": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Add or remove input placeholder with an example number for the selected country."
        },
        "customPlaceholder": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Change the placeholder generated by autoPlaceholder. Must return a string."
        },
        "excludeCountries": {
            "defaultValue": {
                "value": "[]",
                "computed": false
            },
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "string"
                }
            },
            "required": false,
            "description": "Don't display the countries you specify. (Array)"
        },
        "formatOnInit": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Format the input value during initialisation."
        },
        "separateDialCode": {
            "defaultValue": {
                "value": "false",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Display the country dial code next to the selected flag so it's not part of the typed number.\nNote that this will disable nationalMode because technically we are dealing with international numbers,\nbut with the dial code separated."
        },
        "defaultCountry": {
            "defaultValue": {
                "value": "''",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Default country."
        },
        "geoIpLookup": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "GeoIp lookup function."
        },
        "nationalMode": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Don't insert international dial codes."
        },
        "numberType": {
            "defaultValue": {
                "value": "'MOBILE'",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Number type to use for placeholders."
        },
        "noCountryDataHandler": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "The function which can catch the \"no this default country\" exception."
        },
        "onlyCountries": {
            "defaultValue": {
                "value": "[]",
                "computed": false
            },
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "string"
                }
            },
            "required": false,
            "description": "Display only these countries."
        },
        "preferredCountries": {
            "defaultValue": {
                "value": "['us', 'gb']",
                "computed": false
            },
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "string"
                }
            },
            "required": false,
            "description": "The countries at the top of the list. defaults to United States and United Kingdom."
        },
        "onPhoneNumberChange": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Optional validation callback function. It returns validation status, input box value and selected country data."
        },
        "onPhoneNumberBlur": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Optional validation callback function. It returns validation status, input box value and selected country data."
        },
        "onPhoneNumberFocus": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Optional validation callback function. It returns validation status, input box value and selected country data."
        },
        "onSelectFlag": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Allow main app to do things when a country is selected."
        },
        "disabled": {
            "defaultValue": {
                "value": "false",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Disable this component."
        },
        "autoFocus": {
            "defaultValue": {
                "value": "false",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Enable auto focus"
        },
        "useMobileFullscreenDropdown": {
            "defaultValue": {
                "value": "true",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Render fullscreen flag dropdown when mobile useragent is detected. The dropdown element is rendered as a direct child of document.body"
        },
        "autoComplete": {
            "defaultValue": {
                "value": "'off'",
                "computed": false
            },
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Set the value of the autoComplete attribute on the input. For example, set it to phone to tell the browser where to auto complete phone numbers."
        },
        "telInputProps": {
            "defaultValue": {
                "value": "{}",
                "computed": false
            },
            "type": {
                "name": "object"
            },
            "required": false,
            "description": "Pass through arbitrary props to the tel input element."
        },
        "format": {
            "defaultValue": {
                "value": "false",
                "computed": false
            },
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": "Format the number."
        },
        "onFlagClick": {
            "defaultValue": {
                "value": "null",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": "Allow main app to do things when flag icon is clicked."
        },
        "value": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "The value of the input field. Useful for making input value controlled from outside the component."
        },
        "placeholder": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": "Static placeholder for input controller. When defined it takes priority over autoPlaceholder."
        },
        "style": {
            "type": {
                "name": "custom",
                "raw": "StylePropTypes"
            },
            "required": false,
            "description": "Style object for the wrapper div. Useful for setting 100% width on the wrapper, etc."
        }
    }
};

});
parcelRegister("hVsvH", function(module, exports) {
(function(root) {
    // Let's borrow a couple of things from Underscore that we'll need
    // _.each
    var breaker = {}, AP = Array.prototype, OP = Object.prototype, hasOwn = OP.hasOwnProperty, toString = OP.toString, forEach = AP.forEach, indexOf = AP.indexOf, slice = AP.slice;
    var _each = function _each(obj, iterator, context) {
        var key, i, l;
        if (!obj) return;
        if (forEach && obj.forEach === forEach) obj.forEach(iterator, context);
        else if (obj.length === +obj.length) for(i = 0, l = obj.length; i < l; i++){
            if (i in obj && iterator.call(context, obj[i], i, obj) === breaker) return;
        }
        else {
            for(key in obj)if (hasOwn.call(obj, key)) {
                if (iterator.call(context, obj[key], key, obj) === breaker) return;
            }
        }
    };
    // _.isFunction
    var _isFunction = function _isFunction(obj) {
        return !!(obj && obj.constructor && obj.call && obj.apply);
    };
    // _.extend
    var _extend = function _extend(obj) {
        _each(slice.call(arguments, 1), function(source) {
            var prop;
            for(prop in source)if (source[prop] !== void 0) obj[prop] = source[prop];
        });
        return obj;
    };
    // $.inArray
    var _inArray = function _inArray(elem, arr, i) {
        var len;
        if (arr) {
            if (indexOf) return indexOf.call(arr, elem, i);
            len = arr.length;
            i = i ? i < 0 ? Math.max(0, len + i) : i : 0;
            for(; i < len; i++){
                // Skip accessing in sparse arrays
                if (i in arr && arr[i] === elem) return i;
            }
        }
        return -1;
    };
    // And some jQuery specific helpers
    var class2type = {};
    // Populate the class2type map
    _each("Boolean Number String Function Array Date RegExp Object".split(" "), function(name, i) {
        class2type["[object " + name + "]"] = name.toLowerCase();
    });
    var _type = function _type(obj) {
        return obj == null ? String(obj) : class2type[toString.call(obj)] || "object";
    };
    // Now start the jQuery-cum-Underscore implementation. Some very
    // minor changes to the jQuery source to get this working.
    // Internal Deferred namespace
    var _d = {};
    // String to Object options format cache
    var optionsCache = {};
    // Convert String-formatted options into Object-formatted ones and store in cache
    function createOptions(options) {
        var object = optionsCache[options] = {};
        _each(options.split(/\s+/), function(flag) {
            object[flag] = true;
        });
        return object;
    }
    _d.Callbacks = function(options) {
        // Convert options from String-formatted to Object-formatted if needed
        // (we check in cache first)
        options = typeof options === "string" ? optionsCache[options] || createOptions(options) : _extend({}, options);
        var memory, // Flag to know if list was already fired
        fired, // Flag to know if list is currently firing
        firing, // First callback to fire (used internally by add and fireWith)
        firingStart, // End of the loop when firing
        firingLength, // Index of currently firing callback (modified by remove if needed)
        firingIndex, // Actual callback list
        list = [], // Stack of fire calls for repeatable lists
        stack = !options.once && [], // Fire callbacks
        fire = function fire1(data) {
            memory = options.memory && data;
            fired = true;
            firingIndex = firingStart || 0;
            firingStart = 0;
            firingLength = list.length;
            firing = true;
            for(; list && firingIndex < firingLength; firingIndex++)if (list[firingIndex].apply(data[0], data[1]) === false && options.stopOnFalse) {
                memory = false; // To prevent further calls using add
                break;
            }
            firing = false;
            if (list) {
                if (stack) {
                    if (stack.length) fire(stack.shift());
                } else if (memory) list = [];
                else self.disable();
            }
        }, // Actual Callbacks object
        self = {
            // Add a callback or a collection of callbacks to the list
            add: function add() {
                if (list) {
                    // First, we save the current length
                    var start = list.length;
                    (function add(args) {
                        _each(args, function(arg) {
                            var type = _type(arg);
                            if (type === "function") {
                                if (!options.unique || !self.has(arg)) list.push(arg);
                            } else if (arg && arg.length && type !== "string") // Inspect recursively
                            add(arg);
                        });
                    })(arguments);
                    // Do we need to add the callbacks to the
                    // current firing batch?
                    if (firing) firingLength = list.length;
                    else if (memory) {
                        firingStart = start;
                        fire(memory);
                    }
                }
                return this;
            },
            // Remove a callback from the list
            remove: function remove() {
                if (list) _each(arguments, function(arg) {
                    var index;
                    while((index = _inArray(arg, list, index)) > -1){
                        list.splice(index, 1);
                        // Handle firing indexes
                        if (firing) {
                            if (index <= firingLength) firingLength--;
                            if (index <= firingIndex) firingIndex--;
                        }
                    }
                });
                return this;
            },
            // Control if a given callback is in the list
            has: function has(fn) {
                return _inArray(fn, list) > -1;
            },
            // Remove all callbacks from the list
            empty: function empty() {
                list = [];
                return this;
            },
            // Have the list do nothing anymore
            disable: function disable() {
                list = stack = memory = undefined;
                return this;
            },
            // Is it disabled?
            disabled: function disabled() {
                return !list;
            },
            // Lock the list in its current state
            lock: function lock() {
                stack = undefined;
                if (!memory) self.disable();
                return this;
            },
            // Is it locked?
            locked: function locked() {
                return !stack;
            },
            // Call all callbacks with the given context and arguments
            fireWith: function fireWith(context, args) {
                args = args || [];
                args = [
                    context,
                    args.slice ? args.slice() : args
                ];
                if (list && (!fired || stack)) {
                    if (firing) stack.push(args);
                    else fire(args);
                }
                return this;
            },
            // Call all the callbacks with the given arguments
            fire: function fire() {
                self.fireWith(this, arguments);
                return this;
            },
            // To know if the callbacks have already been called at least once
            fired: function fired1() {
                return !!fired;
            }
        };
        return self;
    };
    _d.Deferred = function(func) {
        var tuples = [
            // action, add listener, listener list, final state
            [
                "resolve",
                "done",
                _d.Callbacks("once memory"),
                "resolved"
            ],
            [
                "reject",
                "fail",
                _d.Callbacks("once memory"),
                "rejected"
            ],
            [
                "notify",
                "progress",
                _d.Callbacks("memory")
            ]
        ], state = "pending", promise = {
            state: function state1() {
                return state;
            },
            always: function always() {
                deferred.done(arguments).fail(arguments);
                return this;
            },
            then: function then() {
                var fns = arguments;
                return _d.Deferred(function(newDefer) {
                    _each(tuples, function(tuple, i) {
                        var action = tuple[0], fn = fns[i];
                        // deferred[ done | fail | progress ] for forwarding actions to newDefer
                        deferred[tuple[1]](_isFunction(fn) ? function() {
                            var returned;
                            try {
                                returned = fn.apply(this, arguments);
                            } catch (e) {
                                newDefer.reject(e);
                                return;
                            }
                            if (returned && _isFunction(returned.promise)) returned.promise().done(newDefer.resolve).fail(newDefer.reject).progress(newDefer.notify);
                            else newDefer[action !== "notify" ? 'resolveWith' : action + 'With'](this === deferred ? newDefer : this, [
                                returned
                            ]);
                        } : newDefer[action]);
                    });
                    fns = null;
                }).promise();
            },
            // Get a promise for this deferred
            // If obj is provided, the promise aspect is added to the object
            promise: function promise1(obj) {
                return obj != null ? _extend(obj, promise) : promise;
            }
        }, deferred = {};
        // Keep pipe for back-compat
        promise.pipe = promise.then;
        // Add list-specific methods
        _each(tuples, function(tuple, i) {
            var list = tuple[2], stateString = tuple[3];
            // promise[ done | fail | progress ] = list.add
            promise[tuple[1]] = list.add;
            // Handle state
            if (stateString) list.add(function() {
                // state = [ resolved | rejected ]
                state = stateString;
            // [ reject_list | resolve_list ].disable; progress_list.lock
            }, tuples[i ^ 1][2].disable, tuples[2][2].lock);
            // deferred[ resolve | reject | notify ] = list.fire
            deferred[tuple[0]] = list.fire;
            deferred[tuple[0] + "With"] = list.fireWith;
        });
        // Make the deferred a promise
        promise.promise(deferred);
        // Call given func if any
        if (func) func.call(deferred, deferred);
        // All done!
        return deferred;
    };
    // Deferred helper
    _d.when = function(subordinate /* , ..., subordinateN */ ) {
        var i = 0, resolveValues = _type(subordinate) === 'array' && arguments.length === 1 ? subordinate : slice.call(arguments), length = resolveValues.length, // the count of uncompleted subordinates
        remaining = length !== 1 || subordinate && _isFunction(subordinate.promise) ? length : 0, // the master Deferred. If resolveValues consist of only a single Deferred, just use that.
        deferred = remaining === 1 ? subordinate : _d.Deferred(), // Update function for both resolve and progress values
        updateFunc = function updateFunc(i, contexts, values) {
            return function(value) {
                contexts[i] = this;
                values[i] = arguments.length > 1 ? slice.call(arguments) : value;
                if (values === progressValues) deferred.notifyWith(contexts, values);
                else if (!--remaining) deferred.resolveWith(contexts, values);
            };
        }, progressValues, progressContexts, resolveContexts;
        // add listeners to Deferred subordinates; treat others as resolved
        if (length > 1) {
            progressValues = new Array(length);
            progressContexts = new Array(length);
            resolveContexts = new Array(length);
            for(; i < length; i++)if (resolveValues[i] && _isFunction(resolveValues[i].promise)) resolveValues[i].promise().done(updateFunc(i, resolveContexts, resolveValues)).fail(deferred.reject).progress(updateFunc(i, progressContexts, progressValues));
            else --remaining;
        }
        // if we're not waiting on anything, resolve the master
        if (!remaining) deferred.resolveWith(resolveContexts, resolveValues);
        return deferred.promise();
    };
    // Try exporting as a Common.js Module
    if (module.exports) module.exports = _d;
    else if (typeof root._ !== "undefined") root._.mixin(_d);
    else root._ = _d;
})(module.exports);

});

parcelRegister("liJs6", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;
var $f81e894f2b0e1bc6$var$defaultCountriesData = [
    [
        "Afghanistan (\u202B\u0627\u0641\u063A\u0627\u0646\u0633\u062A\u0627\u0646\u202C\u200E)",
        'af',
        '93'
    ],
    [
        "Albania (Shqip\xebri)",
        'al',
        '355'
    ],
    [
        "Algeria (\u202B\u0627\u0644\u062C\u0632\u0627\u0626\u0631\u202C\u200E)",
        'dz',
        '213'
    ],
    [
        'American Samoa',
        'as',
        '1684'
    ],
    [
        'Andorra',
        'ad',
        '376'
    ],
    [
        'Angola',
        'ao',
        '244'
    ],
    [
        'Anguilla',
        'ai',
        '1264'
    ],
    [
        'Antigua and Barbuda',
        'ag',
        '1268'
    ],
    [
        'Argentina',
        'ar',
        '54'
    ],
    [
        "Armenia (\u0540\u0561\u0575\u0561\u057D\u057F\u0561\u0576)",
        'am',
        '374'
    ],
    [
        'Aruba',
        'aw',
        '297'
    ],
    [
        'Australia',
        'au',
        '61',
        0
    ],
    [
        "Austria (\xd6sterreich)",
        'at',
        '43'
    ],
    [
        "Azerbaijan (Az\u0259rbaycan)",
        'az',
        '994'
    ],
    [
        'Bahamas',
        'bs',
        '1242'
    ],
    [
        "Bahrain (\u202B\u0627\u0644\u0628\u062D\u0631\u064A\u0646\u202C\u200E)",
        'bh',
        '973'
    ],
    [
        "Bangladesh (\u09AC\u09BE\u0982\u09B2\u09BE\u09A6\u09C7\u09B6)",
        'bd',
        '880'
    ],
    [
        'Barbados',
        'bb',
        '1246'
    ],
    [
        "Belarus (\u0411\u0435\u043B\u0430\u0440\u0443\u0441\u044C)",
        'by',
        '375'
    ],
    [
        "Belgium (Belgi\xeb)",
        'be',
        '32'
    ],
    [
        'Belize',
        'bz',
        '501'
    ],
    [
        "Benin (B\xe9nin)",
        'bj',
        '229'
    ],
    [
        'Bermuda',
        'bm',
        '1441'
    ],
    [
        "Bhutan (\u0F60\u0F56\u0FB2\u0F74\u0F42)",
        'bt',
        '975'
    ],
    [
        'Bolivia',
        'bo',
        '591'
    ],
    [
        "Bosnia and Herzegovina (\u0411\u043E\u0441\u043D\u0430 \u0438 \u0425\u0435\u0440\u0446\u0435\u0433\u043E\u0432\u0438\u043D\u0430)",
        'ba',
        '387'
    ],
    [
        'Botswana',
        'bw',
        '267'
    ],
    [
        'Brazil (Brasil)',
        'br',
        '55'
    ],
    [
        'British Indian Ocean Territory',
        'io',
        '246'
    ],
    [
        'British Virgin Islands',
        'vg',
        '1284'
    ],
    [
        'Brunei',
        'bn',
        '673'
    ],
    [
        "Bulgaria (\u0411\u044A\u043B\u0433\u0430\u0440\u0438\u044F)",
        'bg',
        '359'
    ],
    [
        'Burkina Faso',
        'bf',
        '226'
    ],
    [
        'Burundi (Uburundi)',
        'bi',
        '257'
    ],
    [
        "Cambodia (\u1780\u1798\u17D2\u1796\u17BB\u1787\u17B6)",
        'kh',
        '855'
    ],
    [
        'Cameroon (Cameroun)',
        'cm',
        '237'
    ],
    [
        'Canada',
        'ca',
        '1',
        1,
        [
            '204',
            '226',
            '236',
            '249',
            '250',
            '289',
            '306',
            '343',
            '365',
            '367',
            '387',
            '403',
            '416',
            '418',
            '431',
            '437',
            '438',
            '450',
            '506',
            '514',
            '519',
            '548',
            '579',
            '581',
            '587',
            '604',
            '613',
            '639',
            '647',
            '672',
            '705',
            '709',
            '742',
            '778',
            '780',
            '782',
            '807',
            '819',
            '825',
            '867',
            '873',
            '902',
            '905'
        ]
    ],
    [
        'Cape Verde (Kabu Verdi)',
        'cv',
        '238'
    ],
    [
        'Caribbean Netherlands',
        'bq',
        '599',
        1
    ],
    [
        'Cayman Islands',
        'ky',
        '1345'
    ],
    [
        "Central African Republic (R\xe9publique centrafricaine)",
        'cf',
        '236'
    ],
    [
        'Chad (Tchad)',
        'td',
        '235'
    ],
    [
        'Chile',
        'cl',
        '56'
    ],
    [
        "China (\u4E2D\u56FD)",
        'cn',
        '86'
    ],
    [
        'Christmas Island',
        'cx',
        '61',
        2
    ],
    [
        'Cocos (Keeling) Islands',
        'cc',
        '61',
        1
    ],
    [
        'Colombia',
        'co',
        '57'
    ],
    [
        "Comoros (\u202B\u062C\u0632\u0631 \u0627\u0644\u0642\u0645\u0631\u202C\u200E)",
        'km',
        '269'
    ],
    [
        'Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)',
        'cd',
        '243'
    ],
    [
        'Congo (Republic) (Congo-Brazzaville)',
        'cg',
        '242'
    ],
    [
        'Cook Islands',
        'ck',
        '682'
    ],
    [
        'Costa Rica',
        'cr',
        '506'
    ],
    [
        "C\xf4te d\u2019Ivoire",
        'ci',
        '225'
    ],
    [
        'Croatia (Hrvatska)',
        'hr',
        '385'
    ],
    [
        'Cuba',
        'cu',
        '53'
    ],
    [
        "Cura\xe7ao",
        'cw',
        '599',
        0
    ],
    [
        "Cyprus (\u039A\u03CD\u03C0\u03C1\u03BF\u03C2)",
        'cy',
        '357'
    ],
    [
        "Czech Republic (\u010Cesk\xe1 republika)",
        'cz',
        '420'
    ],
    [
        'Denmark (Danmark)',
        'dk',
        '45'
    ],
    [
        'Djibouti',
        'dj',
        '253'
    ],
    [
        'Dominica',
        'dm',
        '1767'
    ],
    [
        "Dominican Republic (Rep\xfablica Dominicana)",
        'do',
        '1',
        2,
        [
            '809',
            '829',
            '849'
        ]
    ],
    [
        'Ecuador',
        'ec',
        '593'
    ],
    [
        "Egypt (\u202B\u0645\u0635\u0631\u202C\u200E)",
        'eg',
        '20'
    ],
    [
        'El Salvador',
        'sv',
        '503'
    ],
    [
        'Equatorial Guinea (Guinea Ecuatorial)',
        'gq',
        '240'
    ],
    [
        'Eritrea',
        'er',
        '291'
    ],
    [
        'Estonia (Eesti)',
        'ee',
        '372'
    ],
    [
        'Ethiopia',
        'et',
        '251'
    ],
    [
        'Falkland Islands (Islas Malvinas)',
        'fk',
        '500'
    ],
    [
        "Faroe Islands (F\xf8royar)",
        'fo',
        '298'
    ],
    [
        'Fiji',
        'fj',
        '679'
    ],
    [
        'Finland (Suomi)',
        'fi',
        '358',
        0
    ],
    [
        'France',
        'fr',
        '33'
    ],
    [
        "French Guiana (Guyane fran\xe7aise)",
        'gf',
        '594'
    ],
    [
        "French Polynesia (Polyn\xe9sie fran\xe7aise)",
        'pf',
        '689'
    ],
    [
        'Gabon',
        'ga',
        '241'
    ],
    [
        'Gambia',
        'gm',
        '220'
    ],
    [
        "Georgia (\u10E1\u10D0\u10E5\u10D0\u10E0\u10D7\u10D5\u10D4\u10DA\u10DD)",
        'ge',
        '995'
    ],
    [
        'Germany (Deutschland)',
        'de',
        '49'
    ],
    [
        'Ghana (Gaana)',
        'gh',
        '233'
    ],
    [
        'Gibraltar',
        'gi',
        '350'
    ],
    [
        "Greece (\u0395\u03BB\u03BB\u03AC\u03B4\u03B1)",
        'gr',
        '30'
    ],
    [
        'Greenland (Kalaallit Nunaat)',
        'gl',
        '299'
    ],
    [
        'Grenada',
        'gd',
        '1473'
    ],
    [
        'Guadeloupe',
        'gp',
        '590',
        0
    ],
    [
        'Guam',
        'gu',
        '1671'
    ],
    [
        'Guatemala',
        'gt',
        '502'
    ],
    [
        'Guernsey',
        'gg',
        '44',
        1
    ],
    [
        "Guinea (Guin\xe9e)",
        'gn',
        '224'
    ],
    [
        "Guinea-Bissau (Guin\xe9 Bissau)",
        'gw',
        '245'
    ],
    [
        'Guyana',
        'gy',
        '592'
    ],
    [
        'Haiti',
        'ht',
        '509'
    ],
    [
        'Honduras',
        'hn',
        '504'
    ],
    [
        "Hong Kong (\u9999\u6E2F)",
        'hk',
        '852'
    ],
    [
        "Hungary (Magyarorsz\xe1g)",
        'hu',
        '36'
    ],
    [
        "Iceland (\xcdsland)",
        'is',
        '354'
    ],
    [
        "India (\u092D\u093E\u0930\u0924)",
        'in',
        '91'
    ],
    [
        'Indonesia',
        'id',
        '62'
    ],
    [
        "Iran (\u202B\u0627\u06CC\u0631\u0627\u0646\u202C\u200E)",
        'ir',
        '98'
    ],
    [
        "Iraq (\u202B\u0627\u0644\u0639\u0631\u0627\u0642\u202C\u200E)",
        'iq',
        '964'
    ],
    [
        'Ireland',
        'ie',
        '353'
    ],
    [
        'Isle of Man',
        'im',
        '44',
        2
    ],
    [
        "Israel (\u202B\u05D9\u05E9\u05E8\u05D0\u05DC\u202C\u200E)",
        'il',
        '972'
    ],
    [
        'Italy (Italia)',
        'it',
        '39',
        0
    ],
    [
        'Jamaica',
        'jm',
        '1876'
    ],
    [
        "Japan (\u65E5\u672C)",
        'jp',
        '81'
    ],
    [
        'Jersey',
        'je',
        '44',
        3
    ],
    [
        "Jordan (\u202B\u0627\u0644\u0623\u0631\u062F\u0646\u202C\u200E)",
        'jo',
        '962'
    ],
    [
        "Kazakhstan (\u041A\u0430\u0437\u0430\u0445\u0441\u0442\u0430\u043D)",
        'kz',
        '7',
        1
    ],
    [
        'Kenya',
        'ke',
        '254'
    ],
    [
        'Kiribati',
        'ki',
        '686'
    ],
    [
        'Kosovo',
        'xk',
        '383'
    ],
    [
        "Kuwait (\u202B\u0627\u0644\u0643\u0648\u064A\u062A\u202C\u200E)",
        'kw',
        '965'
    ],
    [
        "Kyrgyzstan (\u041A\u044B\u0440\u0433\u044B\u0437\u0441\u0442\u0430\u043D)",
        'kg',
        '996'
    ],
    [
        "Laos (\u0EA5\u0EB2\u0EA7)",
        'la',
        '856'
    ],
    [
        'Latvia (Latvija)',
        'lv',
        '371'
    ],
    [
        "Lebanon (\u202B\u0644\u0628\u0646\u0627\u0646\u202C\u200E)",
        'lb',
        '961'
    ],
    [
        'Lesotho',
        'ls',
        '266'
    ],
    [
        'Liberia',
        'lr',
        '231'
    ],
    [
        "Libya (\u202B\u0644\u064A\u0628\u064A\u0627\u202C\u200E)",
        'ly',
        '218'
    ],
    [
        'Liechtenstein',
        'li',
        '423'
    ],
    [
        'Lithuania (Lietuva)',
        'lt',
        '370'
    ],
    [
        'Luxembourg',
        'lu',
        '352'
    ],
    [
        "Macau (\u6FB3\u9580)",
        'mo',
        '853'
    ],
    [
        "Macedonia (FYROM) (\u041C\u0430\u043A\u0435\u0434\u043E\u043D\u0438\u0458\u0430)",
        'mk',
        '389'
    ],
    [
        'Madagascar (Madagasikara)',
        'mg',
        '261'
    ],
    [
        'Malawi',
        'mw',
        '265'
    ],
    [
        'Malaysia',
        'my',
        '60'
    ],
    [
        'Maldives',
        'mv',
        '960'
    ],
    [
        'Mali',
        'ml',
        '223'
    ],
    [
        'Malta',
        'mt',
        '356'
    ],
    [
        'Marshall Islands',
        'mh',
        '692'
    ],
    [
        'Martinique',
        'mq',
        '596'
    ],
    [
        "Mauritania (\u202B\u0645\u0648\u0631\u064A\u062A\u0627\u0646\u064A\u0627\u202C\u200E)",
        'mr',
        '222'
    ],
    [
        'Mauritius (Moris)',
        'mu',
        '230'
    ],
    [
        'Mayotte',
        'yt',
        '262',
        1
    ],
    [
        "Mexico (M\xe9xico)",
        'mx',
        '52'
    ],
    [
        'Micronesia',
        'fm',
        '691'
    ],
    [
        'Moldova (Republica Moldova)',
        'md',
        '373'
    ],
    [
        'Monaco',
        'mc',
        '377'
    ],
    [
        "Mongolia (\u041C\u043E\u043D\u0433\u043E\u043B)",
        'mn',
        '976'
    ],
    [
        'Montenegro (Crna Gora)',
        'me',
        '382'
    ],
    [
        'Montserrat',
        'ms',
        '1664'
    ],
    [
        "Morocco (\u202B\u0627\u0644\u0645\u063A\u0631\u0628\u202C\u200E)",
        'ma',
        '212',
        0
    ],
    [
        "Mozambique (Mo\xe7ambique)",
        'mz',
        '258'
    ],
    [
        "Myanmar (Burma) (\u1019\u103C\u1014\u103A\u1019\u102C)",
        'mm',
        '95'
    ],
    [
        "Namibia (Namibi\xeb)",
        'na',
        '264'
    ],
    [
        'Nauru',
        'nr',
        '674'
    ],
    [
        "Nepal (\u0928\u0947\u092A\u093E\u0932)",
        'np',
        '977'
    ],
    [
        'Netherlands (Nederland)',
        'nl',
        '31'
    ],
    [
        "New Caledonia (Nouvelle-Cal\xe9donie)",
        'nc',
        '687'
    ],
    [
        'New Zealand',
        'nz',
        '64'
    ],
    [
        'Nicaragua',
        'ni',
        '505'
    ],
    [
        'Niger (Nijar)',
        'ne',
        '227'
    ],
    [
        'Nigeria',
        'ng',
        '234'
    ],
    [
        'Niue',
        'nu',
        '683'
    ],
    [
        'Norfolk Island',
        'nf',
        '672'
    ],
    [
        "North Korea (\uC870\uC120 \uBBFC\uC8FC\uC8FC\uC758 \uC778\uBBFC \uACF5\uD654\uAD6D)",
        'kp',
        '850'
    ],
    [
        'Northern Mariana Islands',
        'mp',
        '1670'
    ],
    [
        'Norway (Norge)',
        'no',
        '47',
        0
    ],
    [
        "Oman (\u202B\u0639\u064F\u0645\u0627\u0646\u202C\u200E)",
        'om',
        '968'
    ],
    [
        "Pakistan (\u202B\u067E\u0627\u06A9\u0633\u062A\u0627\u0646\u202C\u200E)",
        'pk',
        '92'
    ],
    [
        'Palau',
        'pw',
        '680'
    ],
    [
        "Palestine (\u202B\u0641\u0644\u0633\u0637\u064A\u0646\u202C\u200E)",
        'ps',
        '970'
    ],
    [
        "Panama (Panam\xe1)",
        'pa',
        '507'
    ],
    [
        'Papua New Guinea',
        'pg',
        '675'
    ],
    [
        'Paraguay',
        'py',
        '595'
    ],
    [
        "Peru (Per\xfa)",
        'pe',
        '51'
    ],
    [
        'Philippines',
        'ph',
        '63'
    ],
    [
        'Poland (Polska)',
        'pl',
        '48'
    ],
    [
        'Portugal',
        'pt',
        '351'
    ],
    [
        'Puerto Rico',
        'pr',
        '1',
        3,
        [
            '787',
            '939'
        ]
    ],
    [
        "Qatar (\u202B\u0642\u0637\u0631\u202C\u200E)",
        'qa',
        '974'
    ],
    [
        "R\xe9union (La R\xe9union)",
        're',
        '262',
        0
    ],
    [
        "Romania (Rom\xe2nia)",
        'ro',
        '40'
    ],
    [
        "Russia (\u0420\u043E\u0441\u0441\u0438\u044F)",
        'ru',
        '7',
        0
    ],
    [
        'Rwanda',
        'rw',
        '250'
    ],
    [
        "Saint Barth\xe9lemy (Saint-Barth\xe9lemy)",
        'bl',
        '590',
        1
    ],
    [
        'Saint Helena',
        'sh',
        '290'
    ],
    [
        'Saint Kitts and Nevis',
        'kn',
        '1869'
    ],
    [
        'Saint Lucia',
        'lc',
        '1758'
    ],
    [
        "Saint Martin (Saint-Martin (partie fran\xe7aise))",
        'mf',
        '590',
        2
    ],
    [
        'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
        'pm',
        '508'
    ],
    [
        'Saint Vincent and the Grenadines',
        'vc',
        '1784'
    ],
    [
        'Samoa',
        'ws',
        '685'
    ],
    [
        'San Marino',
        'sm',
        '378'
    ],
    [
        "S\xe3o Tom\xe9 and Pr\xedncipe (S\xe3o Tom\xe9 e Pr\xedncipe)",
        'st',
        '239'
    ],
    [
        "Saudi Arabia (\u202B\u0627\u0644\u0645\u0645\u0644\u0643\u0629 \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0633\u0639\u0648\u062F\u064A\u0629\u202C\u200E)",
        'sa',
        '966'
    ],
    [
        "Senegal (S\xe9n\xe9gal)",
        'sn',
        '221'
    ],
    [
        "Serbia (\u0421\u0440\u0431\u0438\u0458\u0430)",
        'rs',
        '381'
    ],
    [
        'Seychelles',
        'sc',
        '248'
    ],
    [
        'Sierra Leone',
        'sl',
        '232'
    ],
    [
        'Singapore',
        'sg',
        '65'
    ],
    [
        'Sint Maarten',
        'sx',
        '1721'
    ],
    [
        'Slovakia (Slovensko)',
        'sk',
        '421'
    ],
    [
        'Slovenia (Slovenija)',
        'si',
        '386'
    ],
    [
        'Solomon Islands',
        'sb',
        '677'
    ],
    [
        'Somalia (Soomaaliya)',
        'so',
        '252'
    ],
    [
        'South Africa',
        'za',
        '27'
    ],
    [
        "South Korea (\uB300\uD55C\uBBFC\uAD6D)",
        'kr',
        '82'
    ],
    [
        "South Sudan (\u202B\u062C\u0646\u0648\u0628 \u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)",
        'ss',
        '211'
    ],
    [
        "Spain (Espa\xf1a)",
        'es',
        '34'
    ],
    [
        "Sri Lanka (\u0DC1\u0DCA\u200D\u0DBB\u0DD3 \u0DBD\u0D82\u0D9A\u0DCF\u0DC0)",
        'lk',
        '94'
    ],
    [
        "Sudan (\u202B\u0627\u0644\u0633\u0648\u062F\u0627\u0646\u202C\u200E)",
        'sd',
        '249'
    ],
    [
        'Suriname',
        'sr',
        '597'
    ],
    [
        'Svalbard and Jan Mayen',
        'sj',
        '47',
        1
    ],
    [
        'Swaziland',
        'sz',
        '268'
    ],
    [
        'Sweden (Sverige)',
        'se',
        '46'
    ],
    [
        'Switzerland (Schweiz)',
        'ch',
        '41'
    ],
    [
        "Syria (\u202B\u0633\u0648\u0631\u064A\u0627\u202C\u200E)",
        'sy',
        '963'
    ],
    [
        "Taiwan (\u53F0\u7063)",
        'tw',
        '886'
    ],
    [
        'Tajikistan',
        'tj',
        '992'
    ],
    [
        'Tanzania',
        'tz',
        '255'
    ],
    [
        "Thailand (\u0E44\u0E17\u0E22)",
        'th',
        '66'
    ],
    [
        'Timor-Leste',
        'tl',
        '670'
    ],
    [
        'Togo',
        'tg',
        '228'
    ],
    [
        'Tokelau',
        'tk',
        '690'
    ],
    [
        'Tonga',
        'to',
        '676'
    ],
    [
        'Trinidad and Tobago',
        'tt',
        '1868'
    ],
    [
        "Tunisia (\u202B\u062A\u0648\u0646\u0633\u202C\u200E)",
        'tn',
        '216'
    ],
    [
        "Turkey (T\xfcrkiye)",
        'tr',
        '90'
    ],
    [
        'Turkmenistan',
        'tm',
        '993'
    ],
    [
        'Turks and Caicos Islands',
        'tc',
        '1649'
    ],
    [
        'Tuvalu',
        'tv',
        '688'
    ],
    [
        'U.S. Virgin Islands',
        'vi',
        '1340'
    ],
    [
        'Uganda',
        'ug',
        '256'
    ],
    [
        "Ukraine (\u0423\u043A\u0440\u0430\u0457\u043D\u0430)",
        'ua',
        '380'
    ],
    [
        "United Arab Emirates (\u202B\u0627\u0644\u0625\u0645\u0627\u0631\u0627\u062A \u0627\u0644\u0639\u0631\u0628\u064A\u0629 \u0627\u0644\u0645\u062A\u062D\u062F\u0629\u202C\u200E)",
        'ae',
        '971'
    ],
    [
        'United Kingdom',
        'gb',
        '44',
        0
    ],
    [
        'United States',
        'us',
        '1',
        0
    ],
    [
        'Uruguay',
        'uy',
        '598'
    ],
    [
        "Uzbekistan (O\u02BBzbekiston)",
        'uz',
        '998'
    ],
    [
        'Vanuatu',
        'vu',
        '678'
    ],
    [
        "Vatican City (Citt\xe0 del Vaticano)",
        'va',
        '39',
        1
    ],
    [
        'Venezuela',
        've',
        '58'
    ],
    [
        "Vietnam (Vi\u1EC7t Nam)",
        'vn',
        '84'
    ],
    [
        'Wallis and Futuna',
        'wf',
        '681'
    ],
    [
        "Western Sahara (\u202B\u0627\u0644\u0635\u062D\u0631\u0627\u0621 \u0627\u0644\u063A\u0631\u0628\u064A\u0629\u202C\u200E)",
        'eh',
        '212',
        1
    ],
    [
        "Yemen (\u202B\u0627\u0644\u064A\u0645\u0646\u202C\u200E)",
        'ye',
        '967'
    ],
    [
        'Zambia',
        'zm',
        '260'
    ],
    [
        'Zimbabwe',
        'zw',
        '263'
    ],
    [
        "\xc5land Islands",
        'ax',
        '358',
        1
    ]
];
var $f81e894f2b0e1bc6$var$countries;
function $f81e894f2b0e1bc6$var$_formatCountriesData(countriesData) {
    return countriesData.map(function(country) {
        return {
            name: country[0],
            iso2: country[1],
            dialCode: country[2],
            priority: country[3] || 0,
            areaCodes: country[4] || null
        };
    });
}
function $f81e894f2b0e1bc6$var$initialize(externalCountriesList) {
    $f81e894f2b0e1bc6$var$countries = $f81e894f2b0e1bc6$var$_formatCountriesData(externalCountriesList || $f81e894f2b0e1bc6$var$defaultCountriesData);
}
function $f81e894f2b0e1bc6$var$getCountries() {
    if (!$f81e894f2b0e1bc6$var$countries) $f81e894f2b0e1bc6$var$initialize();
    return $f81e894f2b0e1bc6$var$countries;
}
var $f81e894f2b0e1bc6$var$AllCountries = {
    initialize: $f81e894f2b0e1bc6$var$initialize,
    getCountries: $f81e894f2b0e1bc6$var$getCountries
};
var $f81e894f2b0e1bc6$var$_default = $f81e894f2b0e1bc6$var$AllCountries;
module.exports.default = $f81e894f2b0e1bc6$var$_default;

});

parcelRegister("cwexE", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $91d3c0e33f54030d$var$_react = $91d3c0e33f54030d$var$_interopRequireWildcard((parcelRequire("1Mpn7")));

var $91d3c0e33f54030d$var$_classnames = $91d3c0e33f54030d$var$_interopRequireDefault((parcelRequire("eQDD4")));

var $91d3c0e33f54030d$var$_CountryList = $91d3c0e33f54030d$var$_interopRequireDefault((parcelRequire("bO8hx")));

var $91d3c0e33f54030d$var$_RootModal = $91d3c0e33f54030d$var$_interopRequireDefault((parcelRequire("jOLtm")));
function $91d3c0e33f54030d$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $91d3c0e33f54030d$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $91d3c0e33f54030d$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $91d3c0e33f54030d$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $91d3c0e33f54030d$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $91d3c0e33f54030d$var$_typeof(obj);
}
function $91d3c0e33f54030d$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $91d3c0e33f54030d$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $91d3c0e33f54030d$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $91d3c0e33f54030d$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $91d3c0e33f54030d$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $91d3c0e33f54030d$var$_possibleConstructorReturn(self, call) {
    if (call && ($91d3c0e33f54030d$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $91d3c0e33f54030d$var$_assertThisInitialized(self);
}
function $91d3c0e33f54030d$var$_getPrototypeOf(o) {
    $91d3c0e33f54030d$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $91d3c0e33f54030d$var$_getPrototypeOf(o);
}
function $91d3c0e33f54030d$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $91d3c0e33f54030d$var$_setPrototypeOf(subClass, superClass);
}
function $91d3c0e33f54030d$var$_setPrototypeOf(o, p) {
    $91d3c0e33f54030d$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $91d3c0e33f54030d$var$_setPrototypeOf(o, p);
}
function $91d3c0e33f54030d$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $91d3c0e33f54030d$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $91d3c0e33f54030d$var$FlagDropDown = function(_Component) {
    $91d3c0e33f54030d$var$_inherits(FlagDropDown, _Component);
    function FlagDropDown() {
        var _getPrototypeOf2;
        var _this;
        $91d3c0e33f54030d$var$_classCallCheck(this, FlagDropDown);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $91d3c0e33f54030d$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $91d3c0e33f54030d$var$_getPrototypeOf(FlagDropDown)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $91d3c0e33f54030d$var$_defineProperty($91d3c0e33f54030d$var$_assertThisInitialized($91d3c0e33f54030d$var$_assertThisInitialized(_this)), "genSelectedDialCode", function() {
            var _this$props = _this.props, separateDialCode = _this$props.separateDialCode, dialCode = _this$props.dialCode;
            return separateDialCode ? $91d3c0e33f54030d$var$_react.default.createElement("div", {
                className: "selected-dial-code"
            }, dialCode) : null;
        });
        $91d3c0e33f54030d$var$_defineProperty($91d3c0e33f54030d$var$_assertThisInitialized($91d3c0e33f54030d$var$_assertThisInitialized(_this)), "genArrow", function() {
            var _this$props2 = _this.props, allowDropdown = _this$props2.allowDropdown, showDropdown = _this$props2.showDropdown;
            var arrowClasses = (0, $91d3c0e33f54030d$var$_classnames.default)('arrow', showDropdown ? 'up' : 'down');
            return allowDropdown ? $91d3c0e33f54030d$var$_react.default.createElement("div", {
                className: arrowClasses
            }) : null;
        });
        $91d3c0e33f54030d$var$_defineProperty($91d3c0e33f54030d$var$_assertThisInitialized($91d3c0e33f54030d$var$_assertThisInitialized(_this)), "genFlagClassName", function() {
            return (0, $91d3c0e33f54030d$var$_classnames.default)('iti-flag', $91d3c0e33f54030d$var$_defineProperty({}, _this.props.countryCode, !!_this.props.countryCode));
        });
        $91d3c0e33f54030d$var$_defineProperty($91d3c0e33f54030d$var$_assertThisInitialized($91d3c0e33f54030d$var$_assertThisInitialized(_this)), "genCountryList", function() {
            var _this$props3 = _this.props, dropdownContainer = _this$props3.dropdownContainer, showDropdown = _this$props3.showDropdown, isMobile = _this$props3.isMobile, allowDropdown = _this$props3.allowDropdown, setFlag = _this$props3.setFlag, countries = _this$props3.countries, inputTop = _this$props3.inputTop, inputOuterHeight = _this$props3.inputOuterHeight, preferredCountries = _this$props3.preferredCountries, highlightedCountry = _this$props3.highlightedCountry, changeHighlightCountry = _this$props3.changeHighlightCountry;
            return $91d3c0e33f54030d$var$_react.default.createElement($91d3c0e33f54030d$var$_CountryList.default, {
                ref: function ref(countryList) {
                    _this.countryList = countryList;
                },
                dropdownContainer: dropdownContainer,
                isMobile: isMobile,
                showDropdown: allowDropdown && showDropdown,
                setFlag: setFlag,
                countries: countries,
                inputTop: inputTop,
                inputOuterHeight: inputOuterHeight,
                preferredCountries: preferredCountries,
                highlightedCountry: highlightedCountry,
                changeHighlightCountry: changeHighlightCountry
            });
        });
        return _this;
    }
    $91d3c0e33f54030d$var$_createClass(FlagDropDown, [
        {
            key: "render",
            value: function render() {
                var _this$props4 = this.props, refCallback = _this$props4.refCallback, allowDropdown = _this$props4.allowDropdown, clickSelectedFlag = _this$props4.clickSelectedFlag, handleSelectedFlagKeydown = _this$props4.handleSelectedFlagKeydown, titleTip = _this$props4.titleTip, dropdownContainer = _this$props4.dropdownContainer, showDropdown = _this$props4.showDropdown;
                return $91d3c0e33f54030d$var$_react.default.createElement("div", {
                    ref: refCallback,
                    className: "flag-container"
                }, $91d3c0e33f54030d$var$_react.default.createElement("div", {
                    className: "selected-flag",
                    tabIndex: allowDropdown ? '0' : '',
                    onClick: clickSelectedFlag,
                    onKeyDown: handleSelectedFlagKeydown,
                    title: titleTip
                }, $91d3c0e33f54030d$var$_react.default.createElement("div", {
                    className: this.genFlagClassName()
                }), this.genSelectedDialCode(), this.genArrow()), dropdownContainer && showDropdown ? $91d3c0e33f54030d$var$_react.default.createElement($91d3c0e33f54030d$var$_RootModal.default, null, this.genCountryList()) : this.genCountryList());
            }
        }
    ]);
    return FlagDropDown;
}($91d3c0e33f54030d$var$_react.Component);
module.exports.default = $91d3c0e33f54030d$var$FlagDropDown;
$91d3c0e33f54030d$var$FlagDropDown.__docgenInfo = {
    "description": "",
    "methods": [
        {
            "name": "genSelectedDialCode",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "genArrow",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "genFlagClassName",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "genCountryList",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        }
    ],
    "displayName": "FlagDropDown",
    "props": {
        "allowDropdown": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "dropdownContainer": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "separateDialCode": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "dialCode": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "countryCode": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "showDropdown": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "clickSelectedFlag": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "handleSelectedFlagKeydown": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "isMobile": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "setFlag": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "countries": {
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "object"
                }
            },
            "required": false,
            "description": ""
        },
        "inputTop": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "inputOuterHeight": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "preferredCountries": {
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "object"
                }
            },
            "required": false,
            "description": ""
        },
        "highlightedCountry": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "changeHighlightCountry": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "titleTip": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "refCallback": {
            "type": {
                "name": "func"
            },
            "required": true,
            "description": ""
        }
    }
};

});
parcelRegister("bO8hx", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $898ac9da693a6cf3$var$_react = $898ac9da693a6cf3$var$_interopRequireWildcard((parcelRequire("1Mpn7")));

var $898ac9da693a6cf3$var$_classnames = $898ac9da693a6cf3$var$_interopRequireDefault((parcelRequire("eQDD4")));

var $898ac9da693a6cf3$var$_utils = $898ac9da693a6cf3$var$_interopRequireDefault((parcelRequire("kH4y4")));

var $898ac9da693a6cf3$var$_FlagBox = $898ac9da693a6cf3$var$_interopRequireDefault((parcelRequire("eIRb7")));
function $898ac9da693a6cf3$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $898ac9da693a6cf3$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $898ac9da693a6cf3$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $898ac9da693a6cf3$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $898ac9da693a6cf3$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $898ac9da693a6cf3$var$_typeof(obj);
}
function $898ac9da693a6cf3$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $898ac9da693a6cf3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $898ac9da693a6cf3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $898ac9da693a6cf3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $898ac9da693a6cf3$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $898ac9da693a6cf3$var$_possibleConstructorReturn(self, call) {
    if (call && ($898ac9da693a6cf3$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $898ac9da693a6cf3$var$_assertThisInitialized(self);
}
function $898ac9da693a6cf3$var$_getPrototypeOf(o) {
    $898ac9da693a6cf3$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $898ac9da693a6cf3$var$_getPrototypeOf(o);
}
function $898ac9da693a6cf3$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $898ac9da693a6cf3$var$_setPrototypeOf(subClass, superClass);
}
function $898ac9da693a6cf3$var$_setPrototypeOf(o, p) {
    $898ac9da693a6cf3$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $898ac9da693a6cf3$var$_setPrototypeOf(o, p);
}
function $898ac9da693a6cf3$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $898ac9da693a6cf3$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $898ac9da693a6cf3$var$CountryList = function(_Component) {
    $898ac9da693a6cf3$var$_inherits(CountryList, _Component);
    function CountryList() {
        var _getPrototypeOf2;
        var _this;
        $898ac9da693a6cf3$var$_classCallCheck(this, CountryList);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $898ac9da693a6cf3$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $898ac9da693a6cf3$var$_getPrototypeOf(CountryList)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $898ac9da693a6cf3$var$_defineProperty($898ac9da693a6cf3$var$_assertThisInitialized($898ac9da693a6cf3$var$_assertThisInitialized(_this)), "setDropdownPosition", function() {
            _this.listElement.classList.remove('hide');
            var inputTop = _this.props.inputTop;
            var windowTop = window.pageYOffset !== undefined ? window.pageYOffset : (document.documentElement || document.body.parentNode || document.body).scrollTop;
            var windowHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
            var inputOuterHeight = _this.props.inputOuterHeight;
            var countryListOuterHeight = $898ac9da693a6cf3$var$_utils.default.getOuterHeight(_this.listElement);
            var dropdownFitsBelow = inputTop + inputOuterHeight + countryListOuterHeight < windowTop + windowHeight;
            var dropdownFitsAbove = inputTop - countryListOuterHeight > windowTop;
            var cssTop = !dropdownFitsBelow && dropdownFitsAbove ? "-".concat(countryListOuterHeight - 1, "px") : '';
            _this.listElement.style.top = cssTop;
            _this.listElement.classList.remove('v-hide');
        });
        $898ac9da693a6cf3$var$_defineProperty($898ac9da693a6cf3$var$_assertThisInitialized($898ac9da693a6cf3$var$_assertThisInitialized(_this)), "appendListItem", function(countries) {
            var isPreferred = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var preferredCountriesCount = _this.props.preferredCountries.length;
            return countries.map(function(country, index) {
                var actualIndex = isPreferred ? index : index + preferredCountriesCount;
                var countryClassObj = {
                    country: true,
                    highlight: _this.props.highlightedCountry === actualIndex,
                    preferred: isPreferred
                };
                var countryClass = (0, $898ac9da693a6cf3$var$_classnames.default)(countryClassObj);
                var onMouseOverOrFocus = _this.props.isMobile ? function onMouseOverOrFocus() {} : _this.handleMouseOver;
                var keyPrefix = isPreferred ? 'pref-' : '';
                return $898ac9da693a6cf3$var$_react.default.createElement($898ac9da693a6cf3$var$_FlagBox.default, {
                    key: "".concat(keyPrefix).concat(country.iso2),
                    dialCode: country.dialCode,
                    isoCode: country.iso2,
                    name: country.name,
                    onMouseOver: onMouseOverOrFocus,
                    onClick: function onClick() {
                        return _this.props.setFlag(country.iso2);
                    },
                    onFocus: onMouseOverOrFocus,
                    flagRef: function flagRef(selectedFlag) {
                        _this.selectedFlag = selectedFlag;
                    },
                    innerFlagRef: function innerFlagRef(selectedFlagInner) {
                        _this.selectedFlagInner = selectedFlagInner;
                    },
                    countryClass: countryClass
                });
            });
        });
        $898ac9da693a6cf3$var$_defineProperty($898ac9da693a6cf3$var$_assertThisInitialized($898ac9da693a6cf3$var$_assertThisInitialized(_this)), "handleMouseOver", function(e) {
            if (e.currentTarget.getAttribute('class').indexOf('country') > -1) {
                var selectedIndex = $898ac9da693a6cf3$var$_utils.default.retrieveLiIndex(e.currentTarget);
                _this.props.changeHighlightCountry(true, selectedIndex);
            }
        });
        return _this;
    }
    $898ac9da693a6cf3$var$_createClass(CountryList, [
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(nextProps) {
                var shouldUpdate = !$898ac9da693a6cf3$var$_utils.default.shallowEquals(this.props, nextProps);
                if (shouldUpdate && nextProps.showDropdown) {
                    this.listElement.classList.add('v-hide');
                    this.setDropdownPosition();
                }
                return shouldUpdate;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this2 = this;
                var _this$props = this.props, preferredCountries = _this$props.preferredCountries, countries = _this$props.countries, showDropdown = _this$props.showDropdown;
                var className = (0, $898ac9da693a6cf3$var$_classnames.default)('country-list', {
                    hide: !showDropdown
                });
                var preferredOptions = this.appendListItem(preferredCountries, true);
                var allOptions = this.appendListItem(countries);
                var divider = $898ac9da693a6cf3$var$_react.default.createElement("div", {
                    className: "divider"
                });
                return $898ac9da693a6cf3$var$_react.default.createElement("ul", {
                    ref: function ref(listElement) {
                        _this2.listElement = listElement;
                    },
                    className: className
                }, preferredOptions, preferredCountries.length > 0 ? divider : null, allOptions);
            }
        }
    ]);
    return CountryList;
}($898ac9da693a6cf3$var$_react.Component);
module.exports.default = $898ac9da693a6cf3$var$CountryList;
$898ac9da693a6cf3$var$CountryList.__docgenInfo = {
    "description": "",
    "methods": [
        {
            "name": "setDropdownPosition",
            "docblock": null,
            "modifiers": [],
            "params": [],
            "returns": null
        },
        {
            "name": "appendListItem",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "countries",
                    "type": null
                },
                {
                    "name": "isPreferred",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleMouseOver",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        }
    ],
    "displayName": "CountryList",
    "props": {
        "setFlag": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "countries": {
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "object"
                }
            },
            "required": false,
            "description": ""
        },
        "inputTop": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "inputOuterHeight": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "preferredCountries": {
            "type": {
                "name": "arrayOf",
                "value": {
                    "name": "object"
                }
            },
            "required": false,
            "description": ""
        },
        "highlightedCountry": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        },
        "changeHighlightCountry": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "showDropdown": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "isMobile": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        }
    }
};

});
parcelRegister("kH4y4", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $f10b5a0e3297da92$var$_AllCountries = $f10b5a0e3297da92$var$_interopRequireDefault((parcelRequire("liJs6")));
function $f10b5a0e3297da92$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $f10b5a0e3297da92$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $f10b5a0e3297da92$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $f10b5a0e3297da92$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $f10b5a0e3297da92$var$_typeof(obj);
}
var $f10b5a0e3297da92$var$_default = {
    arraysEqual: function arraysEqual(a, b) {
        if (a === b) return true;
        if (a === null || b === null) return false;
        if (a.length !== b.length) return false;
        for(var i = 0; i < a.length; ++i){
            if (a[i] !== b[i]) return false;
        }
        return true;
    },
    shallowEquals: function shallowEquals(a, b) {
        if (a === b) return true;
        for(var key in a)if (a[key] !== b[key]) {
            if (Array.isArray(a[key]) && Array.isArray(b[key])) {
                if (!this.arraysEqual(a[key], b[key])) return false;
            } else return false;
        }
        for(var _key in b){
            if (a.hasOwnProperty(_key) === false) return false;
        }
        return true;
    },
    trim: function trim(str) {
        var rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        if (!str) return '';
        return str.replace(rtrim, '');
    },
    isNumeric: function isNumeric(obj) {
        return obj - parseFloat(obj) >= 0;
    },
    retrieveLiIndex: function retrieveLiIndex(node) {
        if (!node) return -1;
        var children = node.parentNode.childNodes;
        var num = 0;
        for(var i = 0, max = children.length; i < max; i++){
            if (children[i] === node) return num;
            if (children[i].nodeType === 1 && children[i].tagName.toLowerCase() === 'li') num += 1;
        }
        return -1;
    },
    getNumeric: function getNumeric(s) {
        return s.replace(/\D/g, '');
    },
    startsWith: function startsWith(a, b) {
        return a.substr(0, b.length).toUpperCase() === b;
    },
    isWindow: function isWindow(obj) {
        return obj !== null && obj === obj.window;
    },
    getWindow: function getWindow(elem) {
        return this.isWindow(elem) ? elem : elem.nodeType === 9 && elem.defaultView;
    },
    offset: function offset(elem) {
        var docElem = null;
        var win = null;
        var box = {
            top: 0,
            left: 0
        };
        var doc = elem && elem.ownerDocument;
        docElem = doc.documentElement;
        if ($f10b5a0e3297da92$var$_typeof(elem.getBoundingClientRect) !== "undefined") box = elem.getBoundingClientRect();
        win = this.getWindow(doc);
        return {
            top: box.top + win.pageYOffset - docElem.clientTop,
            left: box.left + win.pageXOffset - docElem.clientLeft
        };
    },
    getOuterHeight: function getOuterHeight(element) {
        return element.offsetHeight + parseFloat(window.getComputedStyle(element).getPropertyValue('margin-top')) + parseFloat(window.getComputedStyle(element).getPropertyValue('margin-bottom'));
    },
    getCountryData: function getCountryData(countries, countryCode, ignoreOnlyCountriesOption, allowFail, errorHandler) {
        var countryList = ignoreOnlyCountriesOption ? $f10b5a0e3297da92$var$_AllCountries.default.getCountries() : countries;
        for(var i = 0; i < countryList.length; i++){
            if (countryList[i].iso2 === countryCode) return countryList[i];
        }
        if (allowFail) return null;
        if (typeof errorHandler === 'function') errorHandler(countryCode);
        return {};
    },
    findIndex: function findIndex(items, predicate) {
        var index = -1;
        items.some(function(item, i) {
            if (predicate(item)) {
                index = i;
                return true;
            }
        });
        return index;
    },
    getCursorPositionAfterFormating: function getCursorPositionAfterFormating(prevBeforeCursor, prev, next) {
        if (prev === next) return prevBeforeCursor.length;
        var cursorShift = 0;
        if (prev.length > next.length) {
            for(var i = 0, j = 0; i < prevBeforeCursor.length && j < next.length; i += 1)if (prevBeforeCursor[i] !== next[j]) {
                if (isNaN(next[j]) && !isNaN(prevBeforeCursor[i])) {
                    i -= 1;
                    j += 1;
                    cursorShift += 1;
                } else cursorShift -= 1;
            } else j += 1;
        } else {
            for(var _i = 0, _j = 0; _i < prevBeforeCursor.length && _j < next.length; _j += 1)if (prevBeforeCursor[_i] !== next[_j]) {
                if (isNaN(prevBeforeCursor[_i]) && !isNaN(next[_j])) {
                    _j -= 1;
                    _i += 1;
                    cursorShift -= 1;
                } else cursorShift += 1;
            } else _i += 1;
        }
        return prevBeforeCursor.length + cursorShift;
    }
};
module.exports.default = $f10b5a0e3297da92$var$_default;

});

parcelRegister("eIRb7", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $ab7e6cd5945d9974$var$_react = $ab7e6cd5945d9974$var$_interopRequireDefault((parcelRequire("1Mpn7")));
function $ab7e6cd5945d9974$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
var $ab7e6cd5945d9974$var$FlagBox = function FlagBox(_ref) {
    var dialCode = _ref.dialCode, isoCode = _ref.isoCode, name = _ref.name, onMouseOver = _ref.onMouseOver, onFocus = _ref.onFocus, onClick = _ref.onClick, flagRef = _ref.flagRef, innerFlagRef = _ref.innerFlagRef, countryClass = _ref.countryClass;
    return $ab7e6cd5945d9974$var$_react.default.createElement("li", {
        className: countryClass,
        "data-dial-code": dialCode,
        "data-country-code": isoCode,
        onMouseOver: onMouseOver,
        onFocus: onFocus,
        onClick: onClick
    }, $ab7e6cd5945d9974$var$_react.default.createElement("div", {
        ref: flagRef,
        className: "flag-box"
    }, $ab7e6cd5945d9974$var$_react.default.createElement("div", {
        ref: innerFlagRef,
        className: "iti-flag ".concat(isoCode)
    })), $ab7e6cd5945d9974$var$_react.default.createElement("span", {
        className: "country-name"
    }, name), $ab7e6cd5945d9974$var$_react.default.createElement("span", {
        className: "dial-code"
    }, "+ ".concat(dialCode)));
};
$ab7e6cd5945d9974$var$FlagBox.defaultProps = {
    onFocus: function onFocus() {},
    onMouseOver: function onMouseOver() {},
    onClick: function onClick() {}
};
var $ab7e6cd5945d9974$var$_default = $ab7e6cd5945d9974$var$FlagBox;
module.exports.default = $ab7e6cd5945d9974$var$_default;
$ab7e6cd5945d9974$var$FlagBox.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "FlagBox",
    "props": {
        "onFocus": {
            "defaultValue": {
                "value": "() => {}",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "onMouseOver": {
            "defaultValue": {
                "value": "() => {}",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "onClick": {
            "defaultValue": {
                "value": "() => {}",
                "computed": false
            },
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "dialCode": {
            "type": {
                "name": "string"
            },
            "required": true,
            "description": ""
        },
        "isoCode": {
            "type": {
                "name": "string"
            },
            "required": true,
            "description": ""
        },
        "name": {
            "type": {
                "name": "string"
            },
            "required": true,
            "description": ""
        },
        "flagRef": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "innerFlagRef": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "countryClass": {
            "type": {
                "name": "string"
            },
            "required": true,
            "description": ""
        }
    }
};

});


parcelRegister("jOLtm", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $e6d782e882e77755$var$_react = $e6d782e882e77755$var$_interopRequireWildcard((parcelRequire("1Mpn7")));

var $e6d782e882e77755$var$_reactDom = $e6d782e882e77755$var$_interopRequireDefault((parcelRequire("eP3xl")));
function $e6d782e882e77755$var$_interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
function $e6d782e882e77755$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $e6d782e882e77755$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $e6d782e882e77755$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $e6d782e882e77755$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $e6d782e882e77755$var$_typeof(obj);
}
function $e6d782e882e77755$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $e6d782e882e77755$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $e6d782e882e77755$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $e6d782e882e77755$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $e6d782e882e77755$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $e6d782e882e77755$var$_possibleConstructorReturn(self, call) {
    if (call && ($e6d782e882e77755$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $e6d782e882e77755$var$_assertThisInitialized(self);
}
function $e6d782e882e77755$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $e6d782e882e77755$var$_getPrototypeOf(o) {
    $e6d782e882e77755$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $e6d782e882e77755$var$_getPrototypeOf(o);
}
function $e6d782e882e77755$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $e6d782e882e77755$var$_setPrototypeOf(subClass, superClass);
}
function $e6d782e882e77755$var$_setPrototypeOf(o, p) {
    $e6d782e882e77755$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $e6d782e882e77755$var$_setPrototypeOf(o, p);
}
var $e6d782e882e77755$var$RootModal = function(_Component) {
    $e6d782e882e77755$var$_inherits(RootModal, _Component);
    function RootModal(props) {
        var _this;
        $e6d782e882e77755$var$_classCallCheck(this, RootModal);
        _this = $e6d782e882e77755$var$_possibleConstructorReturn(this, $e6d782e882e77755$var$_getPrototypeOf(RootModal).call(this, props));
        _this.modalTarget = document.createElement('div');
        _this.modalTarget.className = 'intl-tel-input iti-container';
        return _this;
    }
    $e6d782e882e77755$var$_createClass(RootModal, [
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                document.body.appendChild(this.modalTarget);
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.body.removeChild(this.modalTarget);
            }
        },
        {
            key: "render",
            value: function render() {
                return $e6d782e882e77755$var$_reactDom.default.createPortal($e6d782e882e77755$var$_react.default.createElement($e6d782e882e77755$var$_react.Fragment, null, this.props.children), this.modalTarget);
            }
        }
    ]);
    return RootModal;
}($e6d782e882e77755$var$_react.Component);
module.exports.default = $e6d782e882e77755$var$RootModal;
$e6d782e882e77755$var$RootModal.__docgenInfo = {
    "description": "",
    "methods": [],
    "displayName": "RootModal",
    "props": {
        "children": {
            "type": {
                "name": "node"
            },
            "required": false,
            "description": ""
        }
    }
};

});


parcelRegister("gGWR9", function(module, exports) {

var $l0HdX = parcelRequire("l0HdX");
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $c26e3930e6516eba$var$_react = $c26e3930e6516eba$var$_interopRequireWildcard((parcelRequire("1Mpn7")));
function $c26e3930e6516eba$var$_interopRequireWildcard(obj) {
    if (obj && obj.__esModule) return obj;
    else {
        var newObj = {};
        if (obj != null) {
            for(var key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) {
                var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {};
                if (desc.get || desc.set) Object.defineProperty(newObj, key, desc);
                else newObj[key] = obj[key];
            }
        }
        newObj.default = obj;
        return newObj;
    }
}
function $c26e3930e6516eba$var$_typeof(obj) {
    if (typeof Symbol === "function" && (0, $l0HdX._)(Symbol.iterator) === "symbol") $c26e3930e6516eba$var$_typeof = function _typeof(obj) {
        return typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    else $c26e3930e6516eba$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : (0, $l0HdX._)(obj);
    };
    return $c26e3930e6516eba$var$_typeof(obj);
}
function $c26e3930e6516eba$var$_extends() {
    $c26e3930e6516eba$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $c26e3930e6516eba$var$_extends.apply(this, arguments);
}
function $c26e3930e6516eba$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $c26e3930e6516eba$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $c26e3930e6516eba$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $c26e3930e6516eba$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $c26e3930e6516eba$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $c26e3930e6516eba$var$_possibleConstructorReturn(self, call) {
    if (call && ($c26e3930e6516eba$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $c26e3930e6516eba$var$_assertThisInitialized(self);
}
function $c26e3930e6516eba$var$_getPrototypeOf(o) {
    $c26e3930e6516eba$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $c26e3930e6516eba$var$_getPrototypeOf(o);
}
function $c26e3930e6516eba$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $c26e3930e6516eba$var$_setPrototypeOf(subClass, superClass);
}
function $c26e3930e6516eba$var$_setPrototypeOf(o, p) {
    $c26e3930e6516eba$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $c26e3930e6516eba$var$_setPrototypeOf(o, p);
}
function $c26e3930e6516eba$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $c26e3930e6516eba$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $c26e3930e6516eba$var$TelInput = function(_Component) {
    $c26e3930e6516eba$var$_inherits(TelInput, _Component);
    function TelInput() {
        var _getPrototypeOf2;
        var _this;
        $c26e3930e6516eba$var$_classCallCheck(this, TelInput);
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        _this = $c26e3930e6516eba$var$_possibleConstructorReturn(this, (_getPrototypeOf2 = $c26e3930e6516eba$var$_getPrototypeOf(TelInput)).call.apply(_getPrototypeOf2, [
            this
        ].concat(args)));
        $c26e3930e6516eba$var$_defineProperty($c26e3930e6516eba$var$_assertThisInitialized($c26e3930e6516eba$var$_assertThisInitialized(_this)), "state", {
            hasFocus: false
        });
        $c26e3930e6516eba$var$_defineProperty($c26e3930e6516eba$var$_assertThisInitialized($c26e3930e6516eba$var$_assertThisInitialized(_this)), "refHandler", function(element) {
            _this.tel = element;
            _this.props.refCallback(element);
        });
        $c26e3930e6516eba$var$_defineProperty($c26e3930e6516eba$var$_assertThisInitialized($c26e3930e6516eba$var$_assertThisInitialized(_this)), "handleBlur", function(e) {
            _this.setState({
                hasFocus: false
            });
            if (typeof _this.props.handleOnBlur === 'function') _this.props.handleOnBlur(e);
        });
        $c26e3930e6516eba$var$_defineProperty($c26e3930e6516eba$var$_assertThisInitialized($c26e3930e6516eba$var$_assertThisInitialized(_this)), "handleFocus", function(e) {
            _this.setState({
                hasFocus: true
            });
            if (typeof _this.props.handleOnFocus === 'function') _this.props.handleOnFocus(e);
        });
        return _this;
    }
    $c26e3930e6516eba$var$_createClass(TelInput, [
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this.state.hasFocus) this.tel.setSelectionRange(this.props.cursorPosition, this.props.cursorPosition);
            }
        },
        {
            key: "render",
            value: function render() {
                return $c26e3930e6516eba$var$_react.default.createElement("input", $c26e3930e6516eba$var$_extends({}, this.props.inputProps, {
                    ref: this.refHandler,
                    type: "tel",
                    autoComplete: this.props.autoComplete,
                    className: this.props.className,
                    disabled: this.props.disabled,
                    readOnly: this.props.readonly,
                    name: this.props.fieldName,
                    id: this.props.fieldId,
                    value: this.props.value,
                    placeholder: this.props.placeholder,
                    onChange: this.props.handleInputChange,
                    onBlur: this.handleBlur,
                    onFocus: this.handleFocus,
                    autoFocus: this.props.autoFocus
                }));
            }
        }
    ]);
    return TelInput;
}($c26e3930e6516eba$var$_react.Component);
module.exports.default = $c26e3930e6516eba$var$TelInput;
$c26e3930e6516eba$var$TelInput.__docgenInfo = {
    "description": "",
    "methods": [
        {
            "name": "refHandler",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "element",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleBlur",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        },
        {
            "name": "handleFocus",
            "docblock": null,
            "modifiers": [],
            "params": [
                {
                    "name": "e",
                    "type": null
                }
            ],
            "returns": null
        }
    ],
    "displayName": "TelInput",
    "props": {
        "className": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "disabled": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "readonly": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "fieldName": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "fieldId": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "value": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "placeholder": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "handleInputChange": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "handleOnBlur": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "handleOnFocus": {
            "type": {
                "name": "func"
            },
            "required": false,
            "description": ""
        },
        "autoFocus": {
            "type": {
                "name": "bool"
            },
            "required": false,
            "description": ""
        },
        "autoComplete": {
            "type": {
                "name": "string"
            },
            "required": false,
            "description": ""
        },
        "inputProps": {
            "type": {
                "name": "object"
            },
            "required": false,
            "description": ""
        },
        "refCallback": {
            "type": {
                "name": "func"
            },
            "required": true,
            "description": ""
        },
        "cursorPosition": {
            "type": {
                "name": "number"
            },
            "required": false,
            "description": ""
        }
    }
};

});

parcelRegister("6Wpqq", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.KEYS = void 0;
var $50dbe1c12031d1e5$var$KEYS = {
    UP: 38,
    DOWN: 40,
    ENTER: 13,
    ESC: 27,
    PLUS: 43,
    A: 65,
    Z: 90,
    SPACE: 32,
    TAB: 9
};
module.exports.KEYS = $50dbe1c12031d1e5$var$KEYS;

});

parcelRegister("h3Gbx", function(module, exports) {

module.exports = (parcelRequire("eg86f"))($parcel$resolve("g8Jyh")).then(function() {
    return parcelRequire('8OwZp');
});

});
parcelRegister("eg86f", function(module, exports) {
"use strict";

var $31a2I = parcelRequire("31a2I");
module.exports = $31a2I(function(bundle) {
    return new Promise(function(resolve, reject) {
        // Don't insert the same script twice (e.g. if it was already in the HTML)
        var existingScripts = document.getElementsByTagName('script');
        if ([].concat(existingScripts).some(function(script) {
            return script.src === bundle;
        })) {
            resolve();
            return;
        }
        var preloadLink = document.createElement('link');
        preloadLink.href = bundle;
        preloadLink.rel = 'preload';
        preloadLink.as = 'script';
        document.head.appendChild(preloadLink);
        var script = document.createElement('script');
        script.async = true;
        script.type = 'text/javascript';
        script.src = bundle;
        script.onerror = function(e) {
            var error = new TypeError("Failed to fetch dynamically imported module: ".concat(bundle, ". Error: ").concat(e.message));
            script.onerror = script.onload = null;
            script.remove();
            reject(error);
        };
        script.onload = function() {
            script.onerror = script.onload = null;
            resolve();
        };
        document.getElementsByTagName('head')[0].appendChild(script);
    });
});

});
parcelRegister("31a2I", function(module, exports) {
"use strict";
var $23294162c634ba05$var$cachedBundles = {};
var $23294162c634ba05$var$cachedPreloads = {};
var $23294162c634ba05$var$cachedPrefetches = {};
function $23294162c634ba05$var$getCache(type) {
    switch(type){
        case 'preload':
            return $23294162c634ba05$var$cachedPreloads;
        case 'prefetch':
            return $23294162c634ba05$var$cachedPrefetches;
        default:
            return $23294162c634ba05$var$cachedBundles;
    }
}
module.exports = function(loader, type) {
    return function(bundle) {
        var cache = $23294162c634ba05$var$getCache(type);
        if (cache[bundle]) return cache[bundle];
        return cache[bundle] = loader.apply(null, arguments).catch(function(e) {
            delete cache[bundle];
            throw e;
        });
    };
};

});





parcelRegister("aSTyC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $7eca0b14f4093d10$export$2e2bcd8739ae039; });

var $cYr9j = parcelRequire("cYr9j");

var $4GJKx = parcelRequire("4GJKx");

var $1wc17 = parcelRequire("1wc17");

var $dcsZi = parcelRequire("dcsZi");

var $amul4 = parcelRequire("amul4");

var $jjExS = parcelRequire("jjExS");

var $1Mpn7 = parcelRequire("1Mpn7");

var $eP3xl = parcelRequire("eP3xl");

var $cyXq8 = parcelRequire("cyXq8");


var $l2msb = parcelRequire("l2msb");

var $fzFeM = parcelRequire("fzFeM");
var $7eca0b14f4093d10$var$publicKey = "-----BEGIN PUBLIC KEY-----\nMIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDlOJu6TyygqxfWT7eLtGDwajtN\nFOb9I5XRb6khyfD1Yt3YiCgQWMNW649887VGJiGr/L5i2osbl8C9+WJTeucF+S76\nxFxdU6jE0NQ+Z+zEdhUTooNRaY5nZiu5PgDB0ED/ZKBUSLKL7eibMxZtMlUDHjm4\ngwQco1KRMDSmXSMkDwIDAQAB\n-----END PUBLIC KEY-----";
var $7eca0b14f4093d10$var$encryption = new (0, $fzFeM.default)();
$7eca0b14f4093d10$var$encryption.setPublicKey($7eca0b14f4093d10$var$publicKey);
var $7eca0b14f4093d10$export$2e2bcd8739ae039 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $dcsZi._)(Loginmodal, _React_Component);
    function Loginmodal(props) {
        (0, $4GJKx._)(this, Loginmodal);
        var _this;
        _this = (0, $cYr9j._)(this, Loginmodal, [
            props
        ]);
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_this, "state", {
            isEmail: false,
            password: '',
            country_code: ''
        });
        (0, (/*@__PURE__*/$parcel$interopDefault($jjExS)))(_this, "onToggle", function() {
            var _$Loginmodal = document.querySelector('#loginModal');
            (0, (/*@__PURE__*/$parcel$interopDefault($eP3xl))).unmountComponentAtNode(_$Loginmodal);
        });
        _this.escFunction = _this.escFunction.bind(_this);
        _this.onHandleChange = _this.onHandleChange.bind(_this);
        _this.inputRef = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).createRef();
        return _this;
    }
    (0, $1wc17._)(Loginmodal, [
        {
            key: "escFunction",
            value: function escFunction(event) {
                if (event.keyCode === 27) this.onToggle();
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                this.inputRef.current.tel.setAttribute('type', 'text');
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                document.removeEventListener("keydown", this.escFunction, false);
            }
        },
        {
            key: "onHandleChange",
            value: function onHandleChange(e) {
                this.setState({
                    password: e.target.value
                });
            }
        },
        {
            key: "doLogin",
            value: function doLogin(ev) {
                var _this = this;
                var _ev_target_elements = ev.target.elements, email = _ev_target_elements.email, password = _ev_target_elements.password;
                var new_email = email.value;
                var _codes = this.state.country_code;
                if (this.state.isEmail == false) {
                    if (new_email) {
                        if (new_email.indexOf("+") < 0) new_email = _codes + new_email;
                    }
                }
                var encryptedPass = $7eca0b14f4093d10$var$encryption.encrypt(password.value);
                var _json_body = JSON.stringify({
                    email: new_email,
                    password: encryptedPass
                });
                fetch("".concat(BASE.url, "login"), {
                    method: 'POST',
                    headers: {
                        'ApiKey': 'd5ab8dc7ef67ca92e41d730982c5c602',
                        'Content-Type': 'application/json'
                    },
                    body: _json_body
                }).then(function(res) {
                    return res.json();
                }).then(function(res) {
                    var code = res.code, status = res.status, auth_token = res.auth_token, user_id = res.user_id, message = res.message;
                    if (status == 1 && auth_token) {
                        // AUTH_TOKEN = auth_token;
                        USER_AUTH = true;
                        MY_ID = user_id;
                        (0, $l2msb.showNotification)({
                            'title': message,
                            'type': 'success',
                            'message': message
                        });
                        if ('next_callback' in _this.props) try {
                            _this.props.next_callback();
                        } catch (e) {}
                        setTimeout(function() {
                            _this.onToggle();
                            window.location.reload();
                        }, 500);
                    }
                    if (status == 0) {
                        (0, $l2msb.showNotification)({
                            'title': message,
                            'type': 'error',
                            'message': message
                        });
                        _this.setState({
                            password: ''
                        });
                    }
                });
                ev.preventDefault();
                return false;
            }
        },
        {
            key: "checkInputType",
            value: function checkInputType(valid) {
                var current = this.inputRef.current;
                var tel = current.tel;
                var country_codes = current.state.dialCode;
                var value = tel.getAttribute('value');
                var pattern = /^([a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+(\.[a-z\d!#$%&'*+\-\/=?^_`{|}~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]+)*|"((([ \t]*\r\n)?[ \t]+)?([\x01-\x08\x0b\x0c\x0e-\x1f\x7f\x21\x23-\x5b\x5d-\x7e\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|\\[\x01-\x09\x0b\x0c\x0d-\x7f\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))*(([ \t]*\r\n)?[ \t]+)?")@(([a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\d\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.)+([a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]|[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF][a-z\d\-._~\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]*[a-z\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])\.?$/i;
                var isEmail = pattern.test(value);
                this.setState({
                    country_code: country_codes,
                    isEmail: isEmail
                });
                return valid;
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var isEmail = this.state.isEmail;
                var resetpassword = "".concat(BASE.url, "resetPassword");
                return /*#__PURE__*/ (0, $amul4.jsx)("div", {
                    className: "App",
                    children: /*#__PURE__*/ (0, $amul4.jsx)("div", {
                        className: "content",
                        children: /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                            id: "infoModal",
                            className: "modal_v4",
                            children: [
                                /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                    className: "modalHeader",
                                    children: modalV4.login_btn
                                }),
                                /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                    className: "modalBody",
                                    children: /*#__PURE__*/ (0, $amul4.jsxs)("form", {
                                        onSubmit: function(ev) {
                                            return _this.doLogin(ev);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                                className: "form-group",
                                                children: /*#__PURE__*/ (0, $amul4.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($cyXq8))), {
                                                    numberType: "MOBILE",
                                                    initialCountry: "sd",
                                                    defaultCountry: "sd",
                                                    nationalMode: true,
                                                    autoHideDialCode: false,
                                                    separateDialCode: true,
                                                    containerClassName: "intl-tel-input ".concat(isEmail ? 'email' : ''),
                                                    inputClassName: "form-control",
                                                    className: "input",
                                                    fieldName: "email",
                                                    autoComplete: "off",
                                                    onPhoneNumberChange: function(e) {
                                                        return _this.checkInputType(e);
                                                    },
                                                    ref: this.inputRef,
                                                    htmlAttr: {
                                                        type: 'text'
                                                    }
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                                className: "form-group",
                                                children: /*#__PURE__*/ (0, $amul4.jsx)("input", {
                                                    type: "password",
                                                    value: this.state.password,
                                                    onChange: this.onHandleChange,
                                                    placeholder: modalV4.password,
                                                    name: "password",
                                                    className: "form-control"
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $amul4.jsxs)("div", {
                                                className: "modalFooter",
                                                children: [
                                                    /*#__PURE__*/ (0, $amul4.jsx)("button", {
                                                        type: "submit",
                                                        className: "btn primary-1-btn",
                                                        children: modalV4.login_btn
                                                    }),
                                                    /*#__PURE__*/ (0, $amul4.jsx)("a", {
                                                        className: "login-fb",
                                                        href: "".concat(BASE.url, "redirect"),
                                                        children: /*#__PURE__*/ (0, $amul4.jsxs)("span", {
                                                            children: [
                                                                " ",
                                                                modalV4.facebook,
                                                                /*#__PURE__*/ (0, $amul4.jsx)("img", {
                                                                    src: "".concat(BASE.urls, "/v4/image/facebook.svg"),
                                                                    className: "imagemodal"
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                                className: "link_login",
                                                children: /*#__PURE__*/ (0, $amul4.jsx)("a", {
                                                    className: "forgetpassword",
                                                    href: resetpassword,
                                                    children: modalV4.forgetpassword
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                                className: "link_login",
                                                children: /*#__PURE__*/ (0, $amul4.jsx)("a", {
                                                    className: "register-link",
                                                    href: "".concat(BASE.url, "register"),
                                                    children: modalV4.Registration
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $amul4.jsx)("div", {
                                                className: "link_login",
                                                children: /*#__PURE__*/ (0, $amul4.jsx)("a", {
                                                    className: "close",
                                                    onClick: this.onToggle,
                                                    children: modalV4.close
                                                })
                                            })
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                });
            }
        }
    ]);
    return Loginmodal;
}((0, (/*@__PURE__*/$parcel$interopDefault($1Mpn7))).Component);

});
parcelRegister("fzFeM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b56a1cc4c9ed58e3$export$2e2bcd8739ae039; });

var $hZNRx = parcelRequire("hZNRx");
var $b56a1cc4c9ed58e3$export$2e2bcd8739ae039 = (0, $hZNRx.JSEncrypt);

});
parcelRegister("hZNRx", function(module, exports) {

$parcel$export(module.exports, "JSEncrypt", function () { return $d19ecfd88ebd660d$export$30d20f21275ad563; });

var $6fpEl = parcelRequire("6fpEl");

var $4Yrth = parcelRequire("4Yrth");
var $d19ecfd88ebd660d$var$_a;
var $d19ecfd88ebd660d$var$version = undefined;
/**
 *
 * @param {Object} [options = {}] - An object to customize JSEncrypt behaviour
 * possible parameters are:
 * - default_key_size        {number}  default: 1024 the key size in bit
 * - default_public_exponent {string}  default: '010001' the hexadecimal representation of the public exponent
 * - log                     {boolean} default: false whether log warn/error or not
 * @constructor
 */ var $d19ecfd88ebd660d$export$30d20f21275ad563 = /** @class */ function() {
    function JSEncrypt(options) {
        if (options === void 0) options = {};
        options = options || {};
        this.default_key_size = options.default_key_size ? parseInt(options.default_key_size, 10) : 1024;
        this.default_public_exponent = options.default_public_exponent || "010001"; // 65537 default openssl public exponent for rsa key type
        this.log = options.log || false;
        // The private and public key.
        this.key = null;
    }
    /**
     * Method to set the rsa key parameter (one method is enough to set both the public
     * and the private key, since the private key contains the public key paramenters)
     * Log a warning if logs are enabled
     * @param {Object|string} key the pem encoded string or an object (with or without header/footer)
     * @public
     */ JSEncrypt.prototype.setKey = function(key) {
        if (this.log && this.key) console.warn("A key was already set, overriding existing.");
        this.key = new (0, $4Yrth.JSEncryptRSAKey)(key);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */ JSEncrypt.prototype.setPrivateKey = function(privkey) {
        // Create the key.
        this.setKey(privkey);
    };
    /**
     * Proxy method for setKey, for api compatibility
     * @see setKey
     * @public
     */ JSEncrypt.prototype.setPublicKey = function(pubkey) {
        // Sets the public key.
        this.setKey(pubkey);
    };
    /**
     * Proxy method for RSAKey object's decrypt, decrypt the string using the private
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str base64 encoded crypted string to decrypt
     * @return {string} the decrypted string
     * @public
     */ JSEncrypt.prototype.decrypt = function(str) {
        // Return the decrypted string.
        try {
            return this.getKey().decrypt((0, $6fpEl.b64tohex)(str));
        } catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's encrypt, encrypt the string using the public
     * components of the rsa key object. Note that if the object was not set will be created
     * on the fly (by the getKey method) using the parameters passed in the JSEncrypt constructor
     * @param {string} str the string to encrypt
     * @return {string} the encrypted string encoded in base64
     * @public
     */ JSEncrypt.prototype.encrypt = function(str) {
        // Return the encrypted string.
        try {
            return (0, $6fpEl.hex2b64)(this.getKey().encrypt(str));
        } catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's sign.
     * @param {string} str the string to sign
     * @param {function} digestMethod hash method
     * @param {string} digestName the name of the hash algorithm
     * @return {string} the signature encoded in base64
     * @public
     */ JSEncrypt.prototype.sign = function(str, digestMethod, digestName) {
        // return the RSA signature of 'str' in 'hex' format.
        try {
            return (0, $6fpEl.hex2b64)(this.getKey().sign(str, digestMethod, digestName));
        } catch (ex) {
            return false;
        }
    };
    /**
     * Proxy method for RSAKey object's verify.
     * @param {string} str the string to verify
     * @param {string} signature the signature encoded in base64 to compare the string to
     * @param {function} digestMethod hash method
     * @return {boolean} whether the data and signature match
     * @public
     */ JSEncrypt.prototype.verify = function(str, signature, digestMethod) {
        // Return the decrypted 'digest' of the signature.
        try {
            return this.getKey().verify(str, (0, $6fpEl.b64tohex)(signature), digestMethod);
        } catch (ex) {
            return false;
        }
    };
    /**
     * Getter for the current JSEncryptRSAKey object. If it doesn't exists a new object
     * will be created and returned
     * @param {callback} [cb] the callback to be called if we want the key to be generated
     * in an async fashion
     * @returns {JSEncryptRSAKey} the JSEncryptRSAKey object
     * @public
     */ JSEncrypt.prototype.getKey = function(cb) {
        // Only create new if it does not exist.
        if (!this.key) {
            // Get a new private key.
            this.key = new (0, $4Yrth.JSEncryptRSAKey)();
            if (cb && ({}).toString.call(cb) === "[object Function]") {
                this.key.generateAsync(this.default_key_size, this.default_public_exponent, cb);
                return;
            }
            // Generate the key.
            this.key.generate(this.default_key_size, this.default_public_exponent);
        }
        return this.key;
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITH header and footer
     * @public
     */ JSEncrypt.prototype.getPrivateKey = function() {
        // Return the private representation of this key.
        return this.getKey().getPrivateKey();
    };
    /**
     * Returns the pem encoded representation of the private key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the private key WITHOUT header and footer
     * @public
     */ JSEncrypt.prototype.getPrivateKeyB64 = function() {
        // Return the private representation of this key.
        return this.getKey().getPrivateBaseKeyB64();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITH header and footer
     * @public
     */ JSEncrypt.prototype.getPublicKey = function() {
        // Return the private representation of this key.
        return this.getKey().getPublicKey();
    };
    /**
     * Returns the pem encoded representation of the public key
     * If the key doesn't exists a new key will be created
     * @returns {string} pem encoded representation of the public key WITHOUT header and footer
     * @public
     */ JSEncrypt.prototype.getPublicKeyB64 = function() {
        // Return the private representation of this key.
        return this.getKey().getPublicBaseKeyB64();
    };
    JSEncrypt.version = $d19ecfd88ebd660d$var$version;
    return JSEncrypt;
}();

});
parcelRegister("6fpEl", function(module, exports) {

$parcel$export(module.exports, "hex2b64", function () { return $48c80a4a8e2b36f6$export$1d3058c7ef7b57e7; });
$parcel$export(module.exports, "b64tohex", function () { return $48c80a4a8e2b36f6$export$d19dfddb415836ed; });

var $fX5cY = parcelRequire("fX5cY");
var $48c80a4a8e2b36f6$var$b64map = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
var $48c80a4a8e2b36f6$var$b64pad = "=";
function $48c80a4a8e2b36f6$export$1d3058c7ef7b57e7(h) {
    var i;
    var c;
    var ret = "";
    for(i = 0; i + 3 <= h.length; i += 3){
        c = parseInt(h.substring(i, i + 3), 16);
        ret += $48c80a4a8e2b36f6$var$b64map.charAt(c >> 6) + $48c80a4a8e2b36f6$var$b64map.charAt(c & 63);
    }
    if (i + 1 == h.length) {
        c = parseInt(h.substring(i, i + 1), 16);
        ret += $48c80a4a8e2b36f6$var$b64map.charAt(c << 2);
    } else if (i + 2 == h.length) {
        c = parseInt(h.substring(i, i + 2), 16);
        ret += $48c80a4a8e2b36f6$var$b64map.charAt(c >> 2) + $48c80a4a8e2b36f6$var$b64map.charAt((c & 3) << 4);
    }
    while((ret.length & 3) > 0)ret += $48c80a4a8e2b36f6$var$b64pad;
    return ret;
}
function $48c80a4a8e2b36f6$export$d19dfddb415836ed(s) {
    var ret = "";
    var i;
    var k = 0; // b64 state, 0-3
    var slop = 0;
    for(i = 0; i < s.length; ++i){
        if (s.charAt(i) == $48c80a4a8e2b36f6$var$b64pad) break;
        var v = $48c80a4a8e2b36f6$var$b64map.indexOf(s.charAt(i));
        if (v < 0) continue;
        if (k == 0) {
            ret += (0, $fX5cY.int2char)(v >> 2);
            slop = v & 3;
            k = 1;
        } else if (k == 1) {
            ret += (0, $fX5cY.int2char)(slop << 2 | v >> 4);
            slop = v & 0xf;
            k = 2;
        } else if (k == 2) {
            ret += (0, $fX5cY.int2char)(slop);
            ret += (0, $fX5cY.int2char)(v >> 2);
            slop = v & 3;
            k = 3;
        } else {
            ret += (0, $fX5cY.int2char)(slop << 2 | v >> 4);
            ret += (0, $fX5cY.int2char)(v & 0xf);
            k = 0;
        }
    }
    if (k == 1) ret += (0, $fX5cY.int2char)(slop << 2);
    return ret;
}
function $48c80a4a8e2b36f6$export$d7cf0422ea26a99a(s) {
    // piggyback on b64tohex for now, optimize later
    var h = $48c80a4a8e2b36f6$export$d19dfddb415836ed(s);
    var i;
    var a = [];
    for(i = 0; 2 * i < h.length; ++i)a[i] = parseInt(h.substring(2 * i, 2 * i + 2), 16);
    return a;
}

});
parcelRegister("fX5cY", function(module, exports) {

$parcel$export(module.exports, "int2char", function () { return $02ff3b7bbd0b90c7$export$c428df0c30a01d71; });
$parcel$export(module.exports, "op_and", function () { return $02ff3b7bbd0b90c7$export$c43ae5375c5467e; });
$parcel$export(module.exports, "op_or", function () { return $02ff3b7bbd0b90c7$export$13e1ea506bd1b110; });
$parcel$export(module.exports, "op_xor", function () { return $02ff3b7bbd0b90c7$export$7d09fc4ce0babdf5; });
$parcel$export(module.exports, "op_andnot", function () { return $02ff3b7bbd0b90c7$export$1ba38128026ec450; });
$parcel$export(module.exports, "lbit", function () { return $02ff3b7bbd0b90c7$export$a8462e7e8e5f0662; });
$parcel$export(module.exports, "cbit", function () { return $02ff3b7bbd0b90c7$export$5c5f6ee32e7b5de7; });
var $02ff3b7bbd0b90c7$var$BI_RM = "0123456789abcdefghijklmnopqrstuvwxyz";
function $02ff3b7bbd0b90c7$export$c428df0c30a01d71(n) {
    return $02ff3b7bbd0b90c7$var$BI_RM.charAt(n);
}
function $02ff3b7bbd0b90c7$export$c43ae5375c5467e(x, y) {
    return x & y;
}
function $02ff3b7bbd0b90c7$export$13e1ea506bd1b110(x, y) {
    return x | y;
}
function $02ff3b7bbd0b90c7$export$7d09fc4ce0babdf5(x, y) {
    return x ^ y;
}
function $02ff3b7bbd0b90c7$export$1ba38128026ec450(x, y) {
    return x & ~y;
}
function $02ff3b7bbd0b90c7$export$a8462e7e8e5f0662(x) {
    if (x == 0) return -1;
    var r = 0;
    if ((x & 0xffff) == 0) {
        x >>= 16;
        r += 16;
    }
    if ((x & 0xff) == 0) {
        x >>= 8;
        r += 8;
    }
    if ((x & 0xf) == 0) {
        x >>= 4;
        r += 4;
    }
    if ((x & 3) == 0) {
        x >>= 2;
        r += 2;
    }
    if ((x & 1) == 0) ++r;
    return r;
}
function $02ff3b7bbd0b90c7$export$5c5f6ee32e7b5de7(x) {
    var r = 0;
    while(x != 0){
        x &= x - 1;
        ++r;
    }
    return r;
} //#endregion BIT_OPERATIONS

});


parcelRegister("4Yrth", function(module, exports) {

$parcel$export(module.exports, "JSEncryptRSAKey", function () { return $39f213438713a3da$export$2050a2732e8aa2b2; });

var $6fpEl = parcelRequire("6fpEl");

var $aF3dE = parcelRequire("aF3dE");

var $4ZGqr = parcelRequire("4ZGqr");

var $4pdCC = parcelRequire("4pdCC");

var $4dB5j = parcelRequire("4dB5j");

var $jeSh1 = parcelRequire("jeSh1");

var $337XS = parcelRequire("337XS");
var $39f213438713a3da$var$__extends = undefined && undefined.__extends || function() {
    var extendStatics = function extendStatics1(d, b) {
        extendStatics = Object.setPrototypeOf || ({
            __proto__: []
        }) instanceof Array && function(d, b) {
            d.__proto__ = b;
        } || function(d, b) {
            for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
        };
        return extendStatics(d, b);
    };
    return function(d, b) {
        if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() {
            this.constructor = d;
        }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
}();
/**
 * Create a new JSEncryptRSAKey that extends Tom Wu's RSA key object.
 * This object is just a decorator for parsing the key parameter
 * @param {string|Object} key - The key in string format, or an object containing
 * the parameters needed to build a RSAKey object.
 * @constructor
 */ var $39f213438713a3da$export$2050a2732e8aa2b2 = /** @class */ function(_super) {
    $39f213438713a3da$var$__extends(JSEncryptRSAKey, _super);
    function JSEncryptRSAKey(key) {
        var _this = _super.call(this) || this;
        // Call the super constructor.
        //  RSAKey.call(this);
        // If a key key was provided.
        if (key) {
            // If this is a string...
            if (typeof key === "string") _this.parseKey(key);
            else if (JSEncryptRSAKey.hasPrivateKeyProperty(key) || JSEncryptRSAKey.hasPublicKeyProperty(key)) // Set the values for the key.
            _this.parsePropertiesFrom(key);
        }
        return _this;
    }
    /**
     * Method to parse a pem encoded string containing both a public or private key.
     * The method will translate the pem encoded string in a der encoded string and
     * will parse private key and public key parameters. This method accepts public key
     * in the rsaencryption pkcs #1 format (oid: 1.2.840.113549.1.1.1).
     *
     * @todo Check how many rsa formats use the same format of pkcs #1.
     *
     * The format is defined as:
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * it's possible to examine the structure of the keys obtained from openssl using
     * an asn.1 dumper as the one used here to parse the components: http://lapo.it/asn1js/
     * @argument {string} pem the pem encoded string, can include the BEGIN/END header/footer
     * @private
     */ JSEncryptRSAKey.prototype.parseKey = function(pem) {
        try {
            var modulus = 0;
            var public_exponent = 0;
            var reHex = /^\s*(?:[0-9A-Fa-f][0-9A-Fa-f]\s*)+$/;
            var der = reHex.test(pem) ? (0, $aF3dE.Hex).decode(pem) : (0, $4ZGqr.Base64).unarmor(pem);
            var asn1 = (0, $4pdCC.ASN1).decode(der);
            // Fixes a bug with OpenSSL 1.0+ private keys
            if (asn1.sub.length === 3) asn1 = asn1.sub[2].sub[0];
            if (asn1.sub.length === 9) {
                // Parse the private key.
                modulus = asn1.sub[1].getHexStringValue(); // bigint
                this.n = (0, $jeSh1.parseBigInt)(modulus, 16);
                public_exponent = asn1.sub[2].getHexStringValue(); // int
                this.e = parseInt(public_exponent, 16);
                var private_exponent = asn1.sub[3].getHexStringValue(); // bigint
                this.d = (0, $jeSh1.parseBigInt)(private_exponent, 16);
                var prime1 = asn1.sub[4].getHexStringValue(); // bigint
                this.p = (0, $jeSh1.parseBigInt)(prime1, 16);
                var prime2 = asn1.sub[5].getHexStringValue(); // bigint
                this.q = (0, $jeSh1.parseBigInt)(prime2, 16);
                var exponent1 = asn1.sub[6].getHexStringValue(); // bigint
                this.dmp1 = (0, $jeSh1.parseBigInt)(exponent1, 16);
                var exponent2 = asn1.sub[7].getHexStringValue(); // bigint
                this.dmq1 = (0, $jeSh1.parseBigInt)(exponent2, 16);
                var coefficient = asn1.sub[8].getHexStringValue(); // bigint
                this.coeff = (0, $jeSh1.parseBigInt)(coefficient, 16);
            } else if (asn1.sub.length === 2) {
                if (asn1.sub[0].sub) {
                    // Parse ASN.1 SubjectPublicKeyInfo type as defined by X.509
                    var bit_string = asn1.sub[1];
                    var sequence = bit_string.sub[0];
                    modulus = sequence.sub[0].getHexStringValue();
                    this.n = (0, $jeSh1.parseBigInt)(modulus, 16);
                    public_exponent = sequence.sub[1].getHexStringValue();
                    this.e = parseInt(public_exponent, 16);
                } else {
                    // Parse ASN.1 RSAPublicKey type as defined by PKCS #1
                    modulus = asn1.sub[0].getHexStringValue();
                    this.n = (0, $jeSh1.parseBigInt)(modulus, 16);
                    public_exponent = asn1.sub[1].getHexStringValue();
                    this.e = parseInt(public_exponent, 16);
                }
            } else return false;
            return true;
        } catch (ex) {
            return false;
        }
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa key.
     *
     * The translation follow the ASN.1 notation :
     * RSAPrivateKey ::= SEQUENCE {
     *   version           Version,
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER,  -- e
     *   privateExponent   INTEGER,  -- d
     *   prime1            INTEGER,  -- p
     *   prime2            INTEGER,  -- q
     *   exponent1         INTEGER,  -- d mod (p1)
     *   exponent2         INTEGER,  -- d mod (q-1)
     *   coefficient       INTEGER,  -- (inverse of q) mod p
     * }
     * @returns {string}  DER Encoded String representing the rsa private key
     * @private
     */ JSEncryptRSAKey.prototype.getPrivateBaseKey = function() {
        var options = {
            array: [
                new (0, $337XS.KJUR).asn1.DERInteger({
                    int: 0
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.n
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    int: this.e
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.d
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.p
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.q
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.dmp1
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.dmq1
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.coeff
                })
            ]
        };
        var seq = new (0, $337XS.KJUR).asn1.DERSequence(options);
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */ JSEncryptRSAKey.prototype.getPrivateBaseKeyB64 = function() {
        return (0, $6fpEl.hex2b64)(this.getPrivateBaseKey());
    };
    /**
     * Translate rsa parameters in a hex encoded string representing the rsa public key.
     * The representation follow the ASN.1 notation :
     * PublicKeyInfo ::= SEQUENCE {
     *   algorithm       AlgorithmIdentifier,
     *   PublicKey       BIT STRING
     * }
     * Where AlgorithmIdentifier is:
     * AlgorithmIdentifier ::= SEQUENCE {
     *   algorithm       OBJECT IDENTIFIER,     the OID of the enc algorithm
     *   parameters      ANY DEFINED BY algorithm OPTIONAL (NULL for PKCS #1)
     * }
     * and PublicKey is a SEQUENCE encapsulated in a BIT STRING
     * RSAPublicKey ::= SEQUENCE {
     *   modulus           INTEGER,  -- n
     *   publicExponent    INTEGER   -- e
     * }
     * @returns {string} DER Encoded String representing the rsa public key
     * @private
     */ JSEncryptRSAKey.prototype.getPublicBaseKey = function() {
        var first_sequence = new (0, $337XS.KJUR).asn1.DERSequence({
            array: [
                new (0, $337XS.KJUR).asn1.DERObjectIdentifier({
                    oid: "1.2.840.113549.1.1.1"
                }),
                new (0, $337XS.KJUR).asn1.DERNull()
            ]
        });
        var second_sequence = new (0, $337XS.KJUR).asn1.DERSequence({
            array: [
                new (0, $337XS.KJUR).asn1.DERInteger({
                    bigint: this.n
                }),
                new (0, $337XS.KJUR).asn1.DERInteger({
                    int: this.e
                })
            ]
        });
        var bit_string = new (0, $337XS.KJUR).asn1.DERBitString({
            hex: "00" + second_sequence.getEncodedHex()
        });
        var seq = new (0, $337XS.KJUR).asn1.DERSequence({
            array: [
                first_sequence,
                bit_string
            ]
        });
        return seq.getEncodedHex();
    };
    /**
     * base64 (pem) encoded version of the DER encoded representation
     * @returns {string} pem encoded representation without header and footer
     * @public
     */ JSEncryptRSAKey.prototype.getPublicBaseKeyB64 = function() {
        return (0, $6fpEl.hex2b64)(this.getPublicBaseKey());
    };
    /**
     * wrap the string in block of width chars. The default value for rsa keys is 64
     * characters.
     * @param {string} str the pem encoded string without header and footer
     * @param {Number} [width=64] - the length the string has to be wrapped at
     * @returns {string}
     * @private
     */ JSEncryptRSAKey.wordwrap = function(str, width) {
        width = width || 64;
        if (!str) return str;
        var regex = "(.{1," + width + "})( +|$\n?)|(.{1," + width + "})";
        return str.match(RegExp(regex, "g")).join("\n");
    };
    /**
     * Retrieve the pem encoded private key
     * @returns {string} the pem encoded private key with header/footer
     * @public
     */ JSEncryptRSAKey.prototype.getPrivateKey = function() {
        var key = "-----BEGIN RSA PRIVATE KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPrivateBaseKeyB64()) + "\n";
        key += "-----END RSA PRIVATE KEY-----";
        return key;
    };
    /**
     * Retrieve the pem encoded public key
     * @returns {string} the pem encoded public key with header/footer
     * @public
     */ JSEncryptRSAKey.prototype.getPublicKey = function() {
        var key = "-----BEGIN PUBLIC KEY-----\n";
        key += JSEncryptRSAKey.wordwrap(this.getPublicBaseKeyB64()) + "\n";
        key += "-----END PUBLIC KEY-----";
        return key;
    };
    /**
     * Check if the object contains the necessary parameters to populate the rsa modulus
     * and public exponent parameters.
     * @param {Object} [obj={}] - An object that may contain the two public key
     * parameters
     * @returns {boolean} true if the object contains both the modulus and the public exponent
     * properties (n and e)
     * @todo check for types of n and e. N should be a parseable bigInt object, E should
     * be a parseable integer number
     * @private
     */ JSEncryptRSAKey.hasPublicKeyProperty = function(obj) {
        obj = obj || {};
        return obj.hasOwnProperty("n") && obj.hasOwnProperty("e");
    };
    /**
     * Check if the object contains ALL the parameters of an RSA key.
     * @param {Object} [obj={}] - An object that may contain nine rsa key
     * parameters
     * @returns {boolean} true if the object contains all the parameters needed
     * @todo check for types of the parameters all the parameters but the public exponent
     * should be parseable bigint objects, the public exponent should be a parseable integer number
     * @private
     */ JSEncryptRSAKey.hasPrivateKeyProperty = function(obj) {
        obj = obj || {};
        return obj.hasOwnProperty("n") && obj.hasOwnProperty("e") && obj.hasOwnProperty("d") && obj.hasOwnProperty("p") && obj.hasOwnProperty("q") && obj.hasOwnProperty("dmp1") && obj.hasOwnProperty("dmq1") && obj.hasOwnProperty("coeff");
    };
    /**
     * Parse the properties of obj in the current rsa object. Obj should AT LEAST
     * include the modulus and public exponent (n, e) parameters.
     * @param {Object} obj - the object containing rsa parameters
     * @private
     */ JSEncryptRSAKey.prototype.parsePropertiesFrom = function(obj) {
        this.n = obj.n;
        this.e = obj.e;
        if (obj.hasOwnProperty("d")) {
            this.d = obj.d;
            this.p = obj.p;
            this.q = obj.q;
            this.dmp1 = obj.dmp1;
            this.dmq1 = obj.dmq1;
            this.coeff = obj.coeff;
        }
    };
    return JSEncryptRSAKey;
}((0, $4dB5j.RSAKey));

});
parcelRegister("aF3dE", function(module, exports) {

$parcel$export(module.exports, "Hex", function () { return $7c303b00271aa0fe$export$9ccf03a0aa23a1ca; });
// Hex JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */ var $7c303b00271aa0fe$var$decoder;
var $7c303b00271aa0fe$export$9ccf03a0aa23a1ca = {
    decode: function decode(a) {
        var i;
        if ($7c303b00271aa0fe$var$decoder === undefined) {
            var hex = "0123456789ABCDEF";
            var ignore = " \f\n\r\t\u00A0\u2028\u2029";
            $7c303b00271aa0fe$var$decoder = {};
            for(i = 0; i < 16; ++i)$7c303b00271aa0fe$var$decoder[hex.charAt(i)] = i;
            hex = hex.toLowerCase();
            for(i = 10; i < 16; ++i)$7c303b00271aa0fe$var$decoder[hex.charAt(i)] = i;
            for(i = 0; i < ignore.length; ++i)$7c303b00271aa0fe$var$decoder[ignore.charAt(i)] = -1;
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for(i = 0; i < a.length; ++i){
            var c = a.charAt(i);
            if (c == "=") break;
            c = $7c303b00271aa0fe$var$decoder[c];
            if (c == -1) continue;
            if (c === undefined) throw new Error("Illegal character at offset " + i);
            bits |= c;
            if (++char_count >= 2) {
                out[out.length] = bits;
                bits = 0;
                char_count = 0;
            } else bits <<= 4;
        }
        if (char_count) throw new Error("Hex encoding incomplete: 4 bits missing");
        return out;
    }
};

});

parcelRegister("4ZGqr", function(module, exports) {

$parcel$export(module.exports, "Base64", function () { return $3a2dc4b8f0e24f3e$export$f436b0c2107cbd35; });
// Base64 JavaScript decoder
// Copyright (c) 2008-2013 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */ var $3a2dc4b8f0e24f3e$var$decoder;
var $3a2dc4b8f0e24f3e$export$f436b0c2107cbd35 = {
    decode: function decode(a) {
        var i;
        if ($3a2dc4b8f0e24f3e$var$decoder === undefined) {
            var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
            var ignore = "= \f\n\r\t\u00A0\u2028\u2029";
            $3a2dc4b8f0e24f3e$var$decoder = Object.create(null);
            for(i = 0; i < 64; ++i)$3a2dc4b8f0e24f3e$var$decoder[b64.charAt(i)] = i;
            $3a2dc4b8f0e24f3e$var$decoder['-'] = 62; //+
            $3a2dc4b8f0e24f3e$var$decoder['_'] = 63; //-
            for(i = 0; i < ignore.length; ++i)$3a2dc4b8f0e24f3e$var$decoder[ignore.charAt(i)] = -1;
        }
        var out = [];
        var bits = 0;
        var char_count = 0;
        for(i = 0; i < a.length; ++i){
            var c = a.charAt(i);
            if (c == "=") break;
            c = $3a2dc4b8f0e24f3e$var$decoder[c];
            if (c == -1) continue;
            if (c === undefined) throw new Error("Illegal character at offset " + i);
            bits |= c;
            if (++char_count >= 4) {
                out[out.length] = bits >> 16;
                out[out.length] = bits >> 8 & 0xFF;
                out[out.length] = bits & 0xFF;
                bits = 0;
                char_count = 0;
            } else bits <<= 6;
        }
        switch(char_count){
            case 1:
                throw new Error("Base64 encoding incomplete: at least 2 bits missing");
            case 2:
                out[out.length] = bits >> 10;
                break;
            case 3:
                out[out.length] = bits >> 16;
                out[out.length] = bits >> 8 & 0xFF;
                break;
        }
        return out;
    },
    re: /-----BEGIN [^-]+-----([A-Za-z0-9+\/=\s]+)-----END [^-]+-----|begin-base64[^\n]+\n([A-Za-z0-9+\/=\s]+)====/,
    unarmor: function unarmor(a) {
        var m = $3a2dc4b8f0e24f3e$export$f436b0c2107cbd35.re.exec(a);
        if (m) {
            if (m[1]) a = m[1];
            else if (m[2]) a = m[2];
            else throw new Error("RegExp out of sync");
        }
        return $3a2dc4b8f0e24f3e$export$f436b0c2107cbd35.decode(a);
    }
};

});

parcelRegister("4pdCC", function(module, exports) {

$parcel$export(module.exports, "ASN1", function () { return $3354103e85c64704$export$bcf89a7d574a5ba3; });
// ASN.1 JavaScript decoder
// Copyright (c) 2008-2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */ /*global oids */ 
var $bh4us = parcelRequire("bh4us");
var $3354103e85c64704$var$ellipsis = "\u2026";
var $3354103e85c64704$var$reTimeS = /^(\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
var $3354103e85c64704$var$reTimeL = /^(\d\d\d\d)(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])([01]\d|2[0-3])(?:([0-5]\d)(?:([0-5]\d)(?:[.,](\d{1,3}))?)?)?(Z|[-+](?:[0]\d|1[0-2])([0-5]\d)?)?$/;
function $3354103e85c64704$var$stringCut(str, len) {
    if (str.length > len) str = str.substring(0, len) + $3354103e85c64704$var$ellipsis;
    return str;
}
var $3354103e85c64704$export$6a4eb2e7fc9e8903 = /** @class */ function() {
    function Stream(enc, pos) {
        this.hexDigits = "0123456789ABCDEF";
        if (enc instanceof Stream) {
            this.enc = enc.enc;
            this.pos = enc.pos;
        } else {
            // enc should be an array or a binary string
            this.enc = enc;
            this.pos = pos;
        }
    }
    Stream.prototype.get = function(pos) {
        if (pos === undefined) pos = this.pos++;
        if (pos >= this.enc.length) throw new Error("Requesting byte offset ".concat(pos, " on a stream of length ").concat(this.enc.length));
        return "string" === typeof this.enc ? this.enc.charCodeAt(pos) : this.enc[pos];
    };
    Stream.prototype.hexByte = function(b) {
        return this.hexDigits.charAt(b >> 4 & 0xF) + this.hexDigits.charAt(b & 0xF);
    };
    Stream.prototype.hexDump = function(start, end, raw) {
        var s = "";
        for(var i = start; i < end; ++i){
            s += this.hexByte(this.get(i));
            if (raw !== true) switch(i & 0xF){
                case 0x7:
                    s += "  ";
                    break;
                case 0xF:
                    s += "\n";
                    break;
                default:
                    s += " ";
            }
        }
        return s;
    };
    Stream.prototype.isASCII = function(start, end) {
        for(var i = start; i < end; ++i){
            var c = this.get(i);
            if (c < 32 || c > 176) return false;
        }
        return true;
    };
    Stream.prototype.parseStringISO = function(start, end) {
        var s = "";
        for(var i = start; i < end; ++i)s += String.fromCharCode(this.get(i));
        return s;
    };
    Stream.prototype.parseStringUTF = function(start, end) {
        var s = "";
        for(var i = start; i < end;){
            var c = this.get(i++);
            if (c < 128) s += String.fromCharCode(c);
            else if (c > 191 && c < 224) s += String.fromCharCode((c & 0x1F) << 6 | this.get(i++) & 0x3F);
            else s += String.fromCharCode((c & 0x0F) << 12 | (this.get(i++) & 0x3F) << 6 | this.get(i++) & 0x3F);
        }
        return s;
    };
    Stream.prototype.parseStringBMP = function(start, end) {
        var str = "";
        var hi;
        var lo;
        for(var i = start; i < end;){
            hi = this.get(i++);
            lo = this.get(i++);
            str += String.fromCharCode(hi << 8 | lo);
        }
        return str;
    };
    Stream.prototype.parseTime = function(start, end, shortYear) {
        var s = this.parseStringISO(start, end);
        var m = (shortYear ? $3354103e85c64704$var$reTimeS : $3354103e85c64704$var$reTimeL).exec(s);
        if (!m) return "Unrecognized time: " + s;
        if (shortYear) {
            // to avoid querying the timer, use the fixed range [1970, 2069]
            // it will conform with ITU X.400 [-10, +40] sliding window until 2030
            m[1] = +m[1];
            m[1] += +m[1] < 70 ? 2000 : 1900;
        }
        s = m[1] + "-" + m[2] + "-" + m[3] + " " + m[4];
        if (m[5]) {
            s += ":" + m[5];
            if (m[6]) {
                s += ":" + m[6];
                if (m[7]) s += "." + m[7];
            }
        }
        if (m[8]) {
            s += " UTC";
            if (m[8] != "Z") {
                s += m[8];
                if (m[9]) s += ":" + m[9];
            }
        }
        return s;
    };
    Stream.prototype.parseInteger = function(start, end) {
        var v = this.get(start);
        var neg = v > 127;
        var pad = neg ? 255 : 0;
        var len;
        var s = "";
        // skip unuseful bits (not allowed in DER)
        while(v == pad && ++start < end)v = this.get(start);
        len = end - start;
        if (len === 0) return neg ? -1 : 0;
        // show bit length of huge integers
        if (len > 4) {
            s = v;
            len <<= 3;
            while(((+s ^ pad) & 0x80) == 0){
                s = +s << 1;
                --len;
            }
            s = "(" + len + " bit)\n";
        }
        // decode the integer
        if (neg) v = v - 256;
        var n = new (0, $bh4us.Int10)(v);
        for(var i = start + 1; i < end; ++i)n.mulAdd(256, this.get(i));
        return s + n.toString();
    };
    Stream.prototype.parseBitString = function(start, end, maxLength) {
        var unusedBit = this.get(start);
        var lenBit = (end - start - 1 << 3) - unusedBit;
        var intro = "(" + lenBit + " bit)\n";
        var s = "";
        for(var i = start + 1; i < end; ++i){
            var b = this.get(i);
            var skip = i == end - 1 ? unusedBit : 0;
            for(var j = 7; j >= skip; --j)s += b >> j & 1 ? "1" : "0";
            if (s.length > maxLength) return intro + $3354103e85c64704$var$stringCut(s, maxLength);
        }
        return intro + s;
    };
    Stream.prototype.parseOctetString = function(start, end, maxLength) {
        if (this.isASCII(start, end)) return $3354103e85c64704$var$stringCut(this.parseStringISO(start, end), maxLength);
        var len = end - start;
        var s = "(" + len + " byte)\n";
        maxLength /= 2; // we work in bytes
        if (len > maxLength) end = start + maxLength;
        for(var i = start; i < end; ++i)s += this.hexByte(this.get(i));
        if (len > maxLength) s += $3354103e85c64704$var$ellipsis;
        return s;
    };
    Stream.prototype.parseOID = function(start, end, maxLength) {
        var s = "";
        var n = new (0, $bh4us.Int10)();
        var bits = 0;
        for(var i = start; i < end; ++i){
            var v = this.get(i);
            n.mulAdd(128, v & 0x7F);
            bits += 7;
            if (!(v & 0x80)) {
                if (s === "") {
                    n = n.simplify();
                    if (n instanceof (0, $bh4us.Int10)) {
                        n.sub(80);
                        s = "2." + n.toString();
                    } else {
                        var m = n < 80 ? n < 40 ? 0 : 1 : 2;
                        s = m + "." + (n - m * 40);
                    }
                } else s += "." + n.toString();
                if (s.length > maxLength) return $3354103e85c64704$var$stringCut(s, maxLength);
                n = new (0, $bh4us.Int10)();
                bits = 0;
            }
        }
        if (bits > 0) s += ".incomplete";
        return s;
    };
    return Stream;
}();
var $3354103e85c64704$export$bcf89a7d574a5ba3 = /** @class */ function() {
    function ASN1(stream, header, length, tag, sub) {
        if (!(tag instanceof $3354103e85c64704$export$d43aca1a6125b796)) throw new Error("Invalid tag value.");
        this.stream = stream;
        this.header = header;
        this.length = length;
        this.tag = tag;
        this.sub = sub;
    }
    ASN1.prototype.typeName = function() {
        switch(this.tag.tagClass){
            case 0:
                switch(this.tag.tagNumber){
                    case 0x00:
                        return "EOC";
                    case 0x01:
                        return "BOOLEAN";
                    case 0x02:
                        return "INTEGER";
                    case 0x03:
                        return "BIT_STRING";
                    case 0x04:
                        return "OCTET_STRING";
                    case 0x05:
                        return "NULL";
                    case 0x06:
                        return "OBJECT_IDENTIFIER";
                    case 0x07:
                        return "ObjectDescriptor";
                    case 0x08:
                        return "EXTERNAL";
                    case 0x09:
                        return "REAL";
                    case 0x0A:
                        return "ENUMERATED";
                    case 0x0B:
                        return "EMBEDDED_PDV";
                    case 0x0C:
                        return "UTF8String";
                    case 0x10:
                        return "SEQUENCE";
                    case 0x11:
                        return "SET";
                    case 0x12:
                        return "NumericString";
                    case 0x13:
                        return "PrintableString"; // ASCII subset
                    case 0x14:
                        return "TeletexString"; // aka T61String
                    case 0x15:
                        return "VideotexString";
                    case 0x16:
                        return "IA5String"; // ASCII
                    case 0x17:
                        return "UTCTime";
                    case 0x18:
                        return "GeneralizedTime";
                    case 0x19:
                        return "GraphicString";
                    case 0x1A:
                        return "VisibleString"; // ASCII subset
                    case 0x1B:
                        return "GeneralString";
                    case 0x1C:
                        return "UniversalString";
                    case 0x1E:
                        return "BMPString";
                }
                return "Universal_" + this.tag.tagNumber.toString();
            case 1:
                return "Application_" + this.tag.tagNumber.toString();
            case 2:
                return "[" + this.tag.tagNumber.toString() + "]"; // Context
            case 3:
                return "Private_" + this.tag.tagNumber.toString();
        }
    };
    ASN1.prototype.content = function(maxLength) {
        if (this.tag === undefined) return null;
        if (maxLength === undefined) maxLength = Infinity;
        var content = this.posContent();
        var len = Math.abs(this.length);
        if (!this.tag.isUniversal()) {
            if (this.sub !== null) return "(" + this.sub.length + " elem)";
            return this.stream.parseOctetString(content, content + len, maxLength);
        }
        switch(this.tag.tagNumber){
            case 0x01:
                return this.stream.get(content) === 0 ? "false" : "true";
            case 0x02:
                return this.stream.parseInteger(content, content + len);
            case 0x03:
                return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseBitString(content, content + len, maxLength);
            case 0x04:
                return this.sub ? "(" + this.sub.length + " elem)" : this.stream.parseOctetString(content, content + len, maxLength);
            // case 0x05: // NULL
            case 0x06:
                return this.stream.parseOID(content, content + len, maxLength);
            // case 0x07: // ObjectDescriptor
            // case 0x08: // EXTERNAL
            // case 0x09: // REAL
            // case 0x0A: // ENUMERATED
            // case 0x0B: // EMBEDDED_PDV
            case 0x10:
            case 0x11:
                if (this.sub !== null) return "(" + this.sub.length + " elem)";
                else return "(no elem)";
            case 0x0C:
                return $3354103e85c64704$var$stringCut(this.stream.parseStringUTF(content, content + len), maxLength);
            case 0x12:
            case 0x13:
            case 0x14:
            case 0x15:
            case 0x16:
            // case 0x19: // GraphicString
            case 0x1A:
                // case 0x1B: // GeneralString
                // case 0x1C: // UniversalString
                return $3354103e85c64704$var$stringCut(this.stream.parseStringISO(content, content + len), maxLength);
            case 0x1E:
                return $3354103e85c64704$var$stringCut(this.stream.parseStringBMP(content, content + len), maxLength);
            case 0x17:
            case 0x18:
                return this.stream.parseTime(content, content + len, this.tag.tagNumber == 0x17);
        }
        return null;
    };
    ASN1.prototype.toString = function() {
        return this.typeName() + "@" + this.stream.pos + "[header:" + this.header + ",length:" + this.length + ",sub:" + (this.sub === null ? "null" : this.sub.length) + "]";
    };
    ASN1.prototype.toPrettyString = function(indent) {
        if (indent === undefined) indent = "";
        var s = indent + this.typeName() + " @" + this.stream.pos;
        if (this.length >= 0) s += "+";
        s += this.length;
        if (this.tag.tagConstructed) s += " (constructed)";
        else if (this.tag.isUniversal() && (this.tag.tagNumber == 0x03 || this.tag.tagNumber == 0x04) && this.sub !== null) s += " (encapsulates)";
        s += "\n";
        if (this.sub !== null) {
            indent += "  ";
            for(var i = 0, max = this.sub.length; i < max; ++i)s += this.sub[i].toPrettyString(indent);
        }
        return s;
    };
    ASN1.prototype.posStart = function() {
        return this.stream.pos;
    };
    ASN1.prototype.posContent = function() {
        return this.stream.pos + this.header;
    };
    ASN1.prototype.posEnd = function() {
        return this.stream.pos + this.header + Math.abs(this.length);
    };
    ASN1.prototype.toHexString = function() {
        return this.stream.hexDump(this.posStart(), this.posEnd(), true);
    };
    ASN1.decodeLength = function(stream) {
        var buf = stream.get();
        var len = buf & 0x7F;
        if (len == buf) return len;
        // no reason to use Int10, as it would be a huge buffer anyways
        if (len > 6) throw new Error("Length over 48 bits not supported at position " + (stream.pos - 1));
        if (len === 0) return null;
         // undefined
        buf = 0;
        for(var i = 0; i < len; ++i)buf = buf * 256 + stream.get();
        return buf;
    };
    /**
     * Retrieve the hexadecimal value (as a string) of the current ASN.1 element
     * @returns {string}
     * @public
     */ ASN1.prototype.getHexStringValue = function() {
        var hexString = this.toHexString();
        var offset = this.header * 2;
        var length = this.length * 2;
        return hexString.substr(offset, length);
    };
    ASN1.decode = function(str) {
        var stream;
        if (!(str instanceof $3354103e85c64704$export$6a4eb2e7fc9e8903)) stream = new $3354103e85c64704$export$6a4eb2e7fc9e8903(str, 0);
        else stream = str;
        var streamStart = new $3354103e85c64704$export$6a4eb2e7fc9e8903(stream);
        var tag = new $3354103e85c64704$export$d43aca1a6125b796(stream);
        var len = ASN1.decodeLength(stream);
        var start = stream.pos;
        var header = start - streamStart.pos;
        var sub = null;
        var getSub = function getSub() {
            var ret = [];
            if (len !== null) {
                // definite length
                var end = start + len;
                while(stream.pos < end)ret[ret.length] = ASN1.decode(stream);
                if (stream.pos != end) throw new Error("Content size is not correct for container starting at offset " + start);
            } else // undefined length
            try {
                for(;;){
                    var s = ASN1.decode(stream);
                    if (s.tag.isEOC()) break;
                    ret[ret.length] = s;
                }
                len = start - stream.pos; // undefined lengths are represented as negative values
            } catch (e) {
                throw new Error("Exception while decoding undefined length content: " + e);
            }
            return ret;
        };
        if (tag.tagConstructed) // must have valid content
        sub = getSub();
        else if (tag.isUniversal() && (tag.tagNumber == 0x03 || tag.tagNumber == 0x04)) // sometimes BitString and OctetString are used to encapsulate ASN.1
        try {
            if (tag.tagNumber == 0x03) {
                if (stream.get() != 0) throw new Error("BIT STRINGs with unused bits cannot encapsulate.");
            }
            sub = getSub();
            for(var i = 0; i < sub.length; ++i){
                if (sub[i].tag.isEOC()) throw new Error("EOC is not supposed to be actual content.");
            }
        } catch (e) {
            // but silently ignore when they don't
            sub = null;
        }
        if (sub === null) {
            if (len === null) throw new Error("We can't skip over an invalid tag with undefined length at offset " + start);
            stream.pos = start + Math.abs(len);
        }
        return new ASN1(streamStart, header, len, tag, sub);
    };
    return ASN1;
}();
var $3354103e85c64704$export$d43aca1a6125b796 = /** @class */ function() {
    function ASN1Tag(stream) {
        var buf = stream.get();
        this.tagClass = buf >> 6;
        this.tagConstructed = (buf & 0x20) !== 0;
        this.tagNumber = buf & 0x1F;
        if (this.tagNumber == 0x1F) {
            var n = new (0, $bh4us.Int10)();
            do {
                buf = stream.get();
                n.mulAdd(128, buf & 0x7F);
            }while (buf & 0x80);
            this.tagNumber = n.simplify();
        }
    }
    ASN1Tag.prototype.isUniversal = function() {
        return this.tagClass === 0x00;
    };
    ASN1Tag.prototype.isEOC = function() {
        return this.tagClass === 0x00 && this.tagNumber === 0x00;
    };
    return ASN1Tag;
}();

});
parcelRegister("bh4us", function(module, exports) {

$parcel$export(module.exports, "Int10", function () { return $8354c3e4d0e1d345$export$e91e57f470deafbd; });
// Big integer base-10 printing library
// Copyright (c) 2014 Lapo Luchini <lapo@lapo.it>
// Permission to use, copy, modify, and/or distribute this software for any
// purpose with or without fee is hereby granted, provided that the above
// copyright notice and this permission notice appear in all copies.
//
// THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES
// WITH REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF
// MERCHANTABILITY AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR
// ANY SPECIAL, DIRECT, INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES
// WHATSOEVER RESULTING FROM LOSS OF USE, DATA OR PROFITS, WHETHER IN AN
// ACTION OF CONTRACT, NEGLIGENCE OR OTHER TORTIOUS ACTION, ARISING OUT OF
// OR IN CONNECTION WITH THE USE OR PERFORMANCE OF THIS SOFTWARE.
/*jshint browser: true, strict: true, immed: true, latedef: true, undef: true, regexdash: false */ var $8354c3e4d0e1d345$var$max = 10000000000000; // biggest integer that can still fit 2^53 when multiplied by 256
var $8354c3e4d0e1d345$export$e91e57f470deafbd = /** @class */ function() {
    function Int10(value) {
        this.buf = [
            +value || 0
        ];
    }
    Int10.prototype.mulAdd = function(m, c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for(i = 0; i < l; ++i){
            t = b[i] * m + c;
            if (t < $8354c3e4d0e1d345$var$max) c = 0;
            else {
                c = 0 | t / $8354c3e4d0e1d345$var$max;
                t -= c * $8354c3e4d0e1d345$var$max;
            }
            b[i] = t;
        }
        if (c > 0) b[i] = c;
    };
    Int10.prototype.sub = function(c) {
        // assert(m <= 256)
        var b = this.buf;
        var l = b.length;
        var i;
        var t;
        for(i = 0; i < l; ++i){
            t = b[i] - c;
            if (t < 0) {
                t += $8354c3e4d0e1d345$var$max;
                c = 1;
            } else c = 0;
            b[i] = t;
        }
        while(b[b.length - 1] === 0)b.pop();
    };
    Int10.prototype.toString = function(base) {
        if ((base || 10) != 10) throw new Error("only base 10 is supported");
        var b = this.buf;
        var s = b[b.length - 1].toString();
        for(var i = b.length - 2; i >= 0; --i)s += ($8354c3e4d0e1d345$var$max + b[i]).toString().substring(1);
        return s;
    };
    Int10.prototype.valueOf = function() {
        var b = this.buf;
        var v = 0;
        for(var i = b.length - 1; i >= 0; --i)v = v * $8354c3e4d0e1d345$var$max + b[i];
        return v;
    };
    Int10.prototype.simplify = function() {
        var b = this.buf;
        return b.length == 1 ? b[0] : this;
    };
    return Int10;
}();

});


parcelRegister("4dB5j", function(module, exports) {

$parcel$export(module.exports, "RSAKey", function () { return $31252490dfdbf1ef$export$f5462558b84dd2ed; });
// Depends on jsbn.js and rng.js
// Version 1.1: support utf-8 encoding in pkcs1pad2
// convert a (hex) string to a bignum object

var $jeSh1 = parcelRequire("jeSh1");

var $feMev = parcelRequire("feMev");
// function linebrk(s,n) {
//   var ret = "";
//   var i = 0;
//   while(i + n < s.length) {
//     ret += s.substring(i,i+n) + "\n";
//     i += n;
//   }
//   return ret + s.substring(i,s.length);
// }
// function byte2Hex(b) {
//   if(b < 0x10)
//     return "0" + b.toString(16);
//   else
//     return b.toString(16);
// }
function $31252490dfdbf1ef$var$pkcs1pad1(s, n) {
    if (n < s.length + 22) {
        console.error("Message too long for RSA");
        return null;
    }
    var len = n - s.length - 6;
    var filler = "";
    for(var f = 0; f < len; f += 2)filler += "ff";
    var m = "0001" + filler + "00" + s;
    return (0, $jeSh1.parseBigInt)(m, 16);
}
// PKCS#1 (type 2, random) pad input string s to n bytes, and return a bigint
function $31252490dfdbf1ef$var$pkcs1pad2(s, n) {
    if (n < s.length + 11) {
        console.error("Message too long for RSA");
        return null;
    }
    var ba = [];
    var i = s.length - 1;
    while(i >= 0 && n > 0){
        var c = s.charCodeAt(i--);
        if (c < 128) ba[--n] = c;
        else if (c > 127 && c < 2048) {
            ba[--n] = c & 63 | 128;
            ba[--n] = c >> 6 | 192;
        } else {
            ba[--n] = c & 63 | 128;
            ba[--n] = c >> 6 & 63 | 128;
            ba[--n] = c >> 12 | 224;
        }
    }
    ba[--n] = 0;
    var rng = new (0, $feMev.SecureRandom)();
    var x = [];
    while(n > 2){
        x[0] = 0;
        while(x[0] == 0)rng.nextBytes(x);
        ba[--n] = x[0];
    }
    ba[--n] = 2;
    ba[--n] = 0;
    return new (0, $jeSh1.BigInteger)(ba);
}
// "empty" RSA key constructor
var $31252490dfdbf1ef$export$f5462558b84dd2ed = /** @class */ function() {
    function RSAKey() {
        this.n = null;
        this.e = 0;
        this.d = null;
        this.p = null;
        this.q = null;
        this.dmp1 = null;
        this.dmq1 = null;
        this.coeff = null;
    }
    //#region PROTECTED
    // protected
    // RSAKey.prototype.doPublic = RSADoPublic;
    // Perform raw public operation on "x": return x^e (mod n)
    RSAKey.prototype.doPublic = function(x) {
        return x.modPowInt(this.e, this.n);
    };
    // RSAKey.prototype.doPrivate = RSADoPrivate;
    // Perform raw private operation on "x": return x^d (mod n)
    RSAKey.prototype.doPrivate = function(x) {
        if (this.p == null || this.q == null) return x.modPow(this.d, this.n);
        // TODO: re-calculate any missing CRT params
        var xp = x.mod(this.p).modPow(this.dmp1, this.p);
        var xq = x.mod(this.q).modPow(this.dmq1, this.q);
        while(xp.compareTo(xq) < 0)xp = xp.add(this.p);
        return xp.subtract(xq).multiply(this.coeff).mod(this.p).multiply(this.q).add(xq);
    };
    //#endregion PROTECTED
    //#region PUBLIC
    // RSAKey.prototype.setPublic = RSASetPublic;
    // Set the public key fields N and e from hex strings
    RSAKey.prototype.setPublic = function(N, E) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = (0, $jeSh1.parseBigInt)(N, 16);
            this.e = parseInt(E, 16);
        } else console.error("Invalid RSA public key");
    };
    // RSAKey.prototype.encrypt = RSAEncrypt;
    // Return the PKCS#1 RSA encryption of "text" as an even-length hex string
    RSAKey.prototype.encrypt = function(text) {
        var maxLength = this.n.bitLength() + 7 >> 3;
        var m = $31252490dfdbf1ef$var$pkcs1pad2(text, maxLength);
        if (m == null) return null;
        var c = this.doPublic(m);
        if (c == null) return null;
        var h = c.toString(16);
        var length = h.length;
        // fix zero before result
        for(var i = 0; i < maxLength * 2 - length; i++)h = "0" + h;
        return h;
    };
    // RSAKey.prototype.setPrivate = RSASetPrivate;
    // Set the private key fields N, e, and d from hex strings
    RSAKey.prototype.setPrivate = function(N, E, D) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = (0, $jeSh1.parseBigInt)(N, 16);
            this.e = parseInt(E, 16);
            this.d = (0, $jeSh1.parseBigInt)(D, 16);
        } else console.error("Invalid RSA private key");
    };
    // RSAKey.prototype.setPrivateEx = RSASetPrivateEx;
    // Set the private key fields N, e, d and CRT params from hex strings
    RSAKey.prototype.setPrivateEx = function(N, E, D, P, Q, DP, DQ, C) {
        if (N != null && E != null && N.length > 0 && E.length > 0) {
            this.n = (0, $jeSh1.parseBigInt)(N, 16);
            this.e = parseInt(E, 16);
            this.d = (0, $jeSh1.parseBigInt)(D, 16);
            this.p = (0, $jeSh1.parseBigInt)(P, 16);
            this.q = (0, $jeSh1.parseBigInt)(Q, 16);
            this.dmp1 = (0, $jeSh1.parseBigInt)(DP, 16);
            this.dmq1 = (0, $jeSh1.parseBigInt)(DQ, 16);
            this.coeff = (0, $jeSh1.parseBigInt)(C, 16);
        } else console.error("Invalid RSA private key");
    };
    // RSAKey.prototype.generate = RSAGenerate;
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generate = function(B, E) {
        var rng = new (0, $feMev.SecureRandom)();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new (0, $jeSh1.BigInteger)(E, 16);
        for(;;){
            for(;;){
                this.p = new (0, $jeSh1.BigInteger)(B - qs, 1, rng);
                if (this.p.subtract((0, $jeSh1.BigInteger).ONE).gcd(ee).compareTo((0, $jeSh1.BigInteger).ONE) == 0 && this.p.isProbablePrime(10)) break;
            }
            for(;;){
                this.q = new (0, $jeSh1.BigInteger)(qs, 1, rng);
                if (this.q.subtract((0, $jeSh1.BigInteger).ONE).gcd(ee).compareTo((0, $jeSh1.BigInteger).ONE) == 0 && this.q.isProbablePrime(10)) break;
            }
            if (this.p.compareTo(this.q) <= 0) {
                var t = this.p;
                this.p = this.q;
                this.q = t;
            }
            var p1 = this.p.subtract((0, $jeSh1.BigInteger).ONE);
            var q1 = this.q.subtract((0, $jeSh1.BigInteger).ONE);
            var phi = p1.multiply(q1);
            if (phi.gcd(ee).compareTo((0, $jeSh1.BigInteger).ONE) == 0) {
                this.n = this.p.multiply(this.q);
                this.d = ee.modInverse(phi);
                this.dmp1 = this.d.mod(p1);
                this.dmq1 = this.d.mod(q1);
                this.coeff = this.q.modInverse(this.p);
                break;
            }
        }
    };
    // RSAKey.prototype.decrypt = RSADecrypt;
    // Return the PKCS#1 RSA decryption of "ctext".
    // "ctext" is an even-length hex string and the output is a plain string.
    RSAKey.prototype.decrypt = function(ctext) {
        var c = (0, $jeSh1.parseBigInt)(ctext, 16);
        var m = this.doPrivate(c);
        if (m == null) return null;
        return $31252490dfdbf1ef$var$pkcs1unpad2(m, this.n.bitLength() + 7 >> 3);
    };
    // Generate a new random private key B bits long, using public expt E
    RSAKey.prototype.generateAsync = function(B, E, callback) {
        var rng = new (0, $feMev.SecureRandom)();
        var qs = B >> 1;
        this.e = parseInt(E, 16);
        var ee = new (0, $jeSh1.BigInteger)(E, 16);
        var rsa = this;
        // These functions have non-descript names because they were originally for(;;) loops.
        // I don't know about cryptography to give them better names than loop1-4.
        var loop1 = function loop11() {
            var loop4 = function loop4() {
                if (rsa.p.compareTo(rsa.q) <= 0) {
                    var t = rsa.p;
                    rsa.p = rsa.q;
                    rsa.q = t;
                }
                var p1 = rsa.p.subtract((0, $jeSh1.BigInteger).ONE);
                var q1 = rsa.q.subtract((0, $jeSh1.BigInteger).ONE);
                var phi = p1.multiply(q1);
                if (phi.gcd(ee).compareTo((0, $jeSh1.BigInteger).ONE) == 0) {
                    rsa.n = rsa.p.multiply(rsa.q);
                    rsa.d = ee.modInverse(phi);
                    rsa.dmp1 = rsa.d.mod(p1);
                    rsa.dmq1 = rsa.d.mod(q1);
                    rsa.coeff = rsa.q.modInverse(rsa.p);
                    setTimeout(function() {
                        callback();
                    }, 0); // escape
                } else setTimeout(loop1, 0);
            };
            var loop3 = function loop31() {
                rsa.q = (0, $jeSh1.nbi)();
                rsa.q.fromNumberAsync(qs, 1, rng, function() {
                    rsa.q.subtract((0, $jeSh1.BigInteger).ONE).gcda(ee, function(r) {
                        if (r.compareTo((0, $jeSh1.BigInteger).ONE) == 0 && rsa.q.isProbablePrime(10)) setTimeout(loop4, 0);
                        else setTimeout(loop3, 0);
                    });
                });
            };
            var loop2 = function loop21() {
                rsa.p = (0, $jeSh1.nbi)();
                rsa.p.fromNumberAsync(B - qs, 1, rng, function() {
                    rsa.p.subtract((0, $jeSh1.BigInteger).ONE).gcda(ee, function(r) {
                        if (r.compareTo((0, $jeSh1.BigInteger).ONE) == 0 && rsa.p.isProbablePrime(10)) setTimeout(loop3, 0);
                        else setTimeout(loop2, 0);
                    });
                });
            };
            setTimeout(loop2, 0);
        };
        setTimeout(loop1, 0);
    };
    RSAKey.prototype.sign = function(text, digestMethod, digestName) {
        var header = $31252490dfdbf1ef$var$getDigestHeader(digestName);
        var digest = header + digestMethod(text).toString();
        var m = $31252490dfdbf1ef$var$pkcs1pad1(digest, this.n.bitLength() / 4);
        if (m == null) return null;
        var c = this.doPrivate(m);
        if (c == null) return null;
        var h = c.toString(16);
        if ((h.length & 1) == 0) return h;
        else return "0" + h;
    };
    RSAKey.prototype.verify = function(text, signature, digestMethod) {
        var c = (0, $jeSh1.parseBigInt)(signature, 16);
        var m = this.doPublic(c);
        if (m == null) return null;
        var unpadded = m.toString(16).replace(/^1f+00/, "");
        var digest = $31252490dfdbf1ef$var$removeDigestHeader(unpadded);
        return digest == digestMethod(text).toString();
    };
    return RSAKey;
}();
// Undo PKCS#1 (type 2, random) padding and, if valid, return the plaintext
function $31252490dfdbf1ef$var$pkcs1unpad2(d, n) {
    var b = d.toByteArray();
    var i = 0;
    while(i < b.length && b[i] == 0)++i;
    if (b.length - i != n - 1 || b[i] != 2) return null;
    ++i;
    while(b[i] != 0){
        if (++i >= b.length) return null;
    }
    var ret = "";
    while(++i < b.length){
        var c = b[i] & 255;
        if (c < 128) ret += String.fromCharCode(c);
        else if (c > 191 && c < 224) {
            ret += String.fromCharCode((c & 31) << 6 | b[i + 1] & 63);
            ++i;
        } else {
            ret += String.fromCharCode((c & 15) << 12 | (b[i + 1] & 63) << 6 | b[i + 2] & 63);
            i += 2;
        }
    }
    return ret;
}
// https://tools.ietf.org/html/rfc3447#page-43
var $31252490dfdbf1ef$var$DIGEST_HEADERS = {
    md2: "3020300c06082a864886f70d020205000410",
    md5: "3020300c06082a864886f70d020505000410",
    sha1: "3021300906052b0e03021a05000414",
    sha224: "302d300d06096086480165030402040500041c",
    sha256: "3031300d060960864801650304020105000420",
    sha384: "3041300d060960864801650304020205000430",
    sha512: "3051300d060960864801650304020305000440",
    ripemd160: "3021300906052b2403020105000414"
};
function $31252490dfdbf1ef$var$getDigestHeader(name) {
    return $31252490dfdbf1ef$var$DIGEST_HEADERS[name] || "";
}
function $31252490dfdbf1ef$var$removeDigestHeader(str) {
    for(var name_1 in $31252490dfdbf1ef$var$DIGEST_HEADERS)if ($31252490dfdbf1ef$var$DIGEST_HEADERS.hasOwnProperty(name_1)) {
        var header = $31252490dfdbf1ef$var$DIGEST_HEADERS[name_1];
        var len = header.length;
        if (str.substr(0, len) == header) return str.substr(len);
    }
    return str;
} // Return the PKCS#1 RSA encryption of "text" as a Base64-encoded string
 // function RSAEncryptB64(text) {
 //  var h = this.encrypt(text);
 //  if(h) return hex2b64(h); else return null;
 // }
 // public
 // RSAKey.prototype.encrypt_b64 = RSAEncryptB64;

});
parcelRegister("jeSh1", function(module, exports) {

$parcel$export(module.exports, "BigInteger", function () { return $e0196cb87958ed77$export$1a89ae3627118dd; });
$parcel$export(module.exports, "nbi", function () { return $e0196cb87958ed77$export$2d5871c2be9bf1cc; });
$parcel$export(module.exports, "parseBigInt", function () { return $e0196cb87958ed77$export$76f8b5ba27b3a9fe; });
// Copyright (c) 2005  Tom Wu
// All Rights Reserved.
// See "LICENSE" for details.
// Basic JavaScript BN library - subset useful for RSA encryption.

var $fX5cY = parcelRequire("fX5cY");
// Bits per digit
var $e0196cb87958ed77$var$dbits;
// JavaScript engine analysis
var $e0196cb87958ed77$var$canary = 0xdeadbeefcafe;
var $e0196cb87958ed77$var$j_lm = ($e0196cb87958ed77$var$canary & 0xffffff) == 0xefcafe;
//#region
var $e0196cb87958ed77$var$lowprimes = [
    2,
    3,
    5,
    7,
    11,
    13,
    17,
    19,
    23,
    29,
    31,
    37,
    41,
    43,
    47,
    53,
    59,
    61,
    67,
    71,
    73,
    79,
    83,
    89,
    97,
    101,
    103,
    107,
    109,
    113,
    127,
    131,
    137,
    139,
    149,
    151,
    157,
    163,
    167,
    173,
    179,
    181,
    191,
    193,
    197,
    199,
    211,
    223,
    227,
    229,
    233,
    239,
    241,
    251,
    257,
    263,
    269,
    271,
    277,
    281,
    283,
    293,
    307,
    311,
    313,
    317,
    331,
    337,
    347,
    349,
    353,
    359,
    367,
    373,
    379,
    383,
    389,
    397,
    401,
    409,
    419,
    421,
    431,
    433,
    439,
    443,
    449,
    457,
    461,
    463,
    467,
    479,
    487,
    491,
    499,
    503,
    509,
    521,
    523,
    541,
    547,
    557,
    563,
    569,
    571,
    577,
    587,
    593,
    599,
    601,
    607,
    613,
    617,
    619,
    631,
    641,
    643,
    647,
    653,
    659,
    661,
    673,
    677,
    683,
    691,
    701,
    709,
    719,
    727,
    733,
    739,
    743,
    751,
    757,
    761,
    769,
    773,
    787,
    797,
    809,
    811,
    821,
    823,
    827,
    829,
    839,
    853,
    857,
    859,
    863,
    877,
    881,
    883,
    887,
    907,
    911,
    919,
    929,
    937,
    941,
    947,
    953,
    967,
    971,
    977,
    983,
    991,
    997
];
var $e0196cb87958ed77$var$lplim = 67108864 / $e0196cb87958ed77$var$lowprimes[$e0196cb87958ed77$var$lowprimes.length - 1];
//#endregion
// (public) Constructor
var $e0196cb87958ed77$export$1a89ae3627118dd = /** @class */ function() {
    function BigInteger(a, b, c) {
        if (a != null) {
            if ("number" == typeof a) this.fromNumber(a, b, c);
            else if (b == null && "string" != typeof a) this.fromString(a, 256);
            else this.fromString(a, b);
        }
    }
    //#region PUBLIC
    // BigInteger.prototype.toString = bnToString;
    // (public) return string representation in given radix
    BigInteger.prototype.toString = function(b) {
        if (this.s < 0) return "-" + this.negate().toString(b);
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else return this.toRadix(b);
        var km = (1 << k) - 1;
        var d;
        var m = false;
        var r = "";
        var i = this.t;
        var p = this.DB - i * this.DB % k;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) > 0) {
                m = true;
                r = (0, $fX5cY.int2char)(d);
            }
            while(i >= 0){
                if (p < k) {
                    d = (this[i] & (1 << p) - 1) << k - p;
                    d |= this[--i] >> (p += this.DB - k);
                } else {
                    d = this[i] >> (p -= k) & km;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if (d > 0) m = true;
                if (m) r += (0, $fX5cY.int2char)(d);
            }
        }
        return m ? r : "0";
    };
    // BigInteger.prototype.negate = bnNegate;
    // (public) -this
    BigInteger.prototype.negate = function() {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        BigInteger.ZERO.subTo(this, r);
        return r;
    };
    // BigInteger.prototype.abs = bnAbs;
    // (public) |this|
    BigInteger.prototype.abs = function() {
        return this.s < 0 ? this.negate() : this;
    };
    // BigInteger.prototype.compareTo = bnCompareTo;
    // (public) return + if this > a, - if this < a, 0 if equal
    BigInteger.prototype.compareTo = function(a) {
        var r = this.s - a.s;
        if (r != 0) return r;
        var i = this.t;
        r = i - a.t;
        if (r != 0) return this.s < 0 ? -r : r;
        while(--i >= 0){
            if ((r = this[i] - a[i]) != 0) return r;
        }
        return 0;
    };
    // BigInteger.prototype.bitLength = bnBitLength;
    // (public) return the number of bits in "this"
    BigInteger.prototype.bitLength = function() {
        if (this.t <= 0) return 0;
        return this.DB * (this.t - 1) + $e0196cb87958ed77$export$61f715936f8a3c(this[this.t - 1] ^ this.s & this.DM);
    };
    // BigInteger.prototype.mod = bnMod;
    // (public) this mod a
    BigInteger.prototype.mod = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.abs().divRemTo(a, null, r);
        if (this.s < 0 && r.compareTo(BigInteger.ZERO) > 0) a.subTo(r, r);
        return r;
    };
    // BigInteger.prototype.modPowInt = bnModPowInt;
    // (public) this^e % m, 0 <= e < 2^32
    BigInteger.prototype.modPowInt = function(e, m) {
        var z;
        if (e < 256 || m.isEven()) z = new $e0196cb87958ed77$var$Classic(m);
        else z = new $e0196cb87958ed77$var$Montgomery(m);
        return this.exp(e, z);
    };
    // BigInteger.prototype.clone = bnClone;
    // (public)
    BigInteger.prototype.clone = function() {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.copyTo(r);
        return r;
    };
    // BigInteger.prototype.intValue = bnIntValue;
    // (public) return value as integer
    BigInteger.prototype.intValue = function() {
        if (this.s < 0) {
            if (this.t == 1) return this[0] - this.DV;
            else if (this.t == 0) return -1;
        } else if (this.t == 1) return this[0];
        else if (this.t == 0) return 0;
        // assumes 16 < DB < 32
        return (this[1] & (1 << 32 - this.DB) - 1) << this.DB | this[0];
    };
    // BigInteger.prototype.byteValue = bnByteValue;
    // (public) return value as byte
    BigInteger.prototype.byteValue = function() {
        return this.t == 0 ? this.s : this[0] << 24 >> 24;
    };
    // BigInteger.prototype.shortValue = bnShortValue;
    // (public) return value as short (assumes DB>=16)
    BigInteger.prototype.shortValue = function() {
        return this.t == 0 ? this.s : this[0] << 16 >> 16;
    };
    // BigInteger.prototype.signum = bnSigNum;
    // (public) 0 if this == 0, 1 if this > 0
    BigInteger.prototype.signum = function() {
        if (this.s < 0) return -1;
        else if (this.t <= 0 || this.t == 1 && this[0] <= 0) return 0;
        else return 1;
    };
    // BigInteger.prototype.toByteArray = bnToByteArray;
    // (public) convert to bigendian byte array
    BigInteger.prototype.toByteArray = function() {
        var i = this.t;
        var r = [];
        r[0] = this.s;
        var p = this.DB - i * this.DB % 8;
        var d;
        var k = 0;
        if (i-- > 0) {
            if (p < this.DB && (d = this[i] >> p) != (this.s & this.DM) >> p) r[k++] = d | this.s << this.DB - p;
            while(i >= 0){
                if (p < 8) {
                    d = (this[i] & (1 << p) - 1) << 8 - p;
                    d |= this[--i] >> (p += this.DB - 8);
                } else {
                    d = this[i] >> (p -= 8) & 0xff;
                    if (p <= 0) {
                        p += this.DB;
                        --i;
                    }
                }
                if ((d & 0x80) != 0) d |= -256;
                if (k == 0 && (this.s & 0x80) != (d & 0x80)) ++k;
                if (k > 0 || d != this.s) r[k++] = d;
            }
        }
        return r;
    };
    // BigInteger.prototype.equals = bnEquals;
    BigInteger.prototype.equals = function(a) {
        return this.compareTo(a) == 0;
    };
    // BigInteger.prototype.min = bnMin;
    BigInteger.prototype.min = function(a) {
        return this.compareTo(a) < 0 ? this : a;
    };
    // BigInteger.prototype.max = bnMax;
    BigInteger.prototype.max = function(a) {
        return this.compareTo(a) > 0 ? this : a;
    };
    // BigInteger.prototype.and = bnAnd;
    BigInteger.prototype.and = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.bitwiseTo(a, (0, $fX5cY.op_and), r);
        return r;
    };
    // BigInteger.prototype.or = bnOr;
    BigInteger.prototype.or = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.bitwiseTo(a, (0, $fX5cY.op_or), r);
        return r;
    };
    // BigInteger.prototype.xor = bnXor;
    BigInteger.prototype.xor = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.bitwiseTo(a, (0, $fX5cY.op_xor), r);
        return r;
    };
    // BigInteger.prototype.andNot = bnAndNot;
    BigInteger.prototype.andNot = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.bitwiseTo(a, (0, $fX5cY.op_andnot), r);
        return r;
    };
    // BigInteger.prototype.not = bnNot;
    // (public) ~this
    BigInteger.prototype.not = function() {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        for(var i = 0; i < this.t; ++i)r[i] = this.DM & ~this[i];
        r.t = this.t;
        r.s = ~this.s;
        return r;
    };
    // BigInteger.prototype.shiftLeft = bnShiftLeft;
    // (public) this << n
    BigInteger.prototype.shiftLeft = function(n) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        if (n < 0) this.rShiftTo(-n, r);
        else this.lShiftTo(n, r);
        return r;
    };
    // BigInteger.prototype.shiftRight = bnShiftRight;
    // (public) this >> n
    BigInteger.prototype.shiftRight = function(n) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        if (n < 0) this.lShiftTo(-n, r);
        else this.rShiftTo(n, r);
        return r;
    };
    // BigInteger.prototype.getLowestSetBit = bnGetLowestSetBit;
    // (public) returns index of lowest 1-bit (or -1 if none)
    BigInteger.prototype.getLowestSetBit = function() {
        for(var i = 0; i < this.t; ++i){
            if (this[i] != 0) return i * this.DB + (0, $fX5cY.lbit)(this[i]);
        }
        if (this.s < 0) return this.t * this.DB;
        return -1;
    };
    // BigInteger.prototype.bitCount = bnBitCount;
    // (public) return number of set bits
    BigInteger.prototype.bitCount = function() {
        var r = 0;
        var x = this.s & this.DM;
        for(var i = 0; i < this.t; ++i)r += (0, $fX5cY.cbit)(this[i] ^ x);
        return r;
    };
    // BigInteger.prototype.testBit = bnTestBit;
    // (public) true iff nth bit is set
    BigInteger.prototype.testBit = function(n) {
        var j = Math.floor(n / this.DB);
        if (j >= this.t) return this.s != 0;
        return (this[j] & 1 << n % this.DB) != 0;
    };
    // BigInteger.prototype.setBit = bnSetBit;
    // (public) this | (1<<n)
    BigInteger.prototype.setBit = function(n) {
        return this.changeBit(n, (0, $fX5cY.op_or));
    };
    // BigInteger.prototype.clearBit = bnClearBit;
    // (public) this & ~(1<<n)
    BigInteger.prototype.clearBit = function(n) {
        return this.changeBit(n, (0, $fX5cY.op_andnot));
    };
    // BigInteger.prototype.flipBit = bnFlipBit;
    // (public) this ^ (1<<n)
    BigInteger.prototype.flipBit = function(n) {
        return this.changeBit(n, (0, $fX5cY.op_xor));
    };
    // BigInteger.prototype.add = bnAdd;
    // (public) this + a
    BigInteger.prototype.add = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.addTo(a, r);
        return r;
    };
    // BigInteger.prototype.subtract = bnSubtract;
    // (public) this - a
    BigInteger.prototype.subtract = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.subTo(a, r);
        return r;
    };
    // BigInteger.prototype.multiply = bnMultiply;
    // (public) this * a
    BigInteger.prototype.multiply = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.multiplyTo(a, r);
        return r;
    };
    // BigInteger.prototype.divide = bnDivide;
    // (public) this / a
    BigInteger.prototype.divide = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.divRemTo(a, r, null);
        return r;
    };
    // BigInteger.prototype.remainder = bnRemainder;
    // (public) this % a
    BigInteger.prototype.remainder = function(a) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.divRemTo(a, null, r);
        return r;
    };
    // BigInteger.prototype.divideAndRemainder = bnDivideAndRemainder;
    // (public) [this/a,this%a]
    BigInteger.prototype.divideAndRemainder = function(a) {
        var q = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.divRemTo(a, q, r);
        return [
            q,
            r
        ];
    };
    // BigInteger.prototype.modPow = bnModPow;
    // (public) this^e % m (HAC 14.85)
    BigInteger.prototype.modPow = function(e, m) {
        var i = e.bitLength();
        var k;
        var r = $e0196cb87958ed77$export$e4391d84a4602ee3(1);
        var z;
        if (i <= 0) return r;
        else if (i < 18) k = 1;
        else if (i < 48) k = 3;
        else if (i < 144) k = 4;
        else if (i < 768) k = 5;
        else k = 6;
        if (i < 8) z = new $e0196cb87958ed77$var$Classic(m);
        else if (m.isEven()) z = new $e0196cb87958ed77$var$Barrett(m);
        else z = new $e0196cb87958ed77$var$Montgomery(m);
        // precomputation
        var g = [];
        var n = 3;
        var k1 = k - 1;
        var km = (1 << k) - 1;
        g[1] = z.convert(this);
        if (k > 1) {
            var g2 = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
            z.sqrTo(g[1], g2);
            while(n <= km){
                g[n] = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
                z.mulTo(g2, g[n - 2], g[n]);
                n += 2;
            }
        }
        var j = e.t - 1;
        var w;
        var is1 = true;
        var r2 = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var t;
        i = $e0196cb87958ed77$export$61f715936f8a3c(e[j]) - 1;
        while(j >= 0){
            if (i >= k1) w = e[j] >> i - k1 & km;
            else {
                w = (e[j] & (1 << i + 1) - 1) << k1 - i;
                if (j > 0) w |= e[j - 1] >> this.DB + i - k1;
            }
            n = k;
            while((w & 1) == 0){
                w >>= 1;
                --n;
            }
            if ((i -= n) < 0) {
                i += this.DB;
                --j;
            }
            if (is1) {
                g[w].copyTo(r);
                is1 = false;
            } else {
                while(n > 1){
                    z.sqrTo(r, r2);
                    z.sqrTo(r2, r);
                    n -= 2;
                }
                if (n > 0) z.sqrTo(r, r2);
                else {
                    t = r;
                    r = r2;
                    r2 = t;
                }
                z.mulTo(r2, g[w], r);
            }
            while(j >= 0 && (e[j] & 1 << i) == 0){
                z.sqrTo(r, r2);
                t = r;
                r = r2;
                r2 = t;
                if (--i < 0) {
                    i = this.DB - 1;
                    --j;
                }
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.modInverse = bnModInverse;
    // (public) 1/this % m (HAC 14.61)
    BigInteger.prototype.modInverse = function(m) {
        var ac = m.isEven();
        if (this.isEven() && ac || m.signum() == 0) return BigInteger.ZERO;
        var u = m.clone();
        var v = this.clone();
        var a = $e0196cb87958ed77$export$e4391d84a4602ee3(1);
        var b = $e0196cb87958ed77$export$e4391d84a4602ee3(0);
        var c = $e0196cb87958ed77$export$e4391d84a4602ee3(0);
        var d = $e0196cb87958ed77$export$e4391d84a4602ee3(1);
        while(u.signum() != 0){
            while(u.isEven()){
                u.rShiftTo(1, u);
                if (ac) {
                    if (!a.isEven() || !b.isEven()) {
                        a.addTo(this, a);
                        b.subTo(m, b);
                    }
                    a.rShiftTo(1, a);
                } else if (!b.isEven()) b.subTo(m, b);
                b.rShiftTo(1, b);
            }
            while(v.isEven()){
                v.rShiftTo(1, v);
                if (ac) {
                    if (!c.isEven() || !d.isEven()) {
                        c.addTo(this, c);
                        d.subTo(m, d);
                    }
                    c.rShiftTo(1, c);
                } else if (!d.isEven()) d.subTo(m, d);
                d.rShiftTo(1, d);
            }
            if (u.compareTo(v) >= 0) {
                u.subTo(v, u);
                if (ac) a.subTo(c, a);
                b.subTo(d, b);
            } else {
                v.subTo(u, v);
                if (ac) c.subTo(a, c);
                d.subTo(b, d);
            }
        }
        if (v.compareTo(BigInteger.ONE) != 0) return BigInteger.ZERO;
        if (d.compareTo(m) >= 0) return d.subtract(m);
        if (d.signum() < 0) d.addTo(m, d);
        else return d;
        if (d.signum() < 0) return d.add(m);
        else return d;
    };
    // BigInteger.prototype.pow = bnPow;
    // (public) this^e
    BigInteger.prototype.pow = function(e) {
        return this.exp(e, new $e0196cb87958ed77$var$NullExp());
    };
    // BigInteger.prototype.gcd = bnGCD;
    // (public) gcd(this,a) (HAC 14.54)
    BigInteger.prototype.gcd = function(a) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) return x;
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        while(x.signum() > 0){
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
        }
        if (g > 0) y.lShiftTo(g, y);
        return y;
    };
    // BigInteger.prototype.isProbablePrime = bnIsProbablePrime;
    // (public) test primality with certainty >= 1-.5^t
    BigInteger.prototype.isProbablePrime = function(t) {
        var i;
        var x = this.abs();
        if (x.t == 1 && x[0] <= $e0196cb87958ed77$var$lowprimes[$e0196cb87958ed77$var$lowprimes.length - 1]) {
            for(i = 0; i < $e0196cb87958ed77$var$lowprimes.length; ++i){
                if (x[0] == $e0196cb87958ed77$var$lowprimes[i]) return true;
            }
            return false;
        }
        if (x.isEven()) return false;
        i = 1;
        while(i < $e0196cb87958ed77$var$lowprimes.length){
            var m = $e0196cb87958ed77$var$lowprimes[i];
            var j = i + 1;
            while(j < $e0196cb87958ed77$var$lowprimes.length && m < $e0196cb87958ed77$var$lplim)m *= $e0196cb87958ed77$var$lowprimes[j++];
            m = x.modInt(m);
            while(i < j){
                if (m % $e0196cb87958ed77$var$lowprimes[i++] == 0) return false;
            }
        }
        return x.millerRabin(t);
    };
    //#endregion PUBLIC
    //#region PROTECTED
    // BigInteger.prototype.copyTo = bnpCopyTo;
    // (protected) copy this to r
    BigInteger.prototype.copyTo = function(r) {
        for(var i = this.t - 1; i >= 0; --i)r[i] = this[i];
        r.t = this.t;
        r.s = this.s;
    };
    // BigInteger.prototype.fromInt = bnpFromInt;
    // (protected) set from integer value x, -DV <= x < DV
    BigInteger.prototype.fromInt = function(x) {
        this.t = 1;
        this.s = x < 0 ? -1 : 0;
        if (x > 0) this[0] = x;
        else if (x < -1) this[0] = x + this.DV;
        else this.t = 0;
    };
    // BigInteger.prototype.fromString = bnpFromString;
    // (protected) set from string and radix
    BigInteger.prototype.fromString = function(s, b) {
        var k;
        if (b == 16) k = 4;
        else if (b == 8) k = 3;
        else if (b == 256) k = 8;
        else if (b == 2) k = 1;
        else if (b == 32) k = 5;
        else if (b == 4) k = 2;
        else {
            this.fromRadix(s, b);
            return;
        }
        this.t = 0;
        this.s = 0;
        var i = s.length;
        var mi = false;
        var sh = 0;
        while(--i >= 0){
            var x = k == 8 ? +s[i] & 0xff : $e0196cb87958ed77$export$a834e31db7253a52(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-") mi = true;
                continue;
            }
            mi = false;
            if (sh == 0) this[this.t++] = x;
            else if (sh + k > this.DB) {
                this[this.t - 1] |= (x & (1 << this.DB - sh) - 1) << sh;
                this[this.t++] = x >> this.DB - sh;
            } else this[this.t - 1] |= x << sh;
            sh += k;
            if (sh >= this.DB) sh -= this.DB;
        }
        if (k == 8 && (+s[0] & 0x80) != 0) {
            this.s = -1;
            if (sh > 0) this[this.t - 1] |= (1 << this.DB - sh) - 1 << sh;
        }
        this.clamp();
        if (mi) BigInteger.ZERO.subTo(this, this);
    };
    // BigInteger.prototype.clamp = bnpClamp;
    // (protected) clamp off excess high words
    BigInteger.prototype.clamp = function() {
        var c = this.s & this.DM;
        while(this.t > 0 && this[this.t - 1] == c)--this.t;
    };
    // BigInteger.prototype.dlShiftTo = bnpDLShiftTo;
    // (protected) r = this << n*DB
    BigInteger.prototype.dlShiftTo = function(n, r) {
        var i;
        for(i = this.t - 1; i >= 0; --i)r[i + n] = this[i];
        for(i = n - 1; i >= 0; --i)r[i] = 0;
        r.t = this.t + n;
        r.s = this.s;
    };
    // BigInteger.prototype.drShiftTo = bnpDRShiftTo;
    // (protected) r = this >> n*DB
    BigInteger.prototype.drShiftTo = function(n, r) {
        for(var i = n; i < this.t; ++i)r[i - n] = this[i];
        r.t = Math.max(this.t - n, 0);
        r.s = this.s;
    };
    // BigInteger.prototype.lShiftTo = bnpLShiftTo;
    // (protected) r = this << n
    BigInteger.prototype.lShiftTo = function(n, r) {
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << cbs) - 1;
        var ds = Math.floor(n / this.DB);
        var c = this.s << bs & this.DM;
        for(var i = this.t - 1; i >= 0; --i){
            r[i + ds + 1] = this[i] >> cbs | c;
            c = (this[i] & bm) << bs;
        }
        for(var i = ds - 1; i >= 0; --i)r[i] = 0;
        r[ds] = c;
        r.t = this.t + ds + 1;
        r.s = this.s;
        r.clamp();
    };
    // BigInteger.prototype.rShiftTo = bnpRShiftTo;
    // (protected) r = this >> n
    BigInteger.prototype.rShiftTo = function(n, r) {
        r.s = this.s;
        var ds = Math.floor(n / this.DB);
        if (ds >= this.t) {
            r.t = 0;
            return;
        }
        var bs = n % this.DB;
        var cbs = this.DB - bs;
        var bm = (1 << bs) - 1;
        r[0] = this[ds] >> bs;
        for(var i = ds + 1; i < this.t; ++i){
            r[i - ds - 1] |= (this[i] & bm) << cbs;
            r[i - ds] = this[i] >> bs;
        }
        if (bs > 0) r[this.t - ds - 1] |= (this.s & bm) << cbs;
        r.t = this.t - ds;
        r.clamp();
    };
    // BigInteger.prototype.subTo = bnpSubTo;
    // (protected) r = this - a
    BigInteger.prototype.subTo = function(a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] - a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c -= a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c -= a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c -= a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c < -1) r[i++] = this.DV + c;
        else if (c > 0) r[i++] = c;
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.multiplyTo = bnpMultiplyTo;
    // (protected) r = this * a, r != this,a (HAC 14.12)
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyTo = function(a, r) {
        var x = this.abs();
        var y = a.abs();
        var i = x.t;
        r.t = i + y.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < y.t; ++i)r[i + x.t] = x.am(0, y[i], r, i, 0, x.t);
        r.s = 0;
        r.clamp();
        if (this.s != a.s) BigInteger.ZERO.subTo(r, r);
    };
    // BigInteger.prototype.squareTo = bnpSquareTo;
    // (protected) r = this^2, r != this (HAC 14.16)
    BigInteger.prototype.squareTo = function(r) {
        var x = this.abs();
        var i = r.t = 2 * x.t;
        while(--i >= 0)r[i] = 0;
        for(i = 0; i < x.t - 1; ++i){
            var c = x.am(i, x[i], r, 2 * i, 0, 1);
            if ((r[i + x.t] += x.am(i + 1, 2 * x[i], r, 2 * i + 1, c, x.t - i - 1)) >= x.DV) {
                r[i + x.t] -= x.DV;
                r[i + x.t + 1] = 1;
            }
        }
        if (r.t > 0) r[r.t - 1] += x.am(i, x[i], r, 2 * i, 0, 1);
        r.s = 0;
        r.clamp();
    };
    // BigInteger.prototype.divRemTo = bnpDivRemTo;
    // (protected) divide this by m, quotient and remainder to q, r (HAC 14.20)
    // r != q, this != m.  q or r may be null.
    BigInteger.prototype.divRemTo = function(m, q, r) {
        var pm = m.abs();
        if (pm.t <= 0) return;
        var pt = this.abs();
        if (pt.t < pm.t) {
            if (q != null) q.fromInt(0);
            if (r != null) this.copyTo(r);
            return;
        }
        if (r == null) r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var y = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var ts = this.s;
        var ms = m.s;
        var nsh = this.DB - $e0196cb87958ed77$export$61f715936f8a3c(pm[pm.t - 1]); // normalize modulus
        if (nsh > 0) {
            pm.lShiftTo(nsh, y);
            pt.lShiftTo(nsh, r);
        } else {
            pm.copyTo(y);
            pt.copyTo(r);
        }
        var ys = y.t;
        var y0 = y[ys - 1];
        if (y0 == 0) return;
        var yt = y0 * (1 << this.F1) + (ys > 1 ? y[ys - 2] >> this.F2 : 0);
        var d1 = this.FV / yt;
        var d2 = (1 << this.F1) / yt;
        var e = 1 << this.F2;
        var i = r.t;
        var j = i - ys;
        var t = q == null ? $e0196cb87958ed77$export$2d5871c2be9bf1cc() : q;
        y.dlShiftTo(j, t);
        if (r.compareTo(t) >= 0) {
            r[r.t++] = 1;
            r.subTo(t, r);
        }
        BigInteger.ONE.dlShiftTo(ys, t);
        t.subTo(y, y); // "negative" y so we can replace sub with am later
        while(y.t < ys)y[y.t++] = 0;
        while(--j >= 0){
            // Estimate quotient digit
            var qd = r[--i] == y0 ? this.DM : Math.floor(r[i] * d1 + (r[i - 1] + e) * d2);
            if ((r[i] += y.am(0, qd, r, j, 0, ys)) < qd) {
                y.dlShiftTo(j, t);
                r.subTo(t, r);
                while(r[i] < --qd)r.subTo(t, r);
            }
        }
        if (q != null) {
            r.drShiftTo(ys, q);
            if (ts != ms) BigInteger.ZERO.subTo(q, q);
        }
        r.t = ys;
        r.clamp();
        if (nsh > 0) r.rShiftTo(nsh, r);
         // Denormalize remainder
        if (ts < 0) BigInteger.ZERO.subTo(r, r);
    };
    // BigInteger.prototype.invDigit = bnpInvDigit;
    // (protected) return "-1/this % 2^DB"; useful for Mont. reduction
    // justification:
    //         xy == 1 (mod m)
    //         xy =  1+km
    //   xy(2-xy) = (1+km)(1-km)
    // x[y(2-xy)] = 1-k^2m^2
    // x[y(2-xy)] == 1 (mod m^2)
    // if y is 1/x mod m, then y(2-xy) is 1/x mod m^2
    // should reduce x and y(2-xy) by m^2 at each step to keep size bounded.
    // JS multiply "overflows" differently from C/C++, so care is needed here.
    BigInteger.prototype.invDigit = function() {
        if (this.t < 1) return 0;
        var x = this[0];
        if ((x & 1) == 0) return 0;
        var y = x & 3; // y == 1/x mod 2^2
        y = y * (2 - (x & 0xf) * y) & 0xf; // y == 1/x mod 2^4
        y = y * (2 - (x & 0xff) * y) & 0xff; // y == 1/x mod 2^8
        y = y * (2 - ((x & 0xffff) * y & 0xffff)) & 0xffff; // y == 1/x mod 2^16
        // last step - calculate inverse mod DV directly;
        // assumes 16 < DB <= 32 and assumes ability to handle 48-bit ints
        y = y * (2 - x * y % this.DV) % this.DV; // y == 1/x mod 2^dbits
        // we really want the negative inverse, and -DV < y < DV
        return y > 0 ? this.DV - y : -y;
    };
    // BigInteger.prototype.isEven = bnpIsEven;
    // (protected) true iff this is even
    BigInteger.prototype.isEven = function() {
        return (this.t > 0 ? this[0] & 1 : this.s) == 0;
    };
    // BigInteger.prototype.exp = bnpExp;
    // (protected) this^e, e < 2^32, doing sqr and mul with "r" (HAC 14.79)
    BigInteger.prototype.exp = function(e, z) {
        if (e > 0xffffffff || e < 1) return BigInteger.ONE;
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var r2 = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var g = z.convert(this);
        var i = $e0196cb87958ed77$export$61f715936f8a3c(e) - 1;
        g.copyTo(r);
        while(--i >= 0){
            z.sqrTo(r, r2);
            if ((e & 1 << i) > 0) z.mulTo(r2, g, r);
            else {
                var t = r;
                r = r2;
                r2 = t;
            }
        }
        return z.revert(r);
    };
    // BigInteger.prototype.chunkSize = bnpChunkSize;
    // (protected) return x s.t. r^x < DV
    BigInteger.prototype.chunkSize = function(r) {
        return Math.floor(Math.LN2 * this.DB / Math.log(r));
    };
    // BigInteger.prototype.toRadix = bnpToRadix;
    // (protected) convert to radix string
    BigInteger.prototype.toRadix = function(b) {
        if (b == null) b = 10;
        if (this.signum() == 0 || b < 2 || b > 36) return "0";
        var cs = this.chunkSize(b);
        var a = Math.pow(b, cs);
        var d = $e0196cb87958ed77$export$e4391d84a4602ee3(a);
        var y = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var z = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        var r = "";
        this.divRemTo(d, y, z);
        while(y.signum() > 0){
            r = (a + z.intValue()).toString(b).substr(1) + r;
            y.divRemTo(d, y, z);
        }
        return z.intValue().toString(b) + r;
    };
    // BigInteger.prototype.fromRadix = bnpFromRadix;
    // (protected) convert from radix string
    BigInteger.prototype.fromRadix = function(s, b) {
        this.fromInt(0);
        if (b == null) b = 10;
        var cs = this.chunkSize(b);
        var d = Math.pow(b, cs);
        var mi = false;
        var j = 0;
        var w = 0;
        for(var i = 0; i < s.length; ++i){
            var x = $e0196cb87958ed77$export$a834e31db7253a52(s, i);
            if (x < 0) {
                if (s.charAt(i) == "-" && this.signum() == 0) mi = true;
                continue;
            }
            w = b * w + x;
            if (++j >= cs) {
                this.dMultiply(d);
                this.dAddOffset(w, 0);
                j = 0;
                w = 0;
            }
        }
        if (j > 0) {
            this.dMultiply(Math.pow(b, j));
            this.dAddOffset(w, 0);
        }
        if (mi) BigInteger.ZERO.subTo(this, this);
    };
    // BigInteger.prototype.fromNumber = bnpFromNumber;
    // (protected) alternate constructor
    BigInteger.prototype.fromNumber = function(a, b, c) {
        if ("number" == typeof b) {
            // new BigInteger(int,int,RNG)
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) // force MSB set
                this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), (0, $fX5cY.op_or), this);
                if (this.isEven()) this.dAddOffset(1, 0);
                 // force odd
                while(!this.isProbablePrime(b)){
                    this.dAddOffset(2, 0);
                    if (this.bitLength() > a) this.subTo(BigInteger.ONE.shiftLeft(a - 1), this);
                }
            }
        } else {
            // new BigInteger(int,RNG)
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    };
    // BigInteger.prototype.bitwiseTo = bnpBitwiseTo;
    // (protected) r = this op a (bitwise)
    BigInteger.prototype.bitwiseTo = function(a, op, r) {
        var i;
        var f;
        var m = Math.min(a.t, this.t);
        for(i = 0; i < m; ++i)r[i] = op(this[i], a[i]);
        if (a.t < this.t) {
            f = a.s & this.DM;
            for(i = m; i < this.t; ++i)r[i] = op(this[i], f);
            r.t = this.t;
        } else {
            f = this.s & this.DM;
            for(i = m; i < a.t; ++i)r[i] = op(f, a[i]);
            r.t = a.t;
        }
        r.s = op(this.s, a.s);
        r.clamp();
    };
    // BigInteger.prototype.changeBit = bnpChangeBit;
    // (protected) this op (1<<n)
    BigInteger.prototype.changeBit = function(n, op) {
        var r = BigInteger.ONE.shiftLeft(n);
        this.bitwiseTo(r, op, r);
        return r;
    };
    // BigInteger.prototype.addTo = bnpAddTo;
    // (protected) r = this + a
    BigInteger.prototype.addTo = function(a, r) {
        var i = 0;
        var c = 0;
        var m = Math.min(a.t, this.t);
        while(i < m){
            c += this[i] + a[i];
            r[i++] = c & this.DM;
            c >>= this.DB;
        }
        if (a.t < this.t) {
            c += a.s;
            while(i < this.t){
                c += this[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += this.s;
        } else {
            c += this.s;
            while(i < a.t){
                c += a[i];
                r[i++] = c & this.DM;
                c >>= this.DB;
            }
            c += a.s;
        }
        r.s = c < 0 ? -1 : 0;
        if (c > 0) r[i++] = c;
        else if (c < -1) r[i++] = this.DV + c;
        r.t = i;
        r.clamp();
    };
    // BigInteger.prototype.dMultiply = bnpDMultiply;
    // (protected) this *= n, this >= 0, 1 < n < DV
    BigInteger.prototype.dMultiply = function(n) {
        this[this.t] = this.am(0, n - 1, this, 0, 0, this.t);
        ++this.t;
        this.clamp();
    };
    // BigInteger.prototype.dAddOffset = bnpDAddOffset;
    // (protected) this += n << w words, this >= 0
    BigInteger.prototype.dAddOffset = function(n, w) {
        if (n == 0) return;
        while(this.t <= w)this[this.t++] = 0;
        this[w] += n;
        while(this[w] >= this.DV){
            this[w] -= this.DV;
            if (++w >= this.t) this[this.t++] = 0;
            ++this[w];
        }
    };
    // BigInteger.prototype.multiplyLowerTo = bnpMultiplyLowerTo;
    // (protected) r = lower n words of "this * a", a.t <= n
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyLowerTo = function(a, n, r) {
        var i = Math.min(this.t + a.t, n);
        r.s = 0; // assumes a,this >= 0
        r.t = i;
        while(i > 0)r[--i] = 0;
        for(var j = r.t - this.t; i < j; ++i)r[i + this.t] = this.am(0, a[i], r, i, 0, this.t);
        for(var j = Math.min(a.t, n); i < j; ++i)this.am(0, a[i], r, i, 0, n - i);
        r.clamp();
    };
    // BigInteger.prototype.multiplyUpperTo = bnpMultiplyUpperTo;
    // (protected) r = "this * a" without lower n words, n > 0
    // "this" should be the larger one if appropriate.
    BigInteger.prototype.multiplyUpperTo = function(a, n, r) {
        --n;
        var i = r.t = this.t + a.t - n;
        r.s = 0; // assumes a,this >= 0
        while(--i >= 0)r[i] = 0;
        for(i = Math.max(n - this.t, 0); i < a.t; ++i)r[this.t + i - n] = this.am(n - i, a[i], r, 0, 0, this.t + i - n);
        r.clamp();
        r.drShiftTo(1, r);
    };
    // BigInteger.prototype.modInt = bnpModInt;
    // (protected) this % n, n < 2^26
    BigInteger.prototype.modInt = function(n) {
        if (n <= 0) return 0;
        var d = this.DV % n;
        var r = this.s < 0 ? n - 1 : 0;
        if (this.t > 0) {
            if (d == 0) r = this[0] % n;
            else for(var i = this.t - 1; i >= 0; --i)r = (d * r + this[i]) % n;
        }
        return r;
    };
    // BigInteger.prototype.millerRabin = bnpMillerRabin;
    // (protected) true if probably prime (HAC 4.24, Miller-Rabin)
    BigInteger.prototype.millerRabin = function(t) {
        var n1 = this.subtract(BigInteger.ONE);
        var k = n1.getLowestSetBit();
        if (k <= 0) return false;
        var r = n1.shiftRight(k);
        t = t + 1 >> 1;
        if (t > $e0196cb87958ed77$var$lowprimes.length) t = $e0196cb87958ed77$var$lowprimes.length;
        var a = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        for(var i = 0; i < t; ++i){
            // Pick bases at random, instead of starting at 2
            a.fromInt($e0196cb87958ed77$var$lowprimes[Math.floor(Math.random() * $e0196cb87958ed77$var$lowprimes.length)]);
            var y = a.modPow(r, this);
            if (y.compareTo(BigInteger.ONE) != 0 && y.compareTo(n1) != 0) {
                var j = 1;
                while(j++ < k && y.compareTo(n1) != 0){
                    y = y.modPowInt(2, this);
                    if (y.compareTo(BigInteger.ONE) == 0) return false;
                }
                if (y.compareTo(n1) != 0) return false;
            }
        }
        return true;
    };
    // BigInteger.prototype.square = bnSquare;
    // (public) this^2
    BigInteger.prototype.square = function() {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.squareTo(r);
        return r;
    };
    //#region ASYNC
    // Public API method
    BigInteger.prototype.gcda = function(a, callback) {
        var x = this.s < 0 ? this.negate() : this.clone();
        var y = a.s < 0 ? a.negate() : a.clone();
        if (x.compareTo(y) < 0) {
            var t = x;
            x = y;
            y = t;
        }
        var i = x.getLowestSetBit();
        var g = y.getLowestSetBit();
        if (g < 0) {
            callback(x);
            return;
        }
        if (i < g) g = i;
        if (g > 0) {
            x.rShiftTo(g, x);
            y.rShiftTo(g, y);
        }
        // Workhorse of the algorithm, gets called 200 - 800 times per 512 bit keygen.
        var gcda1 = function gcda11() {
            if ((i = x.getLowestSetBit()) > 0) x.rShiftTo(i, x);
            if ((i = y.getLowestSetBit()) > 0) y.rShiftTo(i, y);
            if (x.compareTo(y) >= 0) {
                x.subTo(y, x);
                x.rShiftTo(1, x);
            } else {
                y.subTo(x, y);
                y.rShiftTo(1, y);
            }
            if (!(x.signum() > 0)) {
                if (g > 0) y.lShiftTo(g, y);
                setTimeout(function() {
                    callback(y);
                }, 0); // escape
            } else setTimeout(gcda1, 0);
        };
        setTimeout(gcda1, 10);
    };
    // (protected) alternate constructor
    BigInteger.prototype.fromNumberAsync = function(a, b, c, callback) {
        if ("number" == typeof b) {
            if (a < 2) this.fromInt(1);
            else {
                this.fromNumber(a, c);
                if (!this.testBit(a - 1)) this.bitwiseTo(BigInteger.ONE.shiftLeft(a - 1), (0, $fX5cY.op_or), this);
                if (this.isEven()) this.dAddOffset(1, 0);
                var bnp_1 = this;
                var bnpfn1_1 = function bnpfn1_11() {
                    bnp_1.dAddOffset(2, 0);
                    if (bnp_1.bitLength() > a) bnp_1.subTo(BigInteger.ONE.shiftLeft(a - 1), bnp_1);
                    if (bnp_1.isProbablePrime(b)) setTimeout(function() {
                        callback();
                    }, 0); // escape
                    else setTimeout(bnpfn1_1, 0);
                };
                setTimeout(bnpfn1_1, 0);
            }
        } else {
            var x = [];
            var t = a & 7;
            x.length = (a >> 3) + 1;
            b.nextBytes(x);
            if (t > 0) x[0] &= (1 << t) - 1;
            else x[0] = 0;
            this.fromString(x, 256);
        }
    };
    return BigInteger;
}();
//#region REDUCERS
//#region NullExp
var $e0196cb87958ed77$var$NullExp = /** @class */ function() {
    function NullExp() {}
    // NullExp.prototype.convert = nNop;
    NullExp.prototype.convert = function(x) {
        return x;
    };
    // NullExp.prototype.revert = nNop;
    NullExp.prototype.revert = function(x) {
        return x;
    };
    // NullExp.prototype.mulTo = nMulTo;
    NullExp.prototype.mulTo = function(x, y, r) {
        x.multiplyTo(y, r);
    };
    // NullExp.prototype.sqrTo = nSqrTo;
    NullExp.prototype.sqrTo = function(x, r) {
        x.squareTo(r);
    };
    return NullExp;
}();
// Modular reduction using "classic" algorithm
var $e0196cb87958ed77$var$Classic = /** @class */ function() {
    function Classic(m) {
        this.m = m;
    }
    // Classic.prototype.convert = cConvert;
    Classic.prototype.convert = function(x) {
        if (x.s < 0 || x.compareTo(this.m) >= 0) return x.mod(this.m);
        else return x;
    };
    // Classic.prototype.revert = cRevert;
    Classic.prototype.revert = function(x) {
        return x;
    };
    // Classic.prototype.reduce = cReduce;
    Classic.prototype.reduce = function(x) {
        x.divRemTo(this.m, null, x);
    };
    // Classic.prototype.mulTo = cMulTo;
    Classic.prototype.mulTo = function(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Classic.prototype.sqrTo = cSqrTo;
    Classic.prototype.sqrTo = function(x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Classic;
}();
//#endregion
//#region Montgomery
// Montgomery reduction
var $e0196cb87958ed77$var$Montgomery = /** @class */ function() {
    function Montgomery(m) {
        this.m = m;
        this.mp = m.invDigit();
        this.mpl = this.mp & 0x7fff;
        this.mph = this.mp >> 15;
        this.um = (1 << m.DB - 15) - 1;
        this.mt2 = 2 * m.t;
    }
    // Montgomery.prototype.convert = montConvert;
    // xR mod m
    Montgomery.prototype.convert = function(x) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        x.abs().dlShiftTo(this.m.t, r);
        r.divRemTo(this.m, null, r);
        if (x.s < 0 && r.compareTo($e0196cb87958ed77$export$1a89ae3627118dd.ZERO) > 0) this.m.subTo(r, r);
        return r;
    };
    // Montgomery.prototype.revert = montRevert;
    // x/R mod m
    Montgomery.prototype.revert = function(x) {
        var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        x.copyTo(r);
        this.reduce(r);
        return r;
    };
    // Montgomery.prototype.reduce = montReduce;
    // x = x/R mod m (HAC 14.32)
    Montgomery.prototype.reduce = function(x) {
        while(x.t <= this.mt2)// pad x so am has enough room later
        x[x.t++] = 0;
        for(var i = 0; i < this.m.t; ++i){
            // faster way of calculating u0 = x[i]*mp mod DV
            var j = x[i] & 0x7fff;
            var u0 = j * this.mpl + ((j * this.mph + (x[i] >> 15) * this.mpl & this.um) << 15) & x.DM;
            // use am to combine the multiply-shift-add into one call
            j = i + this.m.t;
            x[j] += this.m.am(0, u0, x, i, 0, this.m.t);
            // propagate carry
            while(x[j] >= x.DV){
                x[j] -= x.DV;
                x[++j]++;
            }
        }
        x.clamp();
        x.drShiftTo(this.m.t, x);
        if (x.compareTo(this.m) >= 0) x.subTo(this.m, x);
    };
    // Montgomery.prototype.mulTo = montMulTo;
    // r = "xy/R mod m"; x,y != r
    Montgomery.prototype.mulTo = function(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Montgomery.prototype.sqrTo = montSqrTo;
    // r = "x^2/R mod m"; x != r
    Montgomery.prototype.sqrTo = function(x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Montgomery;
}();
//#endregion Montgomery
//#region Barrett
// Barrett modular reduction
var $e0196cb87958ed77$var$Barrett = /** @class */ function() {
    function Barrett(m) {
        this.m = m;
        // setup Barrett
        this.r2 = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        this.q3 = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
        $e0196cb87958ed77$export$1a89ae3627118dd.ONE.dlShiftTo(2 * m.t, this.r2);
        this.mu = this.r2.divide(m);
    }
    // Barrett.prototype.convert = barrettConvert;
    Barrett.prototype.convert = function(x) {
        if (x.s < 0 || x.t > 2 * this.m.t) return x.mod(this.m);
        else if (x.compareTo(this.m) < 0) return x;
        else {
            var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
            x.copyTo(r);
            this.reduce(r);
            return r;
        }
    };
    // Barrett.prototype.revert = barrettRevert;
    Barrett.prototype.revert = function(x) {
        return x;
    };
    // Barrett.prototype.reduce = barrettReduce;
    // x = x mod m (HAC 14.42)
    Barrett.prototype.reduce = function(x) {
        x.drShiftTo(this.m.t - 1, this.r2);
        if (x.t > this.m.t + 1) {
            x.t = this.m.t + 1;
            x.clamp();
        }
        this.mu.multiplyUpperTo(this.r2, this.m.t + 1, this.q3);
        this.m.multiplyLowerTo(this.q3, this.m.t + 1, this.r2);
        while(x.compareTo(this.r2) < 0)x.dAddOffset(1, this.m.t + 1);
        x.subTo(this.r2, x);
        while(x.compareTo(this.m) >= 0)x.subTo(this.m, x);
    };
    // Barrett.prototype.mulTo = barrettMulTo;
    // r = x*y mod m; x,y != r
    Barrett.prototype.mulTo = function(x, y, r) {
        x.multiplyTo(y, r);
        this.reduce(r);
    };
    // Barrett.prototype.sqrTo = barrettSqrTo;
    // r = x^2 mod m; x != r
    Barrett.prototype.sqrTo = function(x, r) {
        x.squareTo(r);
        this.reduce(r);
    };
    return Barrett;
}();
function $e0196cb87958ed77$export$2d5871c2be9bf1cc() {
    return new $e0196cb87958ed77$export$1a89ae3627118dd(null);
}
function $e0196cb87958ed77$export$76f8b5ba27b3a9fe(str, r) {
    return new $e0196cb87958ed77$export$1a89ae3627118dd(str, r);
}
// am: Compute w_j += (x*this_i), propagate carries,
// c is initial carry, returns final carry.
// c < 3*dvalue, x < 2*dvalue, this_i < dvalue
// We need to select the fastest one that works in this environment.
var $e0196cb87958ed77$var$inBrowser = typeof navigator !== "undefined";
if ($e0196cb87958ed77$var$inBrowser && $e0196cb87958ed77$var$j_lm && navigator.appName == "Microsoft Internet Explorer") {
    // am2 avoids a big mult-and-extract completely.
    // Max digit bits should be <= 30 because we do bitwise ops
    // on values up to 2*hdvalue^2-hdvalue-1 (< 2^31)
    $e0196cb87958ed77$export$1a89ae3627118dd.prototype.am = function am2(i, x, w, j, c, n) {
        var xl = x & 0x7fff;
        var xh = x >> 15;
        while(--n >= 0){
            var l = this[i] & 0x7fff;
            var h = this[i++] >> 15;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x7fff) << 15) + w[j] + (c & 0x3fffffff);
            c = (l >>> 30) + (m >>> 15) + xh * h + (c >>> 30);
            w[j++] = l & 0x3fffffff;
        }
        return c;
    };
    $e0196cb87958ed77$var$dbits = 30;
} else if ($e0196cb87958ed77$var$inBrowser && $e0196cb87958ed77$var$j_lm && navigator.appName != "Netscape") {
    // am1: use a single mult and divide to get the high bits,
    // max digit bits should be 26 because
    // max internal value = 2*dvalue^2-2*dvalue (< 2^53)
    $e0196cb87958ed77$export$1a89ae3627118dd.prototype.am = function am1(i, x, w, j, c, n) {
        while(--n >= 0){
            var v = x * this[i++] + w[j] + c;
            c = Math.floor(v / 0x4000000);
            w[j++] = v & 0x3ffffff;
        }
        return c;
    };
    $e0196cb87958ed77$var$dbits = 26;
} else {
    // Alternately, set max digit bits to 28 since some
    // browsers slow down when dealing with 32-bit numbers.
    $e0196cb87958ed77$export$1a89ae3627118dd.prototype.am = function am3(i, x, w, j, c, n) {
        var xl = x & 0x3fff;
        var xh = x >> 14;
        while(--n >= 0){
            var l = this[i] & 0x3fff;
            var h = this[i++] >> 14;
            var m = xh * l + h * xl;
            l = xl * l + ((m & 0x3fff) << 14) + w[j] + c;
            c = (l >> 28) + (m >> 14) + xh * h;
            w[j++] = l & 0xfffffff;
        }
        return c;
    };
    $e0196cb87958ed77$var$dbits = 28;
}
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.DB = $e0196cb87958ed77$var$dbits;
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.DM = (1 << $e0196cb87958ed77$var$dbits) - 1;
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.DV = 1 << $e0196cb87958ed77$var$dbits;
var $e0196cb87958ed77$var$BI_FP = 52;
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.FV = Math.pow(2, $e0196cb87958ed77$var$BI_FP);
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.F1 = $e0196cb87958ed77$var$BI_FP - $e0196cb87958ed77$var$dbits;
$e0196cb87958ed77$export$1a89ae3627118dd.prototype.F2 = 2 * $e0196cb87958ed77$var$dbits - $e0196cb87958ed77$var$BI_FP;
// Digit conversions
var $e0196cb87958ed77$var$BI_RC = [];
var $e0196cb87958ed77$var$rr;
var $e0196cb87958ed77$var$vv;
$e0196cb87958ed77$var$rr = "0".charCodeAt(0);
for($e0196cb87958ed77$var$vv = 0; $e0196cb87958ed77$var$vv <= 9; ++$e0196cb87958ed77$var$vv)$e0196cb87958ed77$var$BI_RC[$e0196cb87958ed77$var$rr++] = $e0196cb87958ed77$var$vv;
$e0196cb87958ed77$var$rr = "a".charCodeAt(0);
for($e0196cb87958ed77$var$vv = 10; $e0196cb87958ed77$var$vv < 36; ++$e0196cb87958ed77$var$vv)$e0196cb87958ed77$var$BI_RC[$e0196cb87958ed77$var$rr++] = $e0196cb87958ed77$var$vv;
$e0196cb87958ed77$var$rr = "A".charCodeAt(0);
for($e0196cb87958ed77$var$vv = 10; $e0196cb87958ed77$var$vv < 36; ++$e0196cb87958ed77$var$vv)$e0196cb87958ed77$var$BI_RC[$e0196cb87958ed77$var$rr++] = $e0196cb87958ed77$var$vv;
function $e0196cb87958ed77$export$a834e31db7253a52(s, i) {
    var c = $e0196cb87958ed77$var$BI_RC[s.charCodeAt(i)];
    return c == null ? -1 : c;
}
function $e0196cb87958ed77$export$e4391d84a4602ee3(i) {
    var r = $e0196cb87958ed77$export$2d5871c2be9bf1cc();
    r.fromInt(i);
    return r;
}
function $e0196cb87958ed77$export$61f715936f8a3c(x) {
    var r = 1;
    var t;
    if ((t = x >>> 16) != 0) {
        x = t;
        r += 16;
    }
    if ((t = x >> 8) != 0) {
        x = t;
        r += 8;
    }
    if ((t = x >> 4) != 0) {
        x = t;
        r += 4;
    }
    if ((t = x >> 2) != 0) {
        x = t;
        r += 2;
    }
    if ((t = x >> 1) != 0) {
        x = t;
        r += 1;
    }
    return r;
}
// "constants"
$e0196cb87958ed77$export$1a89ae3627118dd.ZERO = $e0196cb87958ed77$export$e4391d84a4602ee3(0);
$e0196cb87958ed77$export$1a89ae3627118dd.ONE = $e0196cb87958ed77$export$e4391d84a4602ee3(1);

});

parcelRegister("feMev", function(module, exports) {

$parcel$export(module.exports, "SecureRandom", function () { return $b17d93de5826ce93$export$f3b03d0edd9563f3; });
// Random number generator - requires a PRNG backend, e.g. prng4.js

var $h12rn = parcelRequire("h12rn");
var $b17d93de5826ce93$var$rng_state;
var $b17d93de5826ce93$var$rng_pool = null;
var $b17d93de5826ce93$var$rng_pptr;
// Initialize the pool with junk if needed.
if ($b17d93de5826ce93$var$rng_pool == null) {
    $b17d93de5826ce93$var$rng_pool = [];
    $b17d93de5826ce93$var$rng_pptr = 0;
    var $b17d93de5826ce93$var$t = void 0;
    if (typeof window !== 'undefined' && window.crypto && window.crypto.getRandomValues) {
        // Extract entropy (2048 bits) from RNG if available
        var $b17d93de5826ce93$var$z = new Uint32Array(256);
        window.crypto.getRandomValues($b17d93de5826ce93$var$z);
        for($b17d93de5826ce93$var$t = 0; $b17d93de5826ce93$var$t < $b17d93de5826ce93$var$z.length; ++$b17d93de5826ce93$var$t)$b17d93de5826ce93$var$rng_pool[$b17d93de5826ce93$var$rng_pptr++] = $b17d93de5826ce93$var$z[$b17d93de5826ce93$var$t] & 255;
    }
    // Use mouse events for entropy, if we do not have enough entropy by the time
    // we need it, entropy will be generated by Math.random.
    var $b17d93de5826ce93$var$count = 0;
    var $b17d93de5826ce93$var$onMouseMoveListener_1 = function onMouseMoveListener_11(ev) {
        $b17d93de5826ce93$var$count = $b17d93de5826ce93$var$count || 0;
        if ($b17d93de5826ce93$var$count >= 256 || $b17d93de5826ce93$var$rng_pptr >= (0, $h12rn.rng_psize)) {
            if (window.removeEventListener) window.removeEventListener("mousemove", $b17d93de5826ce93$var$onMouseMoveListener_1, false);
            else if (window.detachEvent) window.detachEvent("onmousemove", $b17d93de5826ce93$var$onMouseMoveListener_1);
            return;
        }
        try {
            var mouseCoordinates = ev.x + ev.y;
            $b17d93de5826ce93$var$rng_pool[$b17d93de5826ce93$var$rng_pptr++] = mouseCoordinates & 255;
            $b17d93de5826ce93$var$count += 1;
        } catch (e) {
        // Sometimes Firefox will deny permission to access event properties for some reason. Ignore.
        }
    };
    if (typeof window !== 'undefined') {
        if (window.addEventListener) window.addEventListener("mousemove", $b17d93de5826ce93$var$onMouseMoveListener_1, false);
        else if (window.attachEvent) window.attachEvent("onmousemove", $b17d93de5826ce93$var$onMouseMoveListener_1);
    }
}
function $b17d93de5826ce93$var$rng_get_byte() {
    if ($b17d93de5826ce93$var$rng_state == null) {
        $b17d93de5826ce93$var$rng_state = (0, $h12rn.prng_newstate)();
        // At this point, we may not have collected enough entropy.  If not, fall back to Math.random
        while($b17d93de5826ce93$var$rng_pptr < (0, $h12rn.rng_psize)){
            var random = Math.floor(65536 * Math.random());
            $b17d93de5826ce93$var$rng_pool[$b17d93de5826ce93$var$rng_pptr++] = random & 255;
        }
        $b17d93de5826ce93$var$rng_state.init($b17d93de5826ce93$var$rng_pool);
        for($b17d93de5826ce93$var$rng_pptr = 0; $b17d93de5826ce93$var$rng_pptr < $b17d93de5826ce93$var$rng_pool.length; ++$b17d93de5826ce93$var$rng_pptr)$b17d93de5826ce93$var$rng_pool[$b17d93de5826ce93$var$rng_pptr] = 0;
        $b17d93de5826ce93$var$rng_pptr = 0;
    }
    // TODO: allow reseeding after first request
    return $b17d93de5826ce93$var$rng_state.next();
}
var $b17d93de5826ce93$export$f3b03d0edd9563f3 = /** @class */ function() {
    function SecureRandom() {}
    SecureRandom.prototype.nextBytes = function(ba) {
        for(var i = 0; i < ba.length; ++i)ba[i] = $b17d93de5826ce93$var$rng_get_byte();
    };
    return SecureRandom;
}();

});
parcelRegister("h12rn", function(module, exports) {

$parcel$export(module.exports, "prng_newstate", function () { return $c6346c4d76b087cf$export$13c72b461ef276a4; });
$parcel$export(module.exports, "rng_psize", function () { return $c6346c4d76b087cf$export$978cccef6bf607dc; });
// prng4.js - uses Arcfour as a PRNG
var $c6346c4d76b087cf$export$41602e5205978337 = /** @class */ function() {
    function Arcfour() {
        this.i = 0;
        this.j = 0;
        this.S = [];
    }
    // Arcfour.prototype.init = ARC4init;
    // Initialize arcfour context from key, an array of ints, each from [0..255]
    Arcfour.prototype.init = function(key) {
        var i;
        var j;
        var t;
        for(i = 0; i < 256; ++i)this.S[i] = i;
        j = 0;
        for(i = 0; i < 256; ++i){
            j = j + this.S[i] + key[i % key.length] & 255;
            t = this.S[i];
            this.S[i] = this.S[j];
            this.S[j] = t;
        }
        this.i = 0;
        this.j = 0;
    };
    // Arcfour.prototype.next = ARC4next;
    Arcfour.prototype.next = function() {
        var t;
        this.i = this.i + 1 & 255;
        this.j = this.j + this.S[this.i] & 255;
        t = this.S[this.i];
        this.S[this.i] = this.S[this.j];
        this.S[this.j] = t;
        return this.S[t + this.S[this.i] & 255];
    };
    return Arcfour;
}();
function $c6346c4d76b087cf$export$13c72b461ef276a4() {
    return new $c6346c4d76b087cf$export$41602e5205978337();
}
var $c6346c4d76b087cf$export$978cccef6bf607dc = 256;

});



parcelRegister("337XS", function(module, exports) {

$parcel$export(module.exports, "KJUR", function () { return $2387d48cc83047d7$export$eeb0cac846251be6; });
/* asn1-1.0.13.js (c) 2013-2017 Kenji Urushima | kjur.github.com/jsrsasign/license
 */ /*
 * asn1.js - ASN.1 DER encoder classes
 *
 * Copyright (c) 2013-2017 Kenji Urushima (kenji.urushima@gmail.com)
 *
 * This software is licensed under the terms of the MIT License.
 * https://kjur.github.io/jsrsasign/license
 *
 * The above copyright and license notice shall be
 * included in all copies or substantial portions of the Software.
 */ 
var $jeSh1 = parcelRequire("jeSh1");

var $16Yry = parcelRequire("16Yry");
var $2387d48cc83047d7$export$eeb0cac846251be6 = {};
/**
 * kjur's ASN.1 class library name space
 * <p>
 * This is ITU-T X.690 ASN.1 DER encoder class library and
 * class structure and methods is very similar to
 * org.bouncycastle.asn1 package of
 * well known BouncyCaslte Cryptography Library.
 * <h4>PROVIDING ASN.1 PRIMITIVES</h4>
 * Here are ASN.1 DER primitive classes.
 * <ul>
 * <li>0x01 {@link KJUR.asn1.DERBoolean}</li>
 * <li>0x02 {@link KJUR.asn1.DERInteger}</li>
 * <li>0x03 {@link KJUR.asn1.DERBitString}</li>
 * <li>0x04 {@link KJUR.asn1.DEROctetString}</li>
 * <li>0x05 {@link KJUR.asn1.DERNull}</li>
 * <li>0x06 {@link KJUR.asn1.DERObjectIdentifier}</li>
 * <li>0x0a {@link KJUR.asn1.DEREnumerated}</li>
 * <li>0x0c {@link KJUR.asn1.DERUTF8String}</li>
 * <li>0x12 {@link KJUR.asn1.DERNumericString}</li>
 * <li>0x13 {@link KJUR.asn1.DERPrintableString}</li>
 * <li>0x14 {@link KJUR.asn1.DERTeletexString}</li>
 * <li>0x16 {@link KJUR.asn1.DERIA5String}</li>
 * <li>0x17 {@link KJUR.asn1.DERUTCTime}</li>
 * <li>0x18 {@link KJUR.asn1.DERGeneralizedTime}</li>
 * <li>0x30 {@link KJUR.asn1.DERSequence}</li>
 * <li>0x31 {@link KJUR.asn1.DERSet}</li>
 * </ul>
 * <h4>OTHER ASN.1 CLASSES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.ASN1Object}</li>
 * <li>{@link KJUR.asn1.DERAbstractString}</li>
 * <li>{@link KJUR.asn1.DERAbstractTime}</li>
 * <li>{@link KJUR.asn1.DERAbstractStructured}</li>
 * <li>{@link KJUR.asn1.DERTaggedObject}</li>
 * </ul>
 * <h4>SUB NAME SPACES</h4>
 * <ul>
 * <li>{@link KJUR.asn1.cades} - CAdES long term signature format</li>
 * <li>{@link KJUR.asn1.cms} - Cryptographic Message Syntax</li>
 * <li>{@link KJUR.asn1.csr} - Certificate Signing Request (CSR/PKCS#10)</li>
 * <li>{@link KJUR.asn1.tsp} - RFC 3161 Timestamping Protocol Format</li>
 * <li>{@link KJUR.asn1.x509} - RFC 5280 X.509 certificate and CRL</li>
 * </ul>
 * </p>
 * NOTE: Please ignore method summary and document of this namespace.
 * This caused by a bug of jsdoc2.
 * @name KJUR.asn1
 * @namespace
 */ if (typeof $2387d48cc83047d7$export$eeb0cac846251be6.asn1 == "undefined" || !$2387d48cc83047d7$export$eeb0cac846251be6.asn1) $2387d48cc83047d7$export$eeb0cac846251be6.asn1 = {};
/**
 * ASN1 utilities class
 * @name KJUR.asn1.ASN1Util
 * @class ASN1 utilities class
 * @since asn1 1.0.2
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util = new function() {
    this.integerToByteHex = function(i) {
        var h = i.toString(16);
        if (h.length % 2 == 1) h = '0' + h;
        return h;
    };
    this.bigIntToMinTwosComplementsHex = function(bigIntegerValue) {
        var h = bigIntegerValue.toString(16);
        if (h.substr(0, 1) != '-') {
            if (h.length % 2 == 1) h = '0' + h;
            else if (!h.match(/^[0-7]/)) h = '00' + h;
        } else {
            var hPos = h.substr(1);
            var xorLen = hPos.length;
            if (xorLen % 2 == 1) xorLen += 1;
            else if (!h.match(/^[0-7]/)) xorLen += 2;
            var hMask = '';
            for(var i = 0; i < xorLen; i++)hMask += 'f';
            var biMask = new (0, $jeSh1.BigInteger)(hMask, 16);
            var biNeg = biMask.xor(bigIntegerValue).add((0, $jeSh1.BigInteger).ONE);
            h = biNeg.toString(16).replace(/^-/, '');
        }
        return h;
    };
    /**
     * get PEM string from hexadecimal data and header string
     * @name getPEMStringFromHex
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {String} dataHex hexadecimal string of PEM body
     * @param {String} pemHeader PEM header string (ex. 'RSA PRIVATE KEY')
     * @return {String} PEM formatted string of input data
     * @description
     * This method converts a hexadecimal string to a PEM string with
     * a specified header. Its line break will be CRLF("\r\n").
     * @example
     * var pem  = KJUR.asn1.ASN1Util.getPEMStringFromHex('616161', 'RSA PRIVATE KEY');
     * // value of pem will be:
     * -----BEGIN PRIVATE KEY-----
     * YWFh
     * -----END PRIVATE KEY-----
     */ this.getPEMStringFromHex = function(dataHex, pemHeader) {
        return hextopem(dataHex, pemHeader);
    };
    /**
     * generate ASN1Object specifed by JSON parameters
     * @name newObject
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return {KJUR.asn1.ASN1Object} generated object
     * @since asn1 1.0.3
     * @description
     * generate any ASN1Object specified by JSON param
     * including ASN.1 primitive or structured.
     * Generally 'param' can be described as follows:
     * <blockquote>
     * {TYPE-OF-ASNOBJ: ASN1OBJ-PARAMETER}
     * </blockquote>
     * 'TYPE-OF-ASN1OBJ' can be one of following symbols:
     * <ul>
     * <li>'bool' - DERBoolean</li>
     * <li>'int' - DERInteger</li>
     * <li>'bitstr' - DERBitString</li>
     * <li>'octstr' - DEROctetString</li>
     * <li>'null' - DERNull</li>
     * <li>'oid' - DERObjectIdentifier</li>
     * <li>'enum' - DEREnumerated</li>
     * <li>'utf8str' - DERUTF8String</li>
     * <li>'numstr' - DERNumericString</li>
     * <li>'prnstr' - DERPrintableString</li>
     * <li>'telstr' - DERTeletexString</li>
     * <li>'ia5str' - DERIA5String</li>
     * <li>'utctime' - DERUTCTime</li>
     * <li>'gentime' - DERGeneralizedTime</li>
     * <li>'seq' - DERSequence</li>
     * <li>'set' - DERSet</li>
     * <li>'tag' - DERTaggedObject</li>
     * </ul>
     * @example
     * newObject({'prnstr': 'aaa'});
     * newObject({'seq': [{'int': 3}, {'prnstr': 'aaa'}]})
     * // ASN.1 Tagged Object
     * newObject({'tag': {'tag': 'a1',
     *                    'explicit': true,
     *                    'obj': {'seq': [{'int': 3}, {'prnstr': 'aaa'}]}}});
     * // more simple representation of ASN.1 Tagged Object
     * newObject({'tag': ['a1',
     *                    true,
     *                    {'seq': [
     *                      {'int': 3},
     *                      {'prnstr': 'aaa'}]}
     *                   ]});
     */ this.newObject = function(param) {
        var _KJUR = $2387d48cc83047d7$export$eeb0cac846251be6, _KJUR_asn1 = _KJUR.asn1, _DERBoolean = _KJUR_asn1.DERBoolean, _DERInteger = _KJUR_asn1.DERInteger, _DERBitString = _KJUR_asn1.DERBitString, _DEROctetString = _KJUR_asn1.DEROctetString, _DERNull = _KJUR_asn1.DERNull, _DERObjectIdentifier = _KJUR_asn1.DERObjectIdentifier, _DEREnumerated = _KJUR_asn1.DEREnumerated, _DERUTF8String = _KJUR_asn1.DERUTF8String, _DERNumericString = _KJUR_asn1.DERNumericString, _DERPrintableString = _KJUR_asn1.DERPrintableString, _DERTeletexString = _KJUR_asn1.DERTeletexString, _DERIA5String = _KJUR_asn1.DERIA5String, _DERUTCTime = _KJUR_asn1.DERUTCTime, _DERGeneralizedTime = _KJUR_asn1.DERGeneralizedTime, _DERSequence = _KJUR_asn1.DERSequence, _DERSet = _KJUR_asn1.DERSet, _DERTaggedObject = _KJUR_asn1.DERTaggedObject, _newObject = _KJUR_asn1.ASN1Util.newObject;
        var keys = Object.keys(param);
        if (keys.length != 1) throw "key of param shall be only one.";
        var key = keys[0];
        if (":bool:int:bitstr:octstr:null:oid:enum:utf8str:numstr:prnstr:telstr:ia5str:utctime:gentime:seq:set:tag:".indexOf(":" + key + ":") == -1) throw "undefined key: " + key;
        if (key == "bool") return new _DERBoolean(param[key]);
        if (key == "int") return new _DERInteger(param[key]);
        if (key == "bitstr") return new _DERBitString(param[key]);
        if (key == "octstr") return new _DEROctetString(param[key]);
        if (key == "null") return new _DERNull(param[key]);
        if (key == "oid") return new _DERObjectIdentifier(param[key]);
        if (key == "enum") return new _DEREnumerated(param[key]);
        if (key == "utf8str") return new _DERUTF8String(param[key]);
        if (key == "numstr") return new _DERNumericString(param[key]);
        if (key == "prnstr") return new _DERPrintableString(param[key]);
        if (key == "telstr") return new _DERTeletexString(param[key]);
        if (key == "ia5str") return new _DERIA5String(param[key]);
        if (key == "utctime") return new _DERUTCTime(param[key]);
        if (key == "gentime") return new _DERGeneralizedTime(param[key]);
        if (key == "seq") {
            var paramList = param[key];
            var a = [];
            for(var i = 0; i < paramList.length; i++){
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSequence({
                'array': a
            });
        }
        if (key == "set") {
            var paramList = param[key];
            var a = [];
            for(var i = 0; i < paramList.length; i++){
                var asn1Obj = _newObject(paramList[i]);
                a.push(asn1Obj);
            }
            return new _DERSet({
                'array': a
            });
        }
        if (key == "tag") {
            var tagParam = param[key];
            if (Object.prototype.toString.call(tagParam) === '[object Array]' && tagParam.length == 3) {
                var obj = _newObject(tagParam[2]);
                return new _DERTaggedObject({
                    tag: tagParam[0],
                    explicit: tagParam[1],
                    obj: obj
                });
            } else {
                var newParam = {};
                if (tagParam.explicit !== undefined) newParam.explicit = tagParam.explicit;
                if (tagParam.tag !== undefined) newParam.tag = tagParam.tag;
                if (tagParam.obj === undefined) throw "obj shall be specified for 'tag'.";
                newParam.obj = _newObject(tagParam.obj);
                return new _DERTaggedObject(newParam);
            }
        }
    };
    /**
     * get encoded hexadecimal string of ASN1Object specifed by JSON parameters
     * @name jsonToASN1HEX
     * @memberOf KJUR.asn1.ASN1Util
     * @function
     * @param {Array} param JSON parameter to generate ASN1Object
     * @return hexadecimal string of ASN1Object
     * @since asn1 1.0.4
     * @description
     * As for ASN.1 object representation of JSON object,
     * please see {@link newObject}.
     * @example
     * jsonToASN1HEX({'prnstr': 'aaa'});
     */ this.jsonToASN1HEX = function(param) {
        var asn1Obj = this.newObject(param);
        return asn1Obj.getEncodedHex();
    };
};
/**
 * get dot noted oid number string from hexadecimal value of OID
 * @name oidHexToInt
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} hex hexadecimal value of object identifier
 * @return {String} dot noted string of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from hexadecimal string representation of
 * ASN.1 value of object identifier to oid number string.
 * @example
 * KJUR.asn1.ASN1Util.oidHexToInt('550406') &rarr; "2.5.4.6"
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.oidHexToInt = function(hex) {
    var s = "";
    var i01 = parseInt(hex.substr(0, 2), 16);
    var i0 = Math.floor(i01 / 40);
    var i1 = i01 % 40;
    var s = i0 + "." + i1;
    var binbuf = "";
    for(var i = 2; i < hex.length; i += 2){
        var value = parseInt(hex.substr(i, 2), 16);
        var bin = ("00000000" + value.toString(2)).slice(-8);
        binbuf = binbuf + bin.substr(1, 7);
        if (bin.substr(0, 1) == "0") {
            var bi = new (0, $jeSh1.BigInteger)(binbuf, 2);
            s = s + "." + bi.toString(10);
            binbuf = "";
        }
    }
    return s;
};
/**
 * get hexadecimal value of object identifier from dot noted oid value
 * @name oidIntToHex
 * @memberOf KJUR.asn1.ASN1Util
 * @function
 * @param {String} oidString dot noted string of object identifier
 * @return {String} hexadecimal value of object identifier
 * @since jsrsasign 4.8.3 asn1 1.0.7
 * @description
 * This static method converts from object identifier value string.
 * to hexadecimal string representation of it.
 * @example
 * KJUR.asn1.ASN1Util.oidIntToHex("2.5.4.6") &rarr; "550406"
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.oidIntToHex = function(oidString) {
    var itox = function itox(i) {
        var h = i.toString(16);
        if (h.length == 1) h = '0' + h;
        return h;
    };
    var roidtox = function roidtox(roid) {
        var h = '';
        var bi = new (0, $jeSh1.BigInteger)(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7) padLen = 0;
        var bPad = '';
        for(var i = 0; i < padLen; i++)bPad += '0';
        b = bPad + b;
        for(var i = 0; i < b.length - 1; i += 7){
            var b8 = b.substr(i, 7);
            if (i != b.length - 7) b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    if (!oidString.match(/^[0-9.]+$/)) throw "malformed oid string: " + oidString;
    var h = '';
    var a = oidString.split('.');
    var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
    h += itox(i0);
    a.splice(0, 2);
    for(var i = 0; i < a.length; i++)h += roidtox(a[i]);
    return h;
};
// ********************************************************************
//  Abstract ASN.1 Classes
// ********************************************************************
// ********************************************************************
/**
 * base class for ASN.1 DER encoder object
 * @name KJUR.asn1.ASN1Object
 * @class base class for ASN.1 DER encoder object
 * @property {Boolean} isModified flag whether internal data was changed
 * @property {String} hTLV hexadecimal string of ASN.1 TLV
 * @property {String} hT hexadecimal string of ASN.1 TLV tag(T)
 * @property {String} hL hexadecimal string of ASN.1 TLV length(L)
 * @property {String} hV hexadecimal string of ASN.1 TLV value(V)
 * @description
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object = function() {
    var isModified = true;
    var hTLV = null;
    var hT = '00';
    var hL = '00';
    var hV = '';
    /**
     * get hexadecimal ASN.1 TLV length(L) bytes from TLV value(V)
     * @name getLengthHexFromValue
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV length(L)
     */ this.getLengthHexFromValue = function() {
        if (typeof this.hV == "undefined" || this.hV == null) throw "this.hV is null or undefined.";
        if (this.hV.length % 2 == 1) throw "value hex must be even length: n=" + hV.length + ",v=" + this.hV;
        var n = this.hV.length / 2;
        var hN = n.toString(16);
        if (hN.length % 2 == 1) hN = "0" + hN;
        if (n < 128) return hN;
        else {
            var hNlen = hN.length / 2;
            if (hNlen > 15) throw "ASN.1 length too long to represent by 8x: n = " + n.toString(16);
            var head = 128 + hNlen;
            return head.toString(16) + hN;
        }
    };
    /**
     * get hexadecimal string of ASN.1 TLV bytes
     * @name getEncodedHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV
     */ this.getEncodedHex = function() {
        if (this.hTLV == null || this.isModified) {
            this.hV = this.getFreshValueHex();
            this.hL = this.getLengthHexFromValue();
            this.hTLV = this.hT + this.hL + this.hV;
            this.isModified = false;
        //alert("first time: " + this.hTLV);
        }
        return this.hTLV;
    };
    /**
     * get hexadecimal string of ASN.1 TLV value(V) bytes
     * @name getValueHex
     * @memberOf KJUR.asn1.ASN1Object#
     * @function
     * @return {String} hexadecimal string of ASN.1 TLV value(V) bytes
     */ this.getValueHex = function() {
        this.getEncodedHex();
        return this.hV;
    };
    this.getFreshValueHex = function() {
        return '';
    };
};
// == BEGIN DERAbstractString ================================================
/**
 * base class for ASN.1 DER string classes
 * @name KJUR.asn1.DERAbstractString
 * @class base class for ASN.1 DER string classes
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @property {String} s internal string of value
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString.superclass.constructor.call(this);
    var s = null;
    var hV = null;
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @return {String} string value of this string object
     */ this.getString = function() {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newS value by a string to set
     */ this.setString = function(newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(this.s);
    };
    /**
     * set value by a hexadecimal string
     * @name setStringHex
     * @memberOf KJUR.asn1.DERAbstractString#
     * @function
     * @param {String} newHexString value by a hexadecimal string to set
     */ this.setStringHex = function(newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string") this.setString(params);
        else if (typeof params['str'] != "undefined") this.setString(params['str']);
        else if (typeof params['hex'] != "undefined") this.setStringHex(params['hex']);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// == END   DERAbstractString ================================================
// == BEGIN DERAbstractTime ==================================================
/**
 * base class for ASN.1 DER Generalized/UTCTime class
 * @name KJUR.asn1.DERAbstractTime
 * @class base class for ASN.1 DER Generalized/UTCTime class
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractTime = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractTime.superclass.constructor.call(this);
    var s = null;
    var date = null;
    // --- PRIVATE METHODS --------------------
    this.localDateToUTC = function(d) {
        utc = d.getTime() + d.getTimezoneOffset() * 60000;
        var utcDate = new Date(utc);
        return utcDate;
    };
    /*
     * format date string by Data object
     * @name formatDate
     * @memberOf KJUR.asn1.AbstractTime;
     * @param {Date} dateObject
     * @param {string} type 'utc' or 'gen'
     * @param {boolean} withMillis flag for with millisections or not
     * @description
     * 'withMillis' flag is supported from asn1 1.0.6.
     */ this.formatDate = function(dateObject, type, withMillis) {
        var pad = this.zeroPadding;
        var d = this.localDateToUTC(dateObject);
        var year = String(d.getFullYear());
        if (type == 'utc') year = year.substr(2, 2);
        var month = pad(String(d.getMonth() + 1), 2);
        var day = pad(String(d.getDate()), 2);
        var hour = pad(String(d.getHours()), 2);
        var min = pad(String(d.getMinutes()), 2);
        var sec = pad(String(d.getSeconds()), 2);
        var s = year + month + day + hour + min + sec;
        if (withMillis === true) {
            var millis = d.getMilliseconds();
            if (millis != 0) {
                var sMillis = pad(String(millis), 3);
                sMillis = sMillis.replace(/[0]+$/, "");
                s = s + "." + sMillis;
            }
        }
        return s + "Z";
    };
    this.zeroPadding = function(s, len) {
        if (s.length >= len) return s;
        return new Array(len - s.length + 1).join('0') + s;
    };
    // --- PUBLIC METHODS --------------------
    /**
     * get string value of this string object
     * @name getString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @return {String} string value of this time object
     */ this.getString = function() {
        return this.s;
    };
    /**
     * set value by a string
     * @name setString
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {String} newS value by a string to set such like "130430235959Z"
     */ this.setString = function(newS) {
        this.hTLV = null;
        this.isModified = true;
        this.s = newS;
        this.hV = stohex(newS);
    };
    /**
     * set value by a Date object
     * @name setByDateValue
     * @memberOf KJUR.asn1.DERAbstractTime#
     * @function
     * @param {Integer} year year of date (ex. 2013)
     * @param {Integer} month month of date between 1 and 12 (ex. 12)
     * @param {Integer} day day of month
     * @param {Integer} hour hours of date
     * @param {Integer} min minutes of date
     * @param {Integer} sec seconds of date
     */ this.setByDateValue = function(year, month, day, hour, min, sec) {
        var dateObject = new Date(Date.UTC(year, month - 1, day, hour, min, sec, 0));
        this.setByDate(dateObject);
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractTime, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// == END   DERAbstractTime ==================================================
// == BEGIN DERAbstractStructured ============================================
/**
 * base class for ASN.1 DER structured class
 * @name KJUR.asn1.DERAbstractStructured
 * @class base class for ASN.1 DER structured class
 * @property {Array} asn1Array internal array of ASN1Object
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractStructured = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString.superclass.constructor.call(this);
    var asn1Array = null;
    /**
     * set value by array of ASN1Object
     * @name setByASN1ObjectArray
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {array} asn1ObjectArray array of ASN1Object to set
     */ this.setByASN1ObjectArray = function(asn1ObjectArray) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array = asn1ObjectArray;
    };
    /**
     * append an ASN1Object to internal array
     * @name appendASN1Object
     * @memberOf KJUR.asn1.DERAbstractStructured#
     * @function
     * @param {ASN1Object} asn1Object to add
     */ this.appendASN1Object = function(asn1Object) {
        this.hTLV = null;
        this.isModified = true;
        this.asn1Array.push(asn1Object);
    };
    this.asn1Array = new Array();
    if (typeof params != "undefined") {
        if (typeof params['array'] != "undefined") this.asn1Array = params['array'];
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractStructured, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
//  ASN.1 Object Classes
// ********************************************************************
// ********************************************************************
/**
 * class for ASN.1 DER Boolean
 * @name KJUR.asn1.DERBoolean
 * @class class for ASN.1 DER Boolean
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBoolean = function() {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBoolean.superclass.constructor.call(this);
    this.hT = "01";
    this.hTLV = "0101ff";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBoolean, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Integer
 * @name KJUR.asn1.DERInteger
 * @class class for ASN.1 DER Integer
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>bigint - specify initial ASN.1 value(V) by BigInteger object</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERInteger = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERInteger.superclass.constructor.call(this);
    this.hT = "02";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */ this.setByBigInteger = function(bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DERInteger
     * @function
     * @param {Integer} integer value to set
     */ this.setByInteger = function(intValue) {
        var bi = new (0, $jeSh1.BigInteger)(String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DERInteger#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     * @example
     * new KJUR.asn1.DERInteger(123);
     * new KJUR.asn1.DERInteger({'int': 123});
     * new KJUR.asn1.DERInteger({'hex': '1fad'});
     */ this.setValueHex = function(newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['bigint'] != "undefined") this.setByBigInteger(params['bigint']);
        else if (typeof params['int'] != "undefined") this.setByInteger(params['int']);
        else if (typeof params == "number") this.setByInteger(params);
        else if (typeof params['hex'] != "undefined") this.setValueHex(params['hex']);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERInteger, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER encoded BitString primitive
 * @name KJUR.asn1.DERBitString
 * @class class for ASN.1 DER encoded BitString primitive
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>bin - specify binary string (ex. '10111')</li>
 * <li>array - specify array of boolean (ex. [true,false,true,true])</li>
 * <li>hex - specify hexadecimal string of ASN.1 value(V) including unused bits</li>
 * <li>obj - specify {@link KJUR.asn1.ASN1Util.newObject}
 * argument for "BitString encapsulates" structure.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: 'obj' parameter have been supported since
 * asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).<br/>
 * @example
 * // default constructor
 * o = new KJUR.asn1.DERBitString();
 * // initialize with binary string
 * o = new KJUR.asn1.DERBitString({bin: "1011"});
 * // initialize with boolean array
 * o = new KJUR.asn1.DERBitString({array: [true,false,true,true]});
 * // initialize with hexadecimal string (04 is unused bits)
 * o = new KJUR.asn1.DEROctetString({hex: "04bac0"});
 * // initialize with ASN1Util.newObject argument for encapsulated
 * o = new KJUR.asn1.DERBitString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // BIT STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBitString = function(params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.newObject(params.obj);
        params.hex = "00" + o.getEncodedHex();
    }
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBitString.superclass.constructor.call(this);
    this.hT = "03";
    /**
     * set ASN.1 value(V) by a hexadecimal string including unused bits
     * @name setHexValueIncludingUnusedBits
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} newHexStringIncludingUnusedBits
     */ this.setHexValueIncludingUnusedBits = function(newHexStringIncludingUnusedBits) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = newHexStringIncludingUnusedBits;
    };
    /**
     * set ASN.1 value(V) by unused bit and hexadecimal string of value
     * @name setUnusedBitsAndHexValue
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {Integer} unusedBits
     * @param {String} hValue
     */ this.setUnusedBitsAndHexValue = function(unusedBits, hValue) {
        if (unusedBits < 0 || 7 < unusedBits) throw "unused bits shall be from 0 to 7: u = " + unusedBits;
        var hUnusedBits = "0" + unusedBits;
        this.hTLV = null;
        this.isModified = true;
        this.hV = hUnusedBits + hValue;
    };
    /**
     * set ASN.1 DER BitString by binary string<br/>
     * @name setByBinaryString
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {String} binaryString binary value string (i.e. '10111')
     * @description
     * Its unused bits will be calculated automatically by length of
     * 'binaryValue'. <br/>
     * NOTE: Trailing zeros '0' will be ignored.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray("01011");
     */ this.setByBinaryString = function(binaryString) {
        binaryString = binaryString.replace(/0+$/, '');
        var unusedBits = 8 - binaryString.length % 8;
        if (unusedBits == 8) unusedBits = 0;
        for(var i = 0; i <= unusedBits; i++)binaryString += '0';
        var h = '';
        for(var i = 0; i < binaryString.length - 1; i += 8){
            var b = binaryString.substr(i, 8);
            var x = parseInt(b, 2).toString(16);
            if (x.length == 1) x = '0' + x;
            h += x;
        }
        this.hTLV = null;
        this.isModified = true;
        this.hV = '0' + unusedBits + h;
    };
    /**
     * set ASN.1 TLV value(V) by an array of boolean<br/>
     * @name setByBooleanArray
     * @memberOf KJUR.asn1.DERBitString#
     * @function
     * @param {array} booleanArray array of boolean (ex. [true, false, true])
     * @description
     * NOTE: Trailing falses will be ignored in the ASN.1 DER Object.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.setByBooleanArray([false, true, false, true, true]);
     */ this.setByBooleanArray = function(booleanArray) {
        var s = '';
        for(var i = 0; i < booleanArray.length; i++)if (booleanArray[i] == true) s += '1';
        else s += '0';
        this.setByBinaryString(s);
    };
    /**
     * generate an array of falses with specified length<br/>
     * @name newFalseArray
     * @memberOf KJUR.asn1.DERBitString
     * @function
     * @param {Integer} nLength length of array to generate
     * @return {array} array of boolean falses
     * @description
     * This static method may be useful to initialize boolean array.
     * @example
     * o = new KJUR.asn1.DERBitString();
     * o.newFalseArray(3) &rarr; [false, false, false]
     */ this.newFalseArray = function(nLength) {
        var a = new Array(nLength);
        for(var i = 0; i < nLength; i++)a[i] = false;
        return a;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params == "string" && params.toLowerCase().match(/^[0-9a-f]+$/)) this.setHexValueIncludingUnusedBits(params);
        else if (typeof params['hex'] != "undefined") this.setHexValueIncludingUnusedBits(params['hex']);
        else if (typeof params['bin'] != "undefined") this.setByBinaryString(params['bin']);
        else if (typeof params['array'] != "undefined") this.setByBooleanArray(params['array']);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERBitString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER OctetString<br/>
 * @name KJUR.asn1.DEROctetString
 * @class class for ASN.1 DER OctetString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * This class provides ASN.1 OctetString simple type.<br/>
 * Supported "params" attributes are:
 * <ul>
 * <li>str - to set a string as a value</li>
 * <li>hex - to set a hexadecimal string as a value</li>
 * <li>obj - to set a encapsulated ASN.1 value by JSON object
 * which is defined in {@link KJUR.asn1.ASN1Util.newObject}</li>
 * </ul>
 * NOTE: A parameter 'obj' have been supported
 * for "OCTET STRING, encapsulates" structure.
 * since asn1 1.0.11, jsrsasign 6.1.1 (2016-Sep-25).
 * @see KJUR.asn1.DERAbstractString - superclass
 * @example
 * // default constructor
 * o = new KJUR.asn1.DEROctetString();
 * // initialize with string
 * o = new KJUR.asn1.DEROctetString({str: "aaa"});
 * // initialize with hexadecimal string
 * o = new KJUR.asn1.DEROctetString({hex: "616161"});
 * // initialize with ASN1Util.newObject argument
 * o = new KJUR.asn1.DEROctetString({obj: {seq: [{int: 3}, {prnstr: 'aaa'}]}});
 * // above generates a ASN.1 data like this:
 * // OCTET STRING, encapsulates {
 * //   SEQUENCE {
 * //     INTEGER 3
 * //     PrintableString 'aaa'
 * //     }
 * //   }
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEROctetString = function(params) {
    if (params !== undefined && typeof params.obj !== "undefined") {
        var o = $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.newObject(params.obj);
        params.hex = o.getEncodedHex();
    }
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEROctetString.superclass.constructor.call(this, params);
    this.hT = "04";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEROctetString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER Null
 * @name KJUR.asn1.DERNull
 * @class class for ASN.1 DER Null
 * @extends KJUR.asn1.ASN1Object
 * @description
 * @see KJUR.asn1.ASN1Object - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNull = function() {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNull.superclass.constructor.call(this);
    this.hT = "05";
    this.hTLV = "0500";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNull, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER ObjectIdentifier
 * @name KJUR.asn1.DERObjectIdentifier
 * @class class for ASN.1 DER ObjectIdentifier
 * @param {Array} params associative array of parameters (ex. {'oid': '2.5.4.5'})
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>oid - specify initial ASN.1 value(V) by a oid string (ex. 2.5.4.13)</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERObjectIdentifier = function(params) {
    var itox = function itox(i) {
        var h = i.toString(16);
        if (h.length == 1) h = '0' + h;
        return h;
    };
    var roidtox = function roidtox(roid) {
        var h = '';
        var bi = new (0, $jeSh1.BigInteger)(roid, 10);
        var b = bi.toString(2);
        var padLen = 7 - b.length % 7;
        if (padLen == 7) padLen = 0;
        var bPad = '';
        for(var i = 0; i < padLen; i++)bPad += '0';
        b = bPad + b;
        for(var i = 0; i < b.length - 1; i += 7){
            var b8 = b.substr(i, 7);
            if (i != b.length - 7) b8 = '1' + b8;
            h += itox(parseInt(b8, 2));
        }
        return h;
    };
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERObjectIdentifier.superclass.constructor.call(this);
    this.hT = "06";
    /**
     * set value by a hexadecimal string
     * @name setValueHex
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} newHexString hexadecimal value of OID bytes
     */ this.setValueHex = function(newHexString) {
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = newHexString;
    };
    /**
     * set value by a OID string<br/>
     * @name setValueOidString
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidString OID string (ex. 2.5.4.13)
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueOidString("2.5.4.13");
     */ this.setValueOidString = function(oidString) {
        if (!oidString.match(/^[0-9.]+$/)) throw "malformed oid string: " + oidString;
        var h = '';
        var a = oidString.split('.');
        var i0 = parseInt(a[0]) * 40 + parseInt(a[1]);
        h += itox(i0);
        a.splice(0, 2);
        for(var i = 0; i < a.length; i++)h += roidtox(a[i]);
        this.hTLV = null;
        this.isModified = true;
        this.s = null;
        this.hV = h;
    };
    /**
     * set value by a OID name
     * @name setValueName
     * @memberOf KJUR.asn1.DERObjectIdentifier#
     * @function
     * @param {String} oidName OID name (ex. 'serverAuth')
     * @since 1.0.1
     * @description
     * OID name shall be defined in 'KJUR.asn1.x509.OID.name2oidList'.
     * Otherwise raise error.
     * @example
     * o = new KJUR.asn1.DERObjectIdentifier();
     * o.setValueName("serverAuth");
     */ this.setValueName = function(oidName) {
        var oid = $2387d48cc83047d7$export$eeb0cac846251be6.asn1.x509.OID.name2oid(oidName);
        if (oid !== '') this.setValueOidString(oid);
        else throw "DERObjectIdentifier oidName undefined: " + oidName;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (params !== undefined) {
        if (typeof params === "string") {
            if (params.match(/^[0-2].[0-9.]+$/)) this.setValueOidString(params);
            else this.setValueName(params);
        } else if (params.oid !== undefined) this.setValueOidString(params.oid);
        else if (params.hex !== undefined) this.setValueHex(params.hex);
        else if (params.name !== undefined) this.setValueName(params.name);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERObjectIdentifier, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER Enumerated
 * @name KJUR.asn1.DEREnumerated
 * @class class for ASN.1 DER Enumerated
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>int - specify initial ASN.1 value(V) by integer value</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * @example
 * new KJUR.asn1.DEREnumerated(123);
 * new KJUR.asn1.DEREnumerated({int: 123});
 * new KJUR.asn1.DEREnumerated({hex: '1fad'});
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEREnumerated = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEREnumerated.superclass.constructor.call(this);
    this.hT = "0a";
    /**
     * set value by Tom Wu's BigInteger object
     * @name setByBigInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {BigInteger} bigIntegerValue to set
     */ this.setByBigInteger = function(bigIntegerValue) {
        this.hTLV = null;
        this.isModified = true;
        this.hV = $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Util.bigIntToMinTwosComplementsHex(bigIntegerValue);
    };
    /**
     * set value by integer value
     * @name setByInteger
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {Integer} integer value to set
     */ this.setByInteger = function(intValue) {
        var bi = new (0, $jeSh1.BigInteger)(String(intValue), 10);
        this.setByBigInteger(bi);
    };
    /**
     * set value by integer value
     * @name setValueHex
     * @memberOf KJUR.asn1.DEREnumerated#
     * @function
     * @param {String} hexadecimal string of integer value
     * @description
     * <br/>
     * NOTE: Value shall be represented by minimum octet length of
     * two's complement representation.
     */ this.setValueHex = function(newHexString) {
        this.hV = newHexString;
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['int'] != "undefined") this.setByInteger(params['int']);
        else if (typeof params == "number") this.setByInteger(params);
        else if (typeof params['hex'] != "undefined") this.setValueHex(params['hex']);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DEREnumerated, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);
// ********************************************************************
/**
 * class for ASN.1 DER UTF8String
 * @name KJUR.asn1.DERUTF8String
 * @class class for ASN.1 DER UTF8String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTF8String = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTF8String.superclass.constructor.call(this, params);
    this.hT = "0c";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTF8String, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER NumericString
 * @name KJUR.asn1.DERNumericString
 * @class class for ASN.1 DER NumericString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNumericString = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNumericString.superclass.constructor.call(this, params);
    this.hT = "12";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERNumericString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER PrintableString
 * @name KJUR.asn1.DERPrintableString
 * @class class for ASN.1 DER PrintableString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERPrintableString = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERPrintableString.superclass.constructor.call(this, params);
    this.hT = "13";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERPrintableString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER TeletexString
 * @name KJUR.asn1.DERTeletexString
 * @class class for ASN.1 DER TeletexString
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTeletexString = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTeletexString.superclass.constructor.call(this, params);
    this.hT = "14";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTeletexString, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER IA5String
 * @name KJUR.asn1.DERIA5String
 * @class class for ASN.1 DER IA5String
 * @param {Array} params associative array of parameters (ex. {'str': 'aaa'})
 * @extends KJUR.asn1.DERAbstractString
 * @description
 * @see KJUR.asn1.DERAbstractString - superclass
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERIA5String = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERIA5String.superclass.constructor.call(this, params);
    this.hT = "16";
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERIA5String, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractString);
// ********************************************************************
/**
 * class for ASN.1 DER UTCTime
 * @name KJUR.asn1.DERUTCTime
 * @class class for ASN.1 DER UTCTime
 * @param {Array} params associative array of parameters (ex. {'str': '130430235959Z'})
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 * <h4>EXAMPLES</h4>
 * @example
 * d1 = new KJUR.asn1.DERUTCTime();
 * d1.setString('130430125959Z');
 *
 * d2 = new KJUR.asn1.DERUTCTime({'str': '130430125959Z'});
 * d3 = new KJUR.asn1.DERUTCTime({'date': new Date(Date.UTC(2015, 0, 31, 0, 0, 0, 0))});
 * d4 = new KJUR.asn1.DERUTCTime('130430125959Z');
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTCTime = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTCTime.superclass.constructor.call(this, params);
    this.hT = "17";
    /**
     * set value by a Date object<br/>
     * @name setByDate
     * @memberOf KJUR.asn1.DERUTCTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * o = new KJUR.asn1.DERUTCTime();
     * o.setByDate(new Date("2016/12/31"));
     */ this.setByDate = function(dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'utc');
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function() {
        if (typeof this.date == "undefined" && typeof this.s == "undefined") {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'utc');
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) this.setString(params.str);
        else if (typeof params == "string" && params.match(/^[0-9]{12}Z$/)) this.setString(params);
        else if (params.hex !== undefined) this.setStringHex(params.hex);
        else if (params.date !== undefined) this.setByDate(params.date);
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERUTCTime, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER GeneralizedTime
 * @name KJUR.asn1.DERGeneralizedTime
 * @class class for ASN.1 DER GeneralizedTime
 * @param {Array} params associative array of parameters (ex. {'str': '20130430235959Z'})
 * @property {Boolean} withMillis flag to show milliseconds or not
 * @extends KJUR.asn1.DERAbstractTime
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>str - specify initial ASN.1 value(V) by a string (ex.'20130430235959Z')</li>
 * <li>hex - specify initial ASN.1 value(V) by a hexadecimal string</li>
 * <li>date - specify Date object.</li>
 * <li>millis - specify flag to show milliseconds (from 1.0.6)</li>
 * </ul>
 * NOTE1: 'params' can be omitted.
 * NOTE2: 'withMillis' property is supported from asn1 1.0.6.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERGeneralizedTime = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERGeneralizedTime.superclass.constructor.call(this, params);
    this.hT = "18";
    this.withMillis = false;
    /**
     * set value by a Date object
     * @name setByDate
     * @memberOf KJUR.asn1.DERGeneralizedTime#
     * @function
     * @param {Date} dateObject Date object to set ASN.1 value(V)
     * @example
     * When you specify UTC time, use 'Date.UTC' method like this:<br/>
     * o1 = new DERUTCTime();
     * o1.setByDate(date);
     *
     * date = new Date(Date.UTC(2015, 0, 31, 23, 59, 59, 0)); #2015JAN31 23:59:59
     */ this.setByDate = function(dateObject) {
        this.hTLV = null;
        this.isModified = true;
        this.date = dateObject;
        this.s = this.formatDate(this.date, 'gen', this.withMillis);
        this.hV = stohex(this.s);
    };
    this.getFreshValueHex = function() {
        if (this.date === undefined && this.s === undefined) {
            this.date = new Date();
            this.s = this.formatDate(this.date, 'gen', this.withMillis);
            this.hV = stohex(this.s);
        }
        return this.hV;
    };
    if (params !== undefined) {
        if (params.str !== undefined) this.setString(params.str);
        else if (typeof params == "string" && params.match(/^[0-9]{14}Z$/)) this.setString(params);
        else if (params.hex !== undefined) this.setStringHex(params.hex);
        else if (params.date !== undefined) this.setByDate(params.date);
        if (params.millis === true) this.withMillis = true;
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERGeneralizedTime, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractTime);
// ********************************************************************
/**
 * class for ASN.1 DER Sequence
 * @name KJUR.asn1.DERSequence
 * @class class for ASN.1 DER Sequence
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * </ul>
 * NOTE: 'params' can be omitted.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSequence = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSequence.superclass.constructor.call(this, params);
    this.hT = "30";
    this.getFreshValueHex = function() {
        var h = '';
        for(var i = 0; i < this.asn1Array.length; i++){
            var asn1Obj = this.asn1Array[i];
            h += asn1Obj.getEncodedHex();
        }
        this.hV = h;
        return this.hV;
    };
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSequence, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER Set
 * @name KJUR.asn1.DERSet
 * @class class for ASN.1 DER Set
 * @extends KJUR.asn1.DERAbstractStructured
 * @description
 * <br/>
 * As for argument 'params' for constructor, you can specify one of
 * following properties:
 * <ul>
 * <li>array - specify array of ASN1Object to set elements of content</li>
 * <li>sortflag - flag for sort (default: true). ASN.1 BER is not sorted in 'SET OF'.</li>
 * </ul>
 * NOTE1: 'params' can be omitted.<br/>
 * NOTE2: sortflag is supported since 1.0.5.
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSet = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSet.superclass.constructor.call(this, params);
    this.hT = "31";
    this.sortFlag = true; // item shall be sorted only in ASN.1 DER
    this.getFreshValueHex = function() {
        var a = new Array();
        for(var i = 0; i < this.asn1Array.length; i++){
            var asn1Obj = this.asn1Array[i];
            a.push(asn1Obj.getEncodedHex());
        }
        if (this.sortFlag == true) a.sort();
        this.hV = a.join('');
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params.sortflag != "undefined" && params.sortflag == false) this.sortFlag = false;
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERSet, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERAbstractStructured);
// ********************************************************************
/**
 * class for ASN.1 DER TaggedObject
 * @name KJUR.asn1.DERTaggedObject
 * @class class for ASN.1 DER TaggedObject
 * @extends KJUR.asn1.ASN1Object
 * @description
 * <br/>
 * Parameter 'tagNoNex' is ASN.1 tag(T) value for this object.
 * For example, if you find '[1]' tag in a ASN.1 dump,
 * 'tagNoHex' will be 'a1'.
 * <br/>
 * As for optional argument 'params' for constructor, you can specify *ANY* of
 * following properties:
 * <ul>
 * <li>explicit - specify true if this is explicit tag otherwise false
 *     (default is 'true').</li>
 * <li>tag - specify tag (default is 'a0' which means [0])</li>
 * <li>obj - specify ASN1Object which is tagged</li>
 * </ul>
 * @example
 * d1 = new KJUR.asn1.DERUTF8String({'str':'a'});
 * d2 = new KJUR.asn1.DERTaggedObject({'obj': d1});
 * hex = d2.getEncodedHex();
 */ $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTaggedObject = function(params) {
    $2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTaggedObject.superclass.constructor.call(this);
    this.hT = "a0";
    this.hV = '';
    this.isExplicit = true;
    this.asn1Object = null;
    /**
     * set value by an ASN1Object
     * @name setString
     * @memberOf KJUR.asn1.DERTaggedObject#
     * @function
     * @param {Boolean} isExplicitFlag flag for explicit/implicit tag
     * @param {Integer} tagNoHex hexadecimal string of ASN.1 tag
     * @param {ASN1Object} asn1Object ASN.1 to encapsulate
     */ this.setASN1Object = function(isExplicitFlag, tagNoHex, asn1Object) {
        this.hT = tagNoHex;
        this.isExplicit = isExplicitFlag;
        this.asn1Object = asn1Object;
        if (this.isExplicit) {
            this.hV = this.asn1Object.getEncodedHex();
            this.hTLV = null;
            this.isModified = true;
        } else {
            this.hV = null;
            this.hTLV = asn1Object.getEncodedHex();
            this.hTLV = this.hTLV.replace(/^../, tagNoHex);
            this.isModified = false;
        }
    };
    this.getFreshValueHex = function() {
        return this.hV;
    };
    if (typeof params != "undefined") {
        if (typeof params['tag'] != "undefined") this.hT = params['tag'];
        if (typeof params['explicit'] != "undefined") this.isExplicit = params['explicit'];
        if (typeof params['obj'] != "undefined") {
            this.asn1Object = params['obj'];
            this.setASN1Object(this.isExplicit, this.hT, this.asn1Object);
        }
    }
};
(0, $16Yry.YAHOO).lang.extend($2387d48cc83047d7$export$eeb0cac846251be6.asn1.DERTaggedObject, $2387d48cc83047d7$export$eeb0cac846251be6.asn1.ASN1Object);

});
parcelRegister("16Yry", function(module, exports) {

$parcel$export(module.exports, "YAHOO", function () { return $0cf53ccbcef982a0$export$a3382d618f21a4f6; });
/*!
Copyright (c) 2011, Yahoo! Inc. All rights reserved.
Code licensed under the BSD License:
http://developer.yahoo.com/yui/license.html
version: 2.9.0
*/ var $0cf53ccbcef982a0$export$a3382d618f21a4f6 = {};
$0cf53ccbcef982a0$export$a3382d618f21a4f6.lang = {
    /**
     * Utility to set up the prototype, constructor and superclass properties to
     * support an inheritance strategy that can chain constructors and methods.
     * Static members will not be inherited.
     *
     * @method extend
     * @static
     * @param {Function} subc   the object to modify
     * @param {Function} superc the object to inherit
     * @param {Object} overrides  additional properties/methods to add to the
     *                              subclass prototype.  These will override the
     *                              matching items obtained from the superclass
     *                              if present.
     */ extend: function extend(subc, superc, overrides) {
        if (!superc || !subc) throw new Error("YAHOO.lang.extend failed, please check that all dependencies are included.");
        var F = function F() {};
        F.prototype = superc.prototype;
        subc.prototype = new F();
        subc.prototype.constructor = subc;
        subc.superclass = superc.prototype;
        if (superc.prototype.constructor == Object.prototype.constructor) superc.prototype.constructor = superc;
        if (overrides) {
            var i;
            for(i in overrides)subc.prototype[i] = overrides[i];
            /*
             * IE will not enumerate native functions in a derived object even if the
             * function was overridden.  This is a workaround for specific functions
             * we care about on the Object prototype.
             * @property _IEEnumFix
             * @param {Function} r  the object to receive the augmentation
             * @param {Function} s  the object that supplies the properties to augment
             * @static
             * @private
             */ var _IEEnumFix = function _IEEnumFix() {}, ADD = [
                "toString",
                "valueOf"
            ];
            try {
                if (/MSIE/.test(navigator.userAgent)) _IEEnumFix = function _IEEnumFix(r, s) {
                    for(i = 0; i < ADD.length; i = i + 1){
                        var fname = ADD[i], f = s[fname];
                        if (typeof f === 'function' && f != Object.prototype[fname]) r[fname] = f;
                    }
                };
            } catch (ex) {}
            _IEEnumFix(subc.prototype, overrides);
        }
    }
};

});






})();
//# sourceMappingURL=userActions.b08792d4.js.map
